var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewayExtraBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Sat Feb  6 03:06:42 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2013, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-ExtraBold",
    horizAdvX: 670
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway ExtraBold",
    fontWeight: 800,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 9 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 525,
    capHeight: 710,
    bbox: "-196 -231 1307 920",
    underlineThickness: 50,
    underlinePosition: -150,
    unicodeRange: "U+0020-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 665,
    d: "M587 605q-33 0 -48 -21t-15 -53v-49h127v-121h-127v-361h-160v361h-115v-361h-160v361h-67v121h67v17q0 45 13 83t37 65t58.5 42.5t78.5 15.5q32 0 66 -7.5t69 -21.5q24 29 59.5 46.5t83.5 17.5q35 0 68 -9t65 -22l-29 -120q-15 6 -33.5 11t-37.5 5zM364 482v14t0.5 24 t1.5 24.5t2 13.5q-14 6 -30 9t-29 3q-32 0 -46 -18t-14 -48v-22h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 593,
    d: "M89 361h-67v121h67v43q0 46 16 85.5t45.5 68.5t71.5 45t93 16q57 0 107.5 -19t102.5 -53l-62 -121q-30 26 -66.5 42t-71.5 16q-38 0 -57 -21t-19 -53v-49h290v-482h-160v361h-130v-361h-160v361z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 685,
    d: "M687 20q-1 -1 -13.5 -5.5t-32 -9.5t-44 -9t-48.5 -4q-34 0 -61 9.5t-46 25.5t-29 37.5t-10 45.5v387q0 49 -14 78.5t-60 29.5q-44 0 -61.5 -28t-18.5 -72v-23h79v-121h-79v-361h-160v361h-67v121h67v58q0 50 16.5 87.5t47 62.5t74 37.5t96.5 12.5q62 0 107.5 -15t75 -43 t43.5 -67t14 -87v-336q0 -19 10.5 -38.5t35.5 -19.5q9 0 18.5 2.5t18 5t14.5 5t7 2.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 868,
    d: "M89 361h-67v121h67v17q0 44 13 82t37 65.5t58.5 43t78.5 15.5q32 0 66 -7.5t69 -21.5q29 29 73.5 46.5t102.5 17.5q51 0 104 -18.5t109 -53.5l-62 -121q-29 26 -65.5 42t-68.5 16q-42 0 -61 -21t-19 -53v-49h290v-482h-161v361h-129v-361h-160v361h-115v-361h-160v361z M364 482v14t0.5 24t1.5 24.5t2 13.5q-14 6 -30 9t-29 3q-32 0 -46 -18.5t-14 -47.5v-22h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 960,
    d: "M824 -8q-35 0 -62 9.5t-45.5 25.5t-28.5 37.5t-10 45.5v394q0 21 -3 39.5t-11.5 32t-24 21.5t-39.5 8q-21 0 -35.5 -8t-23.5 -22t-13 -32.5t-4 -39.5v-21h79v-121h-79v-361h-160v361h-115v-361h-160v361h-67v121h67v17q0 45 13 83t37.5 65t59 42.5t76.5 15.5 q35 0 68 -7.5t68 -21.5q31 32 78.5 48t108.5 16q124 0 182 -58t58 -154v-336q0 -9 2.5 -19.5t8 -19t14 -14t21.5 -5.5q8 0 18 2.5t18 5t14 5t7 2.5l21 -129q-1 -1 -13.5 -5.5t-32 -9.5t-44 -9t-48.5 -4zM364 482v14.5t0.5 24.5t1 24.5t1.5 13.5q-14 6 -29 8.5t-28 2.5 q-31 0 -46 -18t-15 -47v-23h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 333,
    d: "M86 282v435h160v-435h-160zM86 0v166h160v-166h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 431,
    d: "M57 498v228h135v-228h-135zM239 498v228h135v-228h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 738,
    d: "M702 412h-152l-27 -114h130v-119h-159l-43 -179h-128l44 179h-91l-44 -179h-128l45 179h-113v119h141l27 114h-119v110h146l46 188h128l-47 -188h92l46 188h128l-47 -188h125v-110zM396 298l27 114h-92l-27 -114h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 641,
    d: "M509 502q-3 4 -17.5 13t-37 19.5t-50 20t-55.5 13.5v-136l32 -8q51 -14 92 -30.5t69.5 -41t44 -59.5t15.5 -84q0 -57 -20 -97t-53.5 -65.5t-77 -38.5t-91.5 -15v-116h-69v117q-69 6 -136.5 28t-121.5 58l72 143q4 -5 21.5 -16.5t44.5 -24t61 -24t70 -16.5v133l-48 14 q-49 15 -85 32.5t-59.5 40.5t-35 53t-11.5 70q0 52 18 92.5t48.5 69.5t72 45.5t89.5 21.5v101h69v-101q65 -6 122 -29t99 -47zM426 193q0 26 -21 40.5t-56 26.5v-120q77 3 77 53zM232 511q0 -25 17.5 -39.5t52.5 -25.5v123q-70 -6 -70 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 816,
    d: "M205 411q-36 0 -67 12t-54 33t-36.5 49.5t-13.5 60.5t13.5 60t36.5 49t54 33t67 12t67 -12t54.5 -33t36.5 -49t13 -60t-13 -60.5t-36.5 -49.5t-54.5 -33t-67 -12zM205 489q25 0 42.5 22.5t17.5 54.5t-17.5 54t-42.5 22t-42.5 -22.5t-17.5 -53.5q0 -32 17.5 -54.5 t42.5 -22.5zM611 -10q-36 0 -67 12t-54 33t-36.5 49t-13.5 60t13.5 60.5t36.5 49.5t54 33t67 12t67 -12t54.5 -33t36.5 -49.5t13 -60.5t-13 -60t-36.5 -49t-54.5 -33t-67 -12zM611 68q25 0 43 22.5t18 53.5q0 32 -18 54.5t-43 22.5t-42.5 -22.5t-17.5 -54.5t17.5 -54 t42.5 -22zM103 56l282 324l256 339l72 -64l-273 -316l-266 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 729,
    d: "M522 0l-47 50q-44 -30 -93 -45t-100 -15q-58 0 -103.5 18.5t-76.5 49t-47.5 69.5t-16.5 81q0 32 9 59.5t24.5 50.5t35.5 43t42 37q-36 44 -51 75.5t-15 69.5q0 41 15 73.5t42 55.5t63.5 35t79.5 12q38 0 74 -9.5t63.5 -30t44.5 -51t17 -72.5q0 -57 -30 -100.5t-78 -79.5 l111 -118q13 30 20.5 65.5t7.5 77.5h129q-1 -74 -17.5 -133.5t-45.5 -107.5l153 -160h-210zM299 115q47 0 89 27l-141 150q-26 -20 -41 -40.5t-15 -44.5q0 -16 7 -32.5t21 -29.5t34 -21.5t46 -8.5zM228 549q0 -16 10 -29.5t36 -39.5q31 20 46 36t15 38t-14.5 35t-37.5 13 q-25 0 -40 -15t-15 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 250,
    d: "M57 497v229h135v-229h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 325,
    d: "M30 347q0 51 12 102t32.5 103t48 105t59.5 107l122 -50q-14 -22 -35 -62.5t-41 -91.5t-34.5 -107t-14.5 -109q0 -81 34 -166.5t87 -179.5l-116 -57q-31 46 -59 96t-49 101.5t-33.5 104t-12.5 104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 324,
    d: "M294 347q0 -52 -12.5 -104.5t-33.5 -104t-49 -101.5t-59 -96l-116 57q53 94 87 179.5t34 166.5q0 53 -14.5 109t-34.5 107t-41 91.5t-35 62.5l122 50q32 -54 59.5 -107t48 -105t32.5 -103t12 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 354,
    d: "M71 510l47 75l-71 21l21 67l73 -34l-6 80h83l-6 -80l74 34l21 -67l-71 -21l47 -75l-59 -39l-47 79l-47 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 424,
    d: "M379 419v-128h-95v-104h-144v104h-94v128h94v104h144v-104h95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 243,
    d: "M72 -135l31 137h-49v161h135v-161l-47 -137h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 416,
    d: "M54 203v144h308v-144h-308z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 239,
    d: "M54 0v163h131v-163h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 735,
    d: "M708 710l-505 -710h-177l505 710h177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 614,
    d: "M568 293q0 -66 -20 -121.5t-55 -96t-82.5 -63t-103.5 -22.5t-104 22.5t-83 63t-54.5 96t-19.5 121.5t19.5 121.5t54.5 96t83 63.5t104 23t103.5 -23t82.5 -63.5t55 -96t20 -121.5zM407 293q0 70 -28 113.5t-72 43.5q-46 0 -73.5 -43.5t-27.5 -113.5t27.5 -113t73.5 -43 q44 0 72 43t28 113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 518,
    d: "M494 144v-144h-432v144h142v255q-9 -12 -28 -24.5t-42.5 -23t-48 -17t-43.5 -6.5v148q16 0 41.5 11t50.5 26.5t45 31.5t25 26h163v-427h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 580,
    d: "M39 0q0 47 7 84t24 67.5t46 56.5t73 51q47 26 78.5 43t50 30t26.5 23.5t8 24.5q0 28 -20 45t-57 17q-42 0 -73 -20.5t-60 -53.5l-102 118q16 18 43 35t61 30.5t74.5 21.5t84.5 8q108 0 165.5 -47t57.5 -127q0 -33 -10.5 -59t-27.5 -46.5t-38 -36t-43 -28.5 q-15 -9 -36 -21t-41.5 -24.5t-38 -25t-26.5 -22.5h272v-144h-498z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 569,
    d: "M393 237q31 -6 57 -21.5t44.5 -39t28.5 -54t10 -65.5q0 -47 -19 -84.5t-54.5 -64t-85.5 -41t-112 -14.5q-152 0 -238 89l86 114q27 -28 61.5 -42.5t82.5 -14.5q113 0 113 83q0 45 -33.5 68t-105.5 23h-30v115h33q56 0 87.5 23t31.5 61q0 33 -23 50t-61 17 q-41 0 -74.5 -19.5t-56.5 -55.5l-101 116q16 21 42 39t59 30.5t71 19.5t78 7q53 0 97 -12.5t75 -36t48 -56t17 -72.5q0 -30 -9.5 -57t-26.5 -49t-40.5 -36.5t-51.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 578,
    d: "M293 -127v137h-275v143l326 418h109v-417h88v-144h-88v-137h-160zM176 154h136v177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 558,
    d: "M294 322q51 0 94 -17t74.5 -47t49 -72t17.5 -93q0 -54 -20 -98.5t-55.5 -76.5t-84.5 -49.5t-108 -17.5q-78 0 -140 31t-94 87l89 99q29 -35 67.5 -56t78.5 -21q47 0 75 27t28 72q0 43 -26 69t-68 26q-27 0 -50 -12t-37 -34h-139q0 1 4 20.5t9.5 50.5t13 69.5t15.5 78.5 q18 94 41 213h353v-146h-237l-20 -121q6 7 23.5 12.5t46.5 5.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 608,
    d: "M569 239q0 -52 -20 -97.5t-55 -79t-83 -53t-104 -19.5q-62 0 -111 23t-83 66t-52 105.5t-18 142.5q0 93 19.5 165.5t55.5 122t88 75.5t117 26q66 0 122.5 -27t99.5 -78l-90 -102q-25 32 -60 50t-75 18q-59 0 -93.5 -42t-36.5 -119q20 27 53.5 42t77.5 15q53 0 98.5 -18 t78.5 -49.5t52 -74t19 -92.5zM307 125q22 0 42 9t35 24.5t24 36.5t9 44q0 22 -9 42t-24 34.5t-35 23t-42 8.5q-23 0 -43 -8.5t-35 -23t-23.5 -34.5t-8.5 -42q0 -23 9 -44t24 -36.5t35 -24.5t42 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 576,
    d: "M328 438h-299v146h551l-350 -710h-181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 607,
    d: "M566 215q0 -51 -21 -92t-56.5 -70.5t-83.5 -45.5t-102 -16q-53 0 -100.5 16.5t-83.5 46.5t-57 72.5t-21 94.5q0 28 9 52.5t23 44.5t32 35t35 26q-33 18 -55.5 53t-22.5 74q0 49 22.5 87.5t57.5 64t77.5 39t83.5 13.5t84 -13t78.5 -38.5t58 -63.5t22.5 -87q0 -20 -6.5 -39 t-17 -36.5t-25.5 -31t-31 -22.5q18 -11 36 -27t32.5 -36.5t23 -45.5t8.5 -55zM404 225q0 21 -8.5 37.5t-22.5 27.5t-32 17t-38 6q-42 0 -71 -24t-29 -65q0 -20 8.5 -36t22.5 -27.5t32 -18t38 -6.5t38.5 6.5t32 18.5t21.5 28.5t8 35.5zM224 503q0 -18 7 -31t18.5 -21.5 t25.5 -13t28 -4.5t28.5 4.5t26 13.5t18.5 22t7 30q0 29 -23.5 47.5t-56.5 18.5t-56 -18.5t-23 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 589,
    d: "M30 322q0 52 20 97.5t55 79t83 53t104 19.5q62 0 111 -23t83 -66t52 -106t18 -142q0 -93 -19.5 -165.5t-55.5 -122t-88 -75.5t-117 -26q-66 0 -122.5 27t-99.5 78l90 102q25 -32 60 -50t74 -18q59 0 93.5 42t36.5 119q-20 -27 -53 -42t-77 -15q-53 0 -98.5 18t-78.5 49.5 t-52 74t-19 92.5zM292 436q-22 0 -42 -9t-35 -24.5t-24 -36.5t-9 -44t8.5 -42.5t23.5 -34t35 -23t43 -8.5q22 0 42 8.5t35 23t24 34t9 42.5t-9 44t-24 36.5t-35 24.5t-42 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 274,
    d: "M72 356v163h130v-163h-130zM72 0v163h130v-163h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 280,
    d: "M74 356v163h130v-163h-130zM90 -135l32 137h-49v161h135v-161l-47 -137h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 518,
    d: "M32 293l422 256v-170l-190 -120l190 -113v-179l-422 250v76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 435,
    d: "M59 124v102h317v-102h-317zM59 326v102h317v-102h-317z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 518,
    d: "M486 217l-423 -250v179l191 113l-191 120v170l423 -256v-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 490,
    d: "M109 245q0 23 3 44t11.5 40.5t24.5 36.5t42 31q13 7 34.5 18.5t42 26.5t35.5 34.5t15 43.5q0 33 -24 51.5t-55 18.5q-20 0 -35.5 -7.5t-28 -18t-21.5 -23.5t-16 -23l-103 72q26 61 82.5 95t127.5 34q38 0 76 -11t68 -35t49 -62t19 -92q0 -57 -23.5 -95.5t-69.5 -67.5 q-21 -14 -42.5 -25t-39.5 -23t-29 -27t-11 -36h-132zM112 0v150h131v-150h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 848,
    d: "M423 603q74 0 142 -23.5t120.5 -71t84 -119.5t31.5 -168q0 -14 -1.5 -37t-6.5 -49t-15 -53t-27.5 -49t-44 -35.5t-63.5 -13.5q-27 0 -45.5 7.5t-29.5 18.5t-16.5 25t-7.5 27q-32 -32 -76.5 -49t-93.5 -17q-75 0 -114.5 39.5t-39.5 102.5q0 42 16.5 71t42.5 46.5t59.5 25 t68.5 7.5q39 0 66.5 -7.5t41.5 -13.5q0 24 -5 44t-17.5 34t-34 22t-54.5 8q-42 0 -74.5 -11.5t-55.5 -31.5l-28 83q74 50 174 50q68 0 106 -20.5t56.5 -51.5t22.5 -68.5t4 -70.5v-82q0 -22 1 -43.5t6 -38t15 -27t27 -10.5q25 0 41 19.5t24 47t11 57t3 48.5q0 68 -22.5 126 t-64.5 100.5t-101 66.5t-131 24q-71 0 -129 -23.5t-99 -65t-63.5 -99t-22.5 -125.5q0 -65 21 -122t60 -100t94.5 -67.5t125.5 -24.5q50 0 84.5 11t72.5 27l18 -59q-42 -20 -87 -30t-90 -10q-75 0 -141 27t-115.5 76t-78 118.5t-28.5 155.5q0 90 31.5 159.5t84.5 116.5 t122 71.5t145 24.5zM468 93q21 10 33.5 26t12.5 36v40q-14 5 -43.5 12t-62.5 7q-45 0 -69.5 -17.5t-24.5 -56.5q0 -32 18 -49t53 -17q17 0 40.5 4.5t42.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    d: "M261 710h148l259 -710h-168l-55 159h-221l-54 -159h-168zM418 272l-83 251l-85 -251h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 684,
    d: "M655 182q0 -46 -19 -80t-52 -56.5t-77 -34t-93 -11.5h-346v710h395q37 0 67 -16t51 -41.5t32.5 -58t11.5 -66.5q0 -51 -25.5 -96t-76.5 -68q61 -18 96.5 -64t35.5 -118zM488 215q0 33 -19 56t-48 23h-189v-155h182q32 0 53 21t21 55zM232 570v-147h161q27 0 48 18t21 56 q0 35 -18.5 54t-44.5 19h-167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 688,
    d: "M27 361q0 64 24 127.5t70 113.5t112 81t150 31q100 0 173.5 -43t109.5 -112l-126 -88q-12 28 -30.5 46.5t-40.5 30t-45 16t-45 4.5q-47 0 -82 -19t-58 -49t-34 -68t-11 -77q0 -42 13 -81t37.5 -69t59 -47.5t77.5 -17.5q22 0 45.5 5.5t45 17t39.5 30t29 45.5l134 -79 q-16 -39 -47.5 -70t-72.5 -52t-87 -32t-90 -11q-77 0 -141.5 31.5t-111 83.5t-72 118t-25.5 134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 716,
    d: "M68 0v710h265q88 0 154 -28t110.5 -76t67 -112.5t22.5 -137.5q0 -81 -25 -146.5t-71.5 -112t-112 -72t-145.5 -25.5h-265zM520 356q0 47 -12.5 85.5t-36.5 66.5t-59 43t-79 15h-101v-422h101q45 0 80 16t58.5 44.5t36 67t12.5 84.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 599,
    d: "M567 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 569,
    d: "M68 0v710h482v-144h-318v-153h262v-133h-262v-280h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 732,
    d: "M556 70q-81 -75 -187 -75q-70 0 -132 26.5t-108.5 74.5t-73.5 115.5t-27 148.5q0 73 27 138t74.5 113t112.5 76t140 28q99 0 173 -41.5t111 -113.5l-122 -92q-24 48 -69.5 74.5t-98.5 26.5q-41 0 -74.5 -16.5t-57.5 -46t-37 -68.5t-13 -84q0 -46 14 -85t39 -67.5 t59.5 -44.5t76.5 -16q96 0 173 89v22h-138v119h274v-371h-136v70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 747,
    d: "M679 710v-710h-164v291h-283v-291h-164v710h164v-275h283v275h164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 300,
    d: "M68 0v710h164v-710h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 494,
    d: "M40 167q10 -8 42.5 -20t75.5 -12q37 0 59 12.5t34 38.5t15.5 66.5t3.5 96.5v361h164v-361q0 -81 -8.5 -147.5t-37 -113.5t-83.5 -73t-147 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 679,
    d: "M68 0v710h164v-306l260 306h184l-266 -317l284 -393h-187l-201 286l-74 -77v-209h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 585,
    d: "M68 0v710h164v-566h344v-144h-508z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 860,
    d: "M628 0v425l-154 -309h-88l-154 309v-425h-164v710h178l184 -371l185 371h177v-710h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 759,
    d: "M232 406v-406h-164v710h128l331 -417v417h164v-710h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 760,
    d: "M379 -6q-79 0 -144 31t-111 81.5t-71.5 115.5t-25.5 134q0 70 26.5 135t74 114.5t112.5 79t142 29.5q79 0 144 -31t111 -82t71 -116t25 -132q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30zM194 354q0 -41 12 -79.5t35.5 -68.5t58.5 -48t80 -18q47 0 82 19t58 49.5 t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 623,
    d: "M68 0v710h303q51 0 93.5 -21t73 -55t48 -77t17.5 -87q0 -47 -16.5 -90t-46 -77t-71.5 -54t-93 -20h-144v-229h-164zM232 372h134q29 0 50 25t21 73q0 25 -6.5 43t-17.5 30t-25 17.5t-28 5.5h-128v-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 759,
    d: "M552 40q-38 -21 -81.5 -33t-91.5 -12q-79 0 -144 30.5t-111 81t-71.5 115.5t-25.5 134q0 70 26.5 135t74 115t112.5 79.5t142 29.5q79 0 144 -31.5t111 -82.5t71 -116t25 -132q0 -68 -24 -130t-68 -111l102 -112h-154zM380 141q40 0 70 13l-114 126h154l44 -49 q16 28 24 60t8 65q0 41 -12 79.5t-36 68t-58.5 47.5t-79.5 18q-47 0 -81.5 -18.5t-58 -49t-35 -69t-11.5 -78.5q0 -41 12 -79.5t35.5 -68t58.5 -47.5t80 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    d: "M68 0v710h320q50 0 92.5 -21t73.5 -55t48.5 -77t17.5 -87q0 -33 -8 -63.5t-23 -57.5t-36.5 -48.5t-48.5 -36.5l156 -264h-185l-136 229h-107v-229h-164zM232 372h150q29 0 50 27.5t21 70.5q0 44 -24 70t-52 26h-145v-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 615,
    d: "M494 502q-3 4 -21 15t-45 23t-59 21t-64 9q-88 0 -88 -59q0 -18 9.5 -30t28 -21.5t46.5 -17.5t65 -18q51 -14 92 -30.5t69.5 -41t44 -59.5t15.5 -84q0 -60 -22.5 -101.5t-59.5 -67t-85 -37t-99 -11.5q-39 0 -80 6t-80 17.5t-75.5 27.5t-67.5 37l72 143q4 -5 26 -19 t54.5 -28t72.5 -25t81 -11q87 0 87 53q0 20 -13 33t-36 23.5t-54.5 19.5t-68.5 20q-49 15 -85 32.5t-59.5 40.5t-35 53t-11.5 70q0 56 21 99t57 72.5t83.5 44.5t100.5 15q37 0 73 -7t69 -18t61.5 -25t52.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 621,
    d: "M609 566h-216v-566h-164v566h-217v144h597v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 747,
    d: "M373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5v363h164v-363q0 -74 -18.5 -138t-57 -112t-98 -75.5t-141.5 -27.5q-85 0 -145 29t-97.5 77.5t-55 112.5t-17.5 134v363h164v-363q0 -41 8 -78t26 -66t46.5 -46t70.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 674,
    d: "M171 710l167 -504l165 504h173l-269 -710h-138l-272 710h174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1055,
    d: "M304 709h151l72 -227l72 227h152l-119 -330l72 -191l178 522h179l-284 -710h-137l-113 278l-112 -278h-138l-283 710h178l179 -522l70 191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 651,
    d: "M171 710l155 -245l155 245h177l-246 -360l238 -350h-177l-147 235l-147 -235h-178l238 350l-246 360h178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 663,
    d: "M178 710l153 -326l155 326h179l-253 -468v-242h-163v244l-249 466h178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 625,
    d: "M28 123l370 443h-356v144h545v-123l-352 -443h356v-144h-563v123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 341,
    d: "M80 -40v780h215v-127h-67v-526h67v-127h-215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 663,
    d: "M203 710l435 -710h-176l-436 710h177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 341,
    d: "M47 -40v127h66v526h-66v127h214v-780h-214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 604,
    d: "M38 303l198 407h133l197 -407h-130l-134 275l-136 -275h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 459,
    d: "M50 -144v144h360v-144h-360z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 269,
    d: "M46 730h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 586,
    d: "M204 -10q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-21 -5 -38 -6.5 t-31 -1.5q-45 0 -68 17.5t-29 49.5l-3 24q-35 -45 -83.5 -69t-102.5 -24zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 640,
    d: "M370 -10q-60 0 -105 25.5t-71 71.5v-87h-139v730h160v-291q26 45 69.5 70.5t102.5 25.5q50 0 92 -21.5t72 -58.5t47 -87.5t17 -107.5t-18.5 -106.5t-51.5 -86t-78 -57t-97 -20.5zM325 125q28 0 51 10.5t39.5 28.5t26 42.5t9.5 53.5q0 28 -9 53.5t-24.5 44.5t-37.5 30 t-47 11q-38 0 -69.5 -26t-48.5 -65v-110q16 -34 46.5 -53.5t63.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 570,
    d: "M24 263q0 54 19 103.5t55 87t88.5 59.5t119.5 22q91 0 153 -38.5t93 -100.5l-156 -47q-31 50 -91 50q-50 0 -83.5 -37t-33.5 -99q0 -31 9 -56.5t25 -43.5t37.5 -28t45.5 -10q30 0 55 14.5t37 37.5l156 -48q-29 -61 -92.5 -100t-154.5 -39q-66 0 -118.5 22.5t-89 60 t-55.5 87t-19 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 654,
    d: "M273 -10q-54 0 -99.5 20.5t-78.5 57.5t-51.5 86.5t-18.5 108.5q0 57 17 107t48 86.5t73.5 57.5t93.5 21q55 0 99.5 -26t68.5 -70v291h160v-550q0 -24 7.5 -33.5t26.5 -11.5v-135q-22 -5 -38 -6.5t-30 -1.5q-42 0 -68 17.5t-30 50.5l-3 27q-28 -49 -75.5 -73t-101.5 -24z M316 125q33 0 63.5 19.5t46.5 53.5v110q-15 40 -48.5 65.5t-69.5 25.5q-26 0 -47.5 -11.5t-37.5 -30.5t-24.5 -44t-8.5 -53q0 -29 9.5 -54t26 -43t40 -28t50.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 604,
    d: "M306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39z M417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 385,
    d: "M89 0v361h-67v121h67v43q0 49 13 89t37 68t58 43t75 15q64 0 137 -31l-29 -120q-16 7 -35.5 11.5t-36.5 4.5q-59 0 -59 -74v-49h122v-121h-122v-361h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 640,
    d: "M259 -2q-52 0 -95 21t-73.5 57t-47.5 84t-17 103q0 58 18 107.5t50 86t77 57.5t99 21q60 0 104.5 -25.5t71.5 -70.5v86h139v-489q0 -60 -22.5 -108t-62.5 -81.5t-96 -51.5t-123 -18q-85 0 -145 27t-105 78l86 87q29 -33 72 -52.5t92 -19.5q29 0 55 8t46 24.5t31.5 43 t11.5 63.5v51q-24 -44 -69 -66.5t-97 -22.5zM314 125q37 0 66 20.5t45 52.5v110q-16 42 -49 66.5t-70 24.5q-26 0 -47.5 -11.5t-37 -31t-24 -45t-8.5 -52.5q0 -29 9.5 -53.5t26.5 -42.5t39.5 -28t49.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 612,
    d: "M561 0h-160v295q0 51 -20 75t-55 24q-14 0 -30.5 -6.5t-32 -19t-28.5 -29.5t-20 -38v-301h-160v730h160v-293q29 47 76.5 72.5t104.5 25.5q53 0 85.5 -18.5t50 -47t23.5 -64t6 -69.5v-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 270,
    d: "M55 0v525h160v-525h-160zM55 585v145h160v-145h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 274,
    d: "M27 -202q-40 0 -76 12.5t-65 37.5l67 109q11 -11 25 -16t29 -5q23 0 38 15t15 40v534h160v-522q0 -45 -14.5 -83t-40.5 -65t-61.5 -42t-76.5 -15zM60 585v145h160v-145h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 569,
    d: "M408 0l-137 211l-56 -58v-153h-160v730h160v-423l177 218h170l-189 -226l205 -299h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 335,
    d: "M53 730h160v-543q0 -60 51 -60q12 0 26.5 3.5t26.5 10.5l21 -120q-30 -14 -69 -22t-73 -8q-69 0 -106 36t-37 104v599z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 935,
    d: "M885 0h-160v295q0 52 -19 75.5t-49 23.5q-16 0 -32.5 -7t-30.5 -19.5t-25.5 -29.5t-18.5 -37v-301h-160v295q0 52 -19 75.5t-49 23.5q-32 0 -62.5 -25.5t-44.5 -67.5v-301h-160v525h144v-88q29 48 78.5 73t115.5 25q33 0 57.5 -8t42.5 -22t29 -32.5t16 -39.5 q30 49 79 75.5t112 26.5q50 0 80.5 -18.5t47.5 -48t22.5 -64.5t5.5 -68v-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 612,
    d: "M561 0h-160v295q0 52 -19.5 75.5t-51.5 23.5q-17 0 -34 -7t-33 -19.5t-28.5 -29.5t-19.5 -37v-301h-160v525h144v-88q29 47 82 72.5t122 25.5q51 0 82 -18.5t48 -48t22.5 -64.5t5.5 -68v-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 610,
    d: "M305 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5t18.5 103.5t54.5 87t88.5 60t119.5 22.5t119 -22.5t88 -60t55 -87t19 -103.5t-18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22zM188 262q0 -62 33 -99.5t84 -37.5q25 0 46 10t36.5 28t24.5 43.5t9 55.5 q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 640,
    d: "M387 -10q-60 0 -104 25t-68 70v-298h-160v738h139v-85q29 45 72.5 70t103.5 25q53 0 97.5 -21t77 -57.5t51 -86t18.5 -106.5q0 -59 -17 -109t-47 -86.5t-72 -57.5t-91 -21zM333 125q26 0 47.5 11.5t37.5 30.5t24.5 44.5t8.5 53.5q0 29 -9.5 53.5t-26 42.5t-40 28 t-50.5 10q-33 0 -63.5 -19.5t-46.5 -52.5v-108q16 -40 48.5 -67t69.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 640,
    d: "M253 -10q-50 0 -91.5 21t-71.5 58t-47 87t-17 108q0 57 18.5 106.5t51 86t77 57.5t97.5 21q60 0 103.5 -26t72.5 -70v86h139v-550q0 -24 9 -33.5t32 -10.5v-136q-21 -4 -45 -6t-43 -2q-23 0 -43.5 7.5t-36 21t-24.5 32.5t-9 42v195q-54 -95 -172 -95zM314 125 q35 0 63 19.5t48 51.5v111q-6 19 -18 36t-28 29.5t-34 19.5t-36 7q-26 0 -48 -11.5t-38 -30.5t-25 -44t-9 -53q0 -59 34.5 -97t90.5 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 400,
    d: "M388 388q-58 -1 -105 -19t-68 -54v-315h-160v525h147v-106q27 53 69.5 83t90.5 31h16t10 -1v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 499,
    d: "M262 -10q-67 0 -132 21.5t-110 62.5l57 98q48 -33 93.5 -51t87.5 -18q31 0 48 11t17 32t-21.5 33.5t-75.5 26.5q-53 15 -89.5 29t-59.5 31t-33 39t-10 52q0 40 16 73t44 56t66.5 36t83.5 13q59 0 110.5 -16t99.5 -58l-62 -96q-45 31 -80 45t-68 14q-26 0 -44 -10.5 t-18 -33.5q0 -22 19.5 -33t72.5 -24q56 -15 94.5 -30t62.5 -33.5t35 -42.5t11 -57q0 -78 -58 -124t-157 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 402,
    d: "M395 28q-33 -14 -75.5 -26t-85.5 -12q-30 0 -56.5 7.5t-46.5 24t-31.5 43.5t-11.5 65v274h-67v121h67v167h160v-167h107v-121h-107v-219q0 -26 13 -37.5t33 -11.5q18 0 37 6t33 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 627,
    d: "M214 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-23 -5 -39 -6.5t-29 -1.5q-86 0 -98 67l-3 32q-36 -52 -89.5 -76.5t-119.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 556,
    d: "M191 0l-186 525h165l115 -397l116 397h149l-185 -525h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 850,
    d: "M702 525h152l-217 -525h-131l-81 216l-81 -216h-131l-217 525h151l143 -377l49 143l-93 234h128l51 -158l50 158h128l-92 -234l49 -143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 542,
    d: "M166 525l95 -148l10 -19l10 19l94 148h164l-182 -263l186 -262h-164l-99 147l-9 19l-9 -19l-99 -147h-164l186 262l-182 263h163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 552,
    d: "M59 -79q20 -7 37.5 -10t31.5 -3q29 0 45 20t29 72l-200 525h165l122 -388l105 388h150l-200 -610q-21 -65 -75 -105.5t-128 -40.5q-20 0 -40.5 3.5t-41.5 11.5v137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 494,
    d: "M24 96l268 318h-254v111h421v-96l-266 -318h273v-111h-442v96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 344,
    d: "M237 613v-181q0 -23 -11 -40.5t-27 -31.5q15 -14 26.5 -31.5t11.5 -40.5v-192h55v-127h-176q-6 0 -14.5 6t-8.5 24v235q0 29 -17 48t-37 24v110q10 0 20 6.5t17.5 16.5t12 22.5t4.5 24.5v224q0 18 9 24t14 6h176v-127h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 291,
    d: "M78 -130v905h135v-905h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 344,
    d: "M52 613v127h175q6 0 14.5 -6t8.5 -24v-224q0 -12 4.5 -24.5t12.5 -22.5t17.5 -16.5t20.5 -6.5v-110q-20 -5 -37.5 -24t-17.5 -48v-235q0 -18 -8 -24t-15 -6h-175v127h55v192q0 23 11 40.5t26 31.5q-16 14 -26.5 31.5t-10.5 40.5v181h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 587,
    d: "M51 222q0 10 7.5 34t25 49t46.5 43.5t72 18.5q28 0 51.5 -8.5t45 -18t42 -18t43.5 -8.5q22 0 35.5 7.5t21 16.5t10 17t2.5 10h86q0 -6 -7.5 -29.5t-25.5 -48.5t-48 -45t-75 -20q-28 0 -51 8t-44.5 17.5t-42.5 17.5t-44 8q-22 0 -34.5 -7.5t-19 -17t-8.5 -17.5t-2 -9h-86 v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 331,
    d: "M245 429v-435h-160v435h160zM245 711v-166h-160v166h160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 604,
    d: "M276 -120v111q-52 4 -96 28.5t-75.5 61.5t-49 83t-17.5 94q0 51 15 96.5t45 82t74.5 62t103.5 34.5v112h69v-112q69 -2 128 -36t94 -101l-156 -47q-11 19 -29 31t-37 14v-265q22 6 40.5 18.5t26.5 29.5l156 -48q-16 -35 -43.5 -61t-59 -43.5t-63.5 -26t-57 -8.5v-110h-69 zM203 258q0 -39 19 -72.5t54 -48.5v250q-35 -11 -54 -47t-19 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 564,
    d: "M59 384h64q-17 37 -32.5 73.5t-15.5 76.5q0 38 16.5 71t46 57.5t69 38.5t84.5 14q63 0 120.5 -27.5t97.5 -77.5l-83 -98q-25 32 -63.5 53t-73.5 21q-32 0 -52 -19t-20 -50t17 -63t32 -70h187v-119h-167q-4 -37 -22 -70.5t-54 -71.5q23 8 41 11t35 3q35 0 67.5 -8t65.5 -8 q18 0 34 3.5t36 10.5l39 -118q-23 -14 -55.5 -23t-61.5 -9q-23 0 -46.5 5t-48 10.5t-49 10.5t-48.5 5q-28 0 -64.5 -7t-71.5 -18l-33 114q43 31 69 73.5t30 86.5h-90v119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 560,
    d: "M176 501q22 12 48 19t57 7q30 0 55.5 -7t47.5 -18l69 70l62 -62l-66 -66q31 -47 31 -106q0 -61 -32 -108l67 -66l-57 -57l-72 67q-45 -25 -105 -25q-32 0 -58.5 7t-48.5 19l-72 -68l-58 57l68 68q-14 23 -22 50t-8 56q0 58 29 104l-67 68l63 62zM197 337q0 -41 24 -66 t60 -25t60 25t24 67t-24 66.5t-60 24.5t-60 -25t-24 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 726,
    d: "M533 416h69v-103h-122l-38 -71v-31h161v-103h-161v-108h-163v108h-160v103h160v33l-37 69h-122v103h70l-160 294h177l153 -326l156 326h179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 294,
    d: "M215 260v-390h-136v390h136zM215 775v-390h-136v390h136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 541,
    d: "M471 223q13 -14 21.5 -38.5t8.5 -62.5q0 -58 -22.5 -98t-57 -65t-75 -36t-75.5 -11q-41 0 -77 12t-64.5 29t-49 35.5t-32.5 32.5l102 98q29 -30 56.5 -42.5t56.5 -12.5t50.5 13t21.5 39q0 13 -5.5 21t-14.5 12t-20 5.5t-21 2.5q-106 8 -159 58t-53 126q0 29 6 45.5 t9 24.5q-11 12 -23.5 40.5t-12.5 66.5q0 39 16.5 74.5t45.5 62.5t68.5 43.5t86.5 16.5q46 0 81.5 -14t63 -34.5t46.5 -44t32 -41.5l-122 -58q-13 22 -36 36t-55 14q-31 0 -48.5 -14.5t-17.5 -37.5q0 -15 5 -24t14 -14t21 -7t25 -2q38 -1 77 -10t71 -29t52.5 -53t20.5 -81 q0 -29 -6 -49.5t-11 -28.5zM217 319q0 -22 12 -32t28.5 -14.5t35 -5.5t30.5 -5q7 5 10.5 15t3.5 19q0 14 -6 23.5t-15.5 15.5t-20.5 8.5t-21 2.5q-14 0 -27 2.5t-17 4.5q-13 -11 -13 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 508,
    d: "M83 593v129h132v-129h-132zM293 593v129h132v-129h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 844,
    d: "M418 -7q-81 0 -150.5 27.5t-119.5 76t-78.5 114.5t-28.5 144q0 77 28.5 143t78.5 114t119.5 75.5t150.5 27.5q83 0 154 -27.5t122.5 -75.5t80.5 -114t29 -143q0 -78 -29 -144t-80.5 -114.5t-122.5 -76t-154 -27.5zM418 49q68 0 127.5 22.5t103 62.5t68.5 96t25 124 q0 64 -24.5 119.5t-68 97t-102.5 65t-129 23.5q-68 0 -125.5 -23.5t-100 -64.5t-66.5 -96.5t-24 -119.5t24 -120t66 -97t100 -65t126 -24zM428 114q-61 0 -109.5 19t-82 51.5t-51.5 76t-18 93.5q0 47 16.5 90.5t49.5 77t81.5 53.5t111.5 20q86 0 145.5 -37t88.5 -98 l-156 -48q-14 26 -35 37t-44 11q-42 0 -68 -30t-26 -76q0 -25 8 -44.5t21.5 -33t30.5 -20.5t35 -7q25 0 46 12.5t34 35.5l155 -47q-13 -28 -34.5 -53t-51 -43.5t-66.5 -29t-81 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 447,
    d: "M158 336q-26 0 -48 9t-38.5 24.5t-25.5 36.5t-9 46q0 27 11 49.5t31 38.5t47.5 25t60.5 9q46 0 76 -15v15q0 62 -67 62q-29 0 -54.5 -10t-54.5 -30l-34 71q69 47 154 47q81 0 124.5 -39t43.5 -114v-89q0 -31 28 -32v-97q-30 -6 -52 -6q-59 0 -68 48l-2 16 q-24 -32 -55.5 -48.5t-67.5 -16.5zM191 419q16 0 31.5 6t25.5 15q15 12 15 26v33q-13 6 -28 9t-29 3q-28 0 -45.5 -13.5t-17.5 -35.5q0 -18 14 -30.5t34 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 679,
    d: "M33 293l270 193v-129l-144 -98l144 -91v-129l-270 178v76zM352 293l270 193v-129l-144 -98l144 -91v-129l-270 178v76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 623,
    d: "M561 415v-317h-135v173h-372v144h507z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 615,
    d: "M54 203v144h507v-144h-507z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 844,
    d: "M420 -7q-83 0 -152.5 27.5t-119.5 76t-78.5 114.5t-28.5 144q0 77 28.5 143t78.5 114t119.5 75.5t152.5 27.5q82 0 152.5 -27.5t122 -75.5t80.5 -114t29 -143q0 -78 -29 -144t-80.5 -114.5t-122 -76t-152.5 -27.5zM421 48q67 0 125 23t101 63.5t67.5 96.5t24.5 122 q0 64 -24 120t-66.5 97t-100.5 65t-127 24t-127 -24t-100 -65t-65.5 -96.5t-23.5 -119.5t23.5 -119.5t65.5 -97t100 -65.5t127 -24zM254 574h197q31 0 57.5 -13t45.5 -34t29.5 -47.5t10.5 -53.5q0 -39 -20 -73.5t-52 -51.5l99 -161h-125l-87 140h-42v-140h-113v434zM440 376 q19 0 31 12t12 38q0 28 -14 39t-31 11h-71v-100h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 428,
    d: "M62 621v97h304v-97h-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 292,
    d: "M36 618q0 45 31 75.5t79 30.5t79 -30.5t31 -75.5q0 -52 -31 -83t-79 -31t-79 31.5t-31 82.5zM121 638q-10 -10 -10 -24q0 -16 10 -24q9 -11 25 -11t24 11q5 4 7.5 11t2.5 13q0 15 -10 24q-4 5 -10.5 7.5t-13.5 2.5q-16 0 -25 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 476,
    d: "M54 16v127h366v-127h-366zM421 445v-127h-111v-121h-144v121h-111v127h111v121h144v-121h111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 428,
    d: "M28 383q0 42 6.5 73t21.5 55t40.5 42t63.5 34q24 10 47.5 19t42 19.5t30 24t11.5 31.5q0 24 -21 35t-59 11q-42 0 -72.5 -14.5t-48.5 -31.5l-59 68q18 24 68.5 46.5t125.5 22.5q84 0 127.5 -36t43.5 -102q0 -33 -13 -57t-32 -40t-41.5 -25.5t-41.5 -15.5q-86 -25 -86 -68 h200v-91h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 414,
    d: "M193 376q-63 0 -106.5 19t-60.5 57l49 70q5 -7 14.5 -16t23.5 -17t33.5 -13.5t44.5 -5.5q39 0 68 10.5t29 33.5q0 26 -39.5 37.5t-109.5 11.5h-24v85h24q59 0 96.5 10.5t37.5 36.5q0 10 -7.5 17t-19 11.5t-25 6.5t-25.5 2q-39 0 -65 -13t-46 -34l-60 75q12 14 30.5 25 t41 18.5t48 11t50.5 3.5q38 0 70.5 -9t56 -25t37 -37.5t13.5 -46.5q0 -35 -25.5 -58t-70.5 -31q50 -7 78 -38t28 -73q0 -33 -16 -56.5t-42.5 -38.5t-60.5 -22t-70 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 269,
    d: "M148 572l-102 28l52 130h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 684,
    d: "M76 525h160v-301q0 -48 19 -73.5t58 -25.5q28 0 58.5 17t53.5 59v324h160v-345q0 -24 8.5 -33.5t31.5 -11.5v-135q-24 -5 -42.5 -6.5t-32.5 -1.5q-42 0 -67.5 18.5t-30.5 50.5l-3 30q-6 -15 -21 -32.5t-34.5 -32.5t-43 -25.5t-47.5 -10.5q-18 0 -31.5 5.5t-23.5 13 t-15.5 16t-6.5 13.5l10 -251h-160v738z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 679,
    d: "M34 451q0 124 74 191.5t208 67.5h317v-119h-70v-671h-136v279h-41v-279h-136v279q-48 0 -88 18t-68.5 51t-44 79.5t-15.5 103.5zM167 455q0 -60 24 -96.5t59 -41.5v274q-38 -3 -60.5 -40.5t-22.5 -95.5zM427 591h-41v-274h41v274z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 239,
    d: "M54 240v166h131v-166h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 343,
    d: "M51 -127q11 -7 37 -13.5t53 -6.5q24 0 40 7t16 25q0 17 -15 24.5t-39 7.5q-21 0 -44.5 -4t-34.5 -7l62 126l60 -18l-36 -52q13 3 30 3q36 0 63 -17.5t27 -56.5q0 -40 -34 -67.5t-106 -27.5q-35 0 -62 6.5t-47 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 309,
    d: "M288 476v-92h-240v92h77v243q-5 -7 -16 -16t-24.5 -17t-27.5 -13.5t-26 -5.5v93q15 0 31.5 9t30.5 19.5t23 19.5t9 10h94v-342h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 441,
    d: "M220 336q-45 0 -80 15.5t-59 41.5t-36.5 60t-12.5 72t12.5 72t36.5 60t59 41.5t80 15.5t80.5 -15.5t59.5 -41.5t36.5 -60t12.5 -72t-12.5 -72t-36.5 -60t-59 -41.5t-81 -15.5zM147 525q0 -42 21 -67t52 -25q32 0 53 25t21 67t-21 67t-53 25q-31 0 -52 -25t-21 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 679,
    d: "M646 217l-270 -178v129l144 91l-144 98v129l270 -193v-76zM327 217l-270 -178v129l144 91l-144 98v129l270 -193v-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 972,
    d: "M783 1v88h-218v91l247 251h64v-251h62v-91h-62v-88h-93zM653 180h134v138zM194 56l282 324l256 339l72 -64l-273 -316l-266 -348zM298 389v-92h-240v92h77v243q-5 -7 -16 -16t-24.5 -17t-27.5 -13.5t-26 -5.5v93q15 0 31.5 9t30.5 19.5t23 19.5t9 10h94v-342h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 992,
    d: "M588 0q0 42 6.5 73t21.5 54.5t40 42t63 34.5q24 10 47 19t41 19.5t29.5 23.5t11.5 31q0 25 -21 36t-58 11q-42 0 -72 -15t-48 -32l-58 69q18 24 68 46.5t125 22.5q81 0 124.5 -36t43.5 -103q0 -33 -12.5 -56.5t-31.5 -39.5t-41.5 -25.5t-41.5 -15.5q-85 -25 -85 -68h213 v-91h-365zM153 56l282 324l256 339l72 -64l-273 -316l-266 -348zM296 389v-92h-240v92h77v243q-5 -7 -16 -16t-24.5 -17t-27.5 -13.5t-26 -5.5v93q15 0 31.5 9t30.5 19.5t23 19.5t9 10h94v-342h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 980,
    d: "M205 289q-63 0 -106.5 19t-60.5 57l49 70q15 -19 43 -35.5t73 -16.5q39 0 68 10.5t29 33.5q0 26 -39.5 37.5t-109.5 11.5h-24v85h24q59 0 96.5 10.5t37.5 36.5q0 10 -7.5 17t-19 11.5t-25 6.5t-25.5 2q-39 0 -65 -13t-46 -34l-60 75q12 14 30.5 25t41 18.5t48 11 t50.5 3.5q38 0 70.5 -9t56 -25t37 -37.5t13.5 -46.5q0 -35 -25.5 -58t-70.5 -31q50 -7 78 -38t28 -73q0 -33 -16 -56.5t-42.5 -38.5t-60.5 -22t-70 -7zM790 1v88h-218v91l247 251h64v-251h62v-91h-62v-88h-93zM660 180h134v138zM224 56l282 324l256 339l72 -64l-273 -316 l-266 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 483,
    d: "M377 261q0 -23 -3 -44t-11.5 -40.5t-24.5 -36.5t-42 -31q-13 -8 -34.5 -19t-42 -26t-35.5 -34.5t-15 -43.5q0 -33 24 -51.5t55 -18.5q20 0 35.5 7.5t28 18t21.5 23t16 23.5l103 -72q-26 -61 -82.5 -95t-127.5 -34q-38 0 -76 11t-68 35t-49 62t-19 92q0 57 23.5 95.5 t69.5 67.5q21 13 42.5 24.5t39.5 23.5t29 27t11 36h132zM374 506v-150h-131v150h131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    d: "M261 710h148l259 -710h-168l-55 159h-221l-54 -159h-168zM418 272l-83 251l-85 -251h168zM194 916h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    d: "M261 710h148l259 -710h-168l-55 159h-221l-54 -159h-168zM418 272l-83 251l-85 -251h168zM381 757l-102 28l52 130h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    d: "M261 710h148l259 -710h-168l-55 159h-221l-54 -159h-168zM418 272l-83 251l-85 -251h168zM168 807l110 108h115l109 -108l-82 -36l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    d: "M261 710h148l259 -710h-168l-55 159h-221l-54 -159h-168zM418 272l-83 251l-85 -251h168zM399 773q-23 0 -40.5 7t-32.5 16t-29 16t-31 7t-26 -7t-14 -16t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5 q17 0 27.5 7.5t16 16.5t7 17t1.5 9h86q0 -8 -7 -31t-22.5 -48t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    d: "M261 710h148l259 -710h-168l-55 159h-221l-54 -159h-168zM418 272l-83 251l-85 -251h168zM165 779v129h132v-129h-132zM375 779v129h132v-129h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    d: "M261 710h148l259 -710h-168l-55 159h-221l-54 -159h-168zM418 272l-83 251l-85 -251h168zM228 833q0 41 29.5 61.5t77.5 20.5t77 -20.5t29 -61.5q0 -40 -29 -60.5t-77 -20.5t-77.5 20.5t-29.5 60.5zM335 868q-17 0 -28.5 -9.5t-11.5 -24.5t11.5 -25t28.5 -10q16 0 28 9.5 t12 25.5q0 15 -11.5 24.5t-28.5 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 968,
    d: "M412 710h515v-144h-309v-133h255v-143h-255v-146h318v-144h-481v159h-215l-91 -159h-175zM442 303v224l-133 -224h133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 687,
    d: "M281 -127q11 -7 37 -13.5t53 -6.5q24 0 40 7t16 25q0 17 -15 24.5t-39 7.5q-21 0 -44.5 -4t-34.5 -7l44 90q-70 7 -127.5 41t-98.5 84.5t-63.5 113t-22.5 126.5t24 127.5t70 113.5t112 81t150 31q100 0 173.5 -43t109.5 -112l-126 -88q-12 28 -30.5 46.5t-40.5 30t-45 16 t-45 4.5q-47 0 -82 -19t-58 -49t-34 -68t-11 -77q0 -42 13 -81t37.5 -69t59 -47.5t77.5 -17.5q22 0 45.5 5.5t45 17t39.5 30t29 45.5l134 -79q-15 -36 -43 -65t-65 -50t-78.5 -33.5t-83.5 -15.5l-23 -33q13 3 30 3q36 0 63 -17.5t27 -56.5q0 -40 -34 -67.5t-106 -27.5 q-35 0 -62 6.5t-47 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 599,
    d: "M567 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335zM180 916h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 599,
    d: "M367 757l-102 28l52 130h145zM567 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 599,
    d: "M154 807l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM567 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 599,
    d: "M150 779v129h132v-129h-132zM360 779v129h132v-129h-132zM567 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 300,
    d: "M68 0v710h164v-710h-164zM8 916h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 300,
    d: "M68 0v710h164v-710h-164zM195 757l-102 28l52 130h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 300,
    d: "M68 0v710h164v-710h-164zM-17 807l110 108h115l109 -108l-82 -36l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 300,
    d: "M68 0v710h164v-710h-164zM-21 779v129h132v-129h-132zM189 779v129h132v-129h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 721,
    d: "M73 0v298h-43v118h43v294h265q88 0 154 -28t110.5 -76t67 -112.5t22.5 -137.5q0 -81 -25 -146.5t-71.5 -112t-112 -72t-145.5 -25.5h-265zM525 356q0 47 -12.5 85.5t-36.5 66.5t-59 43t-79 15h-101v-150h128v-118h-128v-154h101q45 0 80 16t58.5 44.5t36 67t12.5 84.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 759,
    d: "M232 406v-406h-164v710h128l331 -417v417h164v-710h-132zM441 772q-23 0 -40.5 7t-32.5 16t-29 16t-31 7t-26 -7t-14 -16t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5q17 0 27.5 7.5t16 16.5t7 17t1.5 9 h86q0 -8 -7 -31t-22.5 -48t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 760,
    d: "M379 -6q-79 0 -144 31t-111 81.5t-71.5 115.5t-25.5 134q0 70 26.5 135t74 114.5t112.5 79t142 29.5q79 0 144 -31t111 -82t71 -116t25 -132q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30zM194 354q0 -41 12 -79.5t35.5 -68.5t58.5 -48t80 -18q47 0 82 19t58 49.5 t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5zM244 916h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 760,
    d: "M433 757l-102 28l52 130h145zM379 -6q-79 0 -144 31t-111 81.5t-71.5 115.5t-25.5 134q0 70 26.5 135t74 114.5t112.5 79t142 29.5q79 0 144 -31t111 -82t71 -116t25 -132q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30zM194 354q0 -41 12 -79.5t35.5 -68.5 t58.5 -48t80 -18q47 0 82 19t58 49.5t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 760,
    d: "M214 807l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM379 -6q-79 0 -144 31t-111 81.5t-71.5 115.5t-25.5 134q0 70 26.5 135t74 114.5t112.5 79t142 29.5q79 0 144 -31t111 -82t71 -116t25 -132q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30zM194 354 q0 -41 12 -79.5t35.5 -68.5t58.5 -48t80 -18q47 0 82 19t58 49.5t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 760,
    d: "M379 -6q-79 0 -144 31t-111 81.5t-71.5 115.5t-25.5 134q0 70 26.5 135t74 114.5t112.5 79t142 29.5q79 0 144 -31t111 -82t71 -116t25 -132q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30zM194 354q0 -41 12 -79.5t35.5 -68.5t58.5 -48t80 -18q47 0 82 19t58 49.5 t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5zM448 773q-23 0 -40.5 7t-32.5 16t-29 16t-31 7t-26 -7t-14 -16t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5 t28.5 -16.5t32 -7.5q17 0 27.5 7.5t16 16.5t7 17t1.5 9h86q0 -8 -7 -31t-22.5 -48t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 760,
    d: "M210 779v129h132v-129h-132zM420 779v129h132v-129h-132zM379 -6q-79 0 -144 31t-111 81.5t-71.5 115.5t-25.5 134q0 70 26.5 135t74 114.5t112.5 79t142 29.5q79 0 144 -31t111 -82t71 -116t25 -132q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30zM194 354 q0 -41 12 -79.5t35.5 -68.5t58.5 -48t80 -18q47 0 82 19t58 49.5t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 484,
    d: "M437 181l-100 -99l-96 95l-95 -95l-99 99l94 95l-89 91l100 99l90 -90l90 90l99 -99l-90 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 759,
    d: "M721 710l-81 -114q44 -51 68 -114t24 -129q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30t-144 31l-18 -25h-177l79 111q-45 51 -68.5 114.5t-23.5 130.5q0 70 26.5 135t74 114.5t112.5 79t142 29.5t144 -31l19 27h177zM193 354q0 -28 5.5 -55t16.5 -51l221 311 q-13 4 -27 6.5t-30 2.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5zM565 356q0 27 -5.5 53.5t-16.5 50.5l-221 -312q27 -8 57 -8q47 0 82 19t58 49.5t34.5 69t11.5 78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 747,
    d: "M373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5v363h164v-363q0 -74 -18.5 -138t-57 -112t-98 -75.5t-141.5 -27.5q-85 0 -145 29t-97.5 77.5t-55 112.5t-17.5 134v363h164v-363q0 -41 8 -78t26 -66t46.5 -46t70.5 -17zM232 916h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 747,
    d: "M419 757l-102 28l52 130h145zM373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5v363h164v-363q0 -74 -18.5 -138t-57 -112t-98 -75.5t-141.5 -27.5q-85 0 -145 29t-97.5 77.5t-55 112.5t-17.5 134v363h164v-363q0 -41 8 -78t26 -66t46.5 -46t70.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 747,
    d: "M206 807l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5v363h164v-363q0 -74 -18.5 -138t-57 -112t-98 -75.5t-141.5 -27.5q-85 0 -145 29t-97.5 77.5t-55 112.5t-17.5 134v363h164v-363q0 -41 8 -78t26 -66t46.5 -46 t70.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 747,
    d: "M202 779v129h132v-129h-132zM412 779v129h132v-129h-132zM373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5v363h164v-363q0 -74 -18.5 -138t-57 -112t-98 -75.5t-141.5 -27.5q-85 0 -145 29t-97.5 77.5t-55 112.5t-17.5 134v363h164v-363q0 -41 8 -78t26 -66t46.5 -46 t70.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 663,
    d: "M178 710l153 -326l155 326h179l-253 -468v-242h-163v244l-249 466h178zM376 757l-102 28l52 130h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 605,
    d: "M355 586q51 0 93.5 -21t73 -54.5t48 -76.5t17.5 -87q0 -47 -16.5 -90.5t-46 -77t-71 -53.5t-92.5 -20h-129v-106h-164v710h164v-124h123zM352 250q30 0 50.5 27.5t20.5 69.5q0 44 -23.5 70t-52.5 26h-115v-193h120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 560,
    d: "M250 141q51 0 84.5 22t33.5 68q0 22 -8.5 38.5t-22 27.5t-30 16.5t-32.5 5.5h-22v143h21q29 0 44 16t15 42q0 19 -7 30.5t-17 18t-20.5 8.5t-17.5 2q-20 0 -32.5 -8.5t-19.5 -21t-9.5 -27t-2.5 -25.5v-497h-152v525q0 41 17.5 75.5t48.5 60t73 39.5t91 14 q43 0 79.5 -11.5t63.5 -32.5t42 -52t15 -70q0 -26 -6.5 -49t-17.5 -42t-25.5 -33t-30.5 -21q61 -20 96 -69.5t35 -121.5q0 -61 -24.5 -102.5t-65 -67t-91.5 -37t-105 -11.5v147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 586,
    d: "M204 -10q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-21 -5 -38 -6.5 t-31 -1.5q-45 0 -68 17.5t-29 49.5l-3 24q-35 -45 -83.5 -69t-102.5 -24zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5zM135 731h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 586,
    d: "M204 -10q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-21 -5 -38 -6.5 t-31 -1.5q-45 0 -68 17.5t-29 49.5l-3 24q-35 -45 -83.5 -69t-102.5 -24zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5zM322 572l-102 28l52 130h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 586,
    d: "M204 -10q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-21 -5 -38 -6.5 t-31 -1.5q-45 0 -68 17.5t-29 49.5l-3 24q-35 -45 -83.5 -69t-102.5 -24zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5zM109 622l110 108h115l109 -108l-82 -36l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 586,
    d: "M204 -10q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-21 -5 -38 -6.5 t-31 -1.5q-45 0 -68 17.5t-29 49.5l-3 24q-35 -45 -83.5 -69t-102.5 -24zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5zM339 588q-23 0 -40.5 7t-32.5 16t-29 16t-31 7t-26 -7t-14 -16 t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5q17 0 27.5 7.5t16 16.5t7 17t1.5 9h86q0 -8 -7 -31t-22.5 -48t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 586,
    d: "M204 -10q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-21 -5 -38 -6.5 t-31 -1.5q-45 0 -68 17.5t-29 49.5l-3 24q-35 -45 -83.5 -69t-102.5 -24zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5zM105 594v129h132v-129h-132zM315 594v129h132v-129h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 586,
    d: "M204 -10q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-21 -5 -38 -6.5 t-31 -1.5q-45 0 -68 17.5t-29 49.5l-3 24q-35 -45 -83.5 -69t-102.5 -24zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5zM169 648q0 41 29.5 61.5t77.5 20.5t77 -20.5t29 -61.5 q0 -40 -29 -60.5t-77 -20.5t-77.5 20.5t-29.5 60.5zM276 683q-17 0 -28.5 -9.5t-11.5 -24.5t11.5 -25t28.5 -10q16 0 28 9.5t12 25.5q0 15 -11.5 24.5t-28.5 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 939,
    d: "M203 -10q-39 0 -72 12.5t-57 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q32 0 61 -5.5t52 -14.5q0 5 1 15.5t3 14.5q-3 42 -28 62.5t-76 20.5q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q60 0 106 -16.5t77 -47.5q34 29 79 46.5t102 17.5 q67 0 119.5 -22t88.5 -59.5t55 -87t19 -104.5q0 -12 -1.5 -25.5t-3.5 -23.5h-390q2 -26 12.5 -46.5t27 -34t37 -20.5t42.5 -7q36 0 68 17t43 46l136 -38q-30 -62 -95.5 -101t-156.5 -39q-77 0 -135 28.5t-93 76.5q-19 -28 -44 -48t-53 -32.5t-57 -18.5t-56 -6zM250 105 q26 0 50.5 9t41.5 24q23 18 23 37q-1 2 -2 9.5t-1.5 16.5t-1 16.5t-0.5 10.5q-20 7 -43 11t-43 4q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t55 -18.5zM753 310q-5 50 -36 80t-79 30t-78.5 -30t-35.5 -80h229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 570,
    d: "M225 -127q11 -7 37 -13.5t53 -6.5q24 0 40 7t16 25q0 17 -15 24.5t-39 7.5q-21 0 -44.5 -4t-34.5 -7l42 85q-60 4 -107.5 28t-80.5 61t-50.5 84t-17.5 99q0 54 19 103.5t55 87t88.5 59.5t119.5 22q91 0 153 -38.5t93 -100.5l-156 -47q-31 50 -91 50q-50 0 -83.5 -37 t-33.5 -99q0 -31 9 -56.5t25 -43.5t37.5 -28t45.5 -10q30 0 55 14.5t37 37.5l156 -48q-26 -54 -79.5 -91.5t-129.5 -45.5l-20 -30q13 3 30 3q36 0 63 -17.5t27 -56.5q0 -40 -34 -67.5t-106 -27.5q-35 0 -62 6.5t-47 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 604,
    d: "M306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39z M417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226zM163 731h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 604,
    d: "M350 572l-102 28l52 130h145zM306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5q35 0 67.5 17t43.5 46l136 -38 q-31 -62 -96 -101t-156 -39zM417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 604,
    d: "M137 622l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5 q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39zM417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 604,
    d: "M134 594v129h132v-129h-132zM344 594v129h132v-129h-132zM306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5 q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39zM417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 270,
    d: "M55 0v525h160v-525h-160zM-7 731h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 270,
    d: "M180 572l-102 28l52 130h145zM55 0v525h160v-525h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 270,
    d: "M-32 622l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM55 0v525h160v-525h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 270,
    d: "M-36 594v129h132v-129h-132zM174 594v129h132v-129h-132zM55 0v525h160v-525h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 617,
    d: "M537 651l-66 -35q57 -69 87.5 -154.5t30.5 -170.5q0 -71 -20.5 -126.5t-57.5 -94.5t-89.5 -59.5t-115.5 -20.5q-60 0 -111.5 18.5t-88.5 51t-58 77t-21 97.5q0 49 18.5 92.5t51 76t76 51t94.5 18.5q47 0 88 -17.5t69 -46.5q-20 84 -75 154l-85 -46l-45 61l77 41 q-67 59 -168 112h199q48 -23 90 -59l76 41zM191 234q0 -48 32.5 -78.5t83.5 -30.5q52 0 84.5 31.5t32.5 79.5t-32.5 78t-83.5 30t-84 -31t-33 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 612,
    d: "M561 0h-160v295q0 52 -19.5 75.5t-51.5 23.5q-17 0 -34 -7t-33 -19.5t-28.5 -29.5t-19.5 -37v-301h-160v525h144v-88q29 47 82 72.5t122 25.5q51 0 82 -18.5t48 -48t22.5 -64.5t5.5 -68v-336zM388 588q-23 0 -40.5 7t-32.5 16t-29 16t-31 7t-26 -7t-14 -16t-6 -16.5 t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5q17 0 27.5 7.5t16 16.5t7 17t1.5 9h86q0 -8 -7 -31t-22.5 -48t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 610,
    d: "M305 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5t18.5 103.5t54.5 87t88.5 60t119.5 22.5t119 -22.5t88 -60t55 -87t19 -103.5t-18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22zM188 262q0 -62 33 -99.5t84 -37.5q25 0 46 10t36.5 28t24.5 43.5t9 55.5 q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5zM164 731h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 610,
    d: "M350 572l-102 28l52 130h145zM305 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5t18.5 103.5t54.5 87t88.5 60t119.5 22.5t119 -22.5t88 -60t55 -87t19 -103.5t-18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22zM188 262q0 -62 33 -99.5t84 -37.5q25 0 46 10 t36.5 28t24.5 43.5t9 55.5q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 610,
    d: "M137 622l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM305 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5t18.5 103.5t54.5 87t88.5 60t119.5 22.5t119 -22.5t88 -60t55 -87t19 -103.5t-18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22zM188 262q0 -62 33 -99.5 t84 -37.5q25 0 46 10t36.5 28t24.5 43.5t9 55.5q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 610,
    d: "M305 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5t18.5 103.5t54.5 87t88.5 60t119.5 22.5t119 -22.5t88 -60t55 -87t19 -103.5t-18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22zM188 262q0 -62 33 -99.5t84 -37.5q25 0 46 10t36.5 28t24.5 43.5t9 55.5 q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5zM368 588q-23 0 -40.5 7t-32.5 16t-29 16t-31 7t-26 -7t-14 -16t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5q17 0 27.5 7.5t16 16.5 t7 17t1.5 9h86q0 -8 -7 -31t-22.5 -48t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 610,
    d: "M134 594v129h132v-129h-132zM344 594v129h132v-129h-132zM305 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5t18.5 103.5t54.5 87t88.5 60t119.5 22.5t119 -22.5t88 -60t55 -87t19 -103.5t-18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22zM188 262 q0 -62 33 -99.5t84 -37.5q25 0 46 10t36.5 28t24.5 43.5t9 55.5q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 499,
    d: "M183 426v143h134v-143h-134zM183 38v143h134v-143h-134zM48 240v127h404v-127h-404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 610,
    d: "M33 -5l65 75q-36 38 -55 87.5t-19 104.5q0 54 18.5 103.5t54.5 87t88.5 60t119.5 22.5q44 0 81 -10t68 -27l27 32h88l-62 -72q38 -38 58.5 -88.5t20.5 -107.5q0 -54 -18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22q-90 0 -155 40l-30 -35h-87zM305 125q25 0 46 10 t36.5 28t24.5 43.5t9 55.5q0 44 -19 77l-159 -196q25 -18 62 -18zM188 262q0 -43 16 -74l158 195q-27 16 -57 16q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 627,
    d: "M214 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-23 -5 -39 -6.5t-29 -1.5q-86 0 -98 67l-3 32q-36 -52 -89.5 -76.5t-119.5 -24.5zM163 731h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 627,
    d: "M350 572l-102 28l52 130h145zM214 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-23 -5 -39 -6.5t-29 -1.5q-86 0 -98 67l-3 32q-36 -52 -89.5 -76.5t-119.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 627,
    d: "M137 622l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM214 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-23 -5 -39 -6.5t-29 -1.5q-86 0 -98 67l-3 32 q-36 -52 -89.5 -76.5t-119.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 627,
    d: "M133 594v129h132v-129h-132zM343 594v129h132v-129h-132zM214 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-23 -5 -39 -6.5t-29 -1.5q-86 0 -98 67l-3 32 q-36 -52 -89.5 -76.5t-119.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 552,
    d: "M59 -79q20 -7 37.5 -10t31.5 -3q29 0 45 20t29 72l-200 525h165l122 -388l105 388h150l-200 -610q-21 -65 -75 -105.5t-128 -40.5q-20 0 -40.5 3.5t-41.5 11.5v137zM335 572l-102 28l52 130h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 600,
    d: "M577 256q0 -56 -21 -107.5t-57.5 -90.5t-85 -62t-102.5 -23q-42 0 -64.5 12.5t-27.5 22.5v-221h-164v923h164v-207q7 10 30 24t70 14q59 0 107 -25.5t81.5 -66t51.5 -91.5t18 -102zM413 259q0 28 -7 53.5t-20.5 44.5t-32.5 30t-44 11q-32 0 -53.5 -18.5t-36.5 -47.5v-155 q0 -9 7.5 -20t20 -20t28 -15t31.5 -6q23 0 42.5 11t34 30t22.5 45.5t8 56.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 552,
    d: "M59 -79q20 -7 37.5 -10t31.5 -3q29 0 45 20t29 72l-200 525h165l122 -388l105 388h150l-200 -610q-21 -65 -75 -105.5t-128 -40.5q-20 0 -40.5 3.5t-41.5 11.5v137zM119 594v129h132v-129h-132zM329 594v129h132v-129h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    d: "M261 710h148l259 -710h-168l-55 159h-221l-54 -159h-168zM418 272l-83 251l-85 -251h168zM184 806v97h304v-97h-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 586,
    d: "M204 -10q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-21 -5 -38 -6.5 t-31 -1.5q-45 0 -68 17.5t-29 49.5l-3 24q-35 -45 -83.5 -69t-102.5 -24zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5zM125 621v97h304v-97h-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    d: "M261 710h148l259 -710h-168l-55 159h-221l-54 -159h-168zM418 272l-83 251l-85 -251h168zM335 838q23 0 40.5 21.5t20.5 55.5h83q0 -32 -10.5 -59t-29.5 -46.5t-45.5 -30.5t-58.5 -11t-58 11t-45.5 30.5t-30 46.5t-10.5 59h85q0 -32 17.5 -54.5t41.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 586,
    d: "M204 -10q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-21 -5 -38 -6.5 t-31 -1.5q-45 0 -68 17.5t-29 49.5l-3 24q-35 -45 -83.5 -69t-102.5 -24zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5zM275 653q23 0 40.5 21.5t20.5 55.5h83q0 -32 -10.5 -59t-29.5 -46.5 t-45.5 -30.5t-58.5 -11t-58 11t-45.5 30.5t-30 46.5t-10.5 59h85q0 -32 17.5 -54.5t41.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 679,
    d: "M627 -205q-67 8 -99.5 34t-32.5 59q0 29 21 57.5t63 54.5h-79l-55 159h-221l-54 -159h-168l259 710h148l259 -710q-75 -45 -75 -82q0 -17 16 -27.5t49 -11.5zM418 272l-83 251l-85 -251h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 586,
    d: "M518 -205q-67 8 -99.5 34t-32.5 59q0 56 75 106q-59 10 -68 65l-3 24q-35 -45 -83.5 -69t-102.5 -24q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100 q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-75 -45 -75 -82q0 -17 16 -27.5t49 -11.5zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 688,
    d: "M432 757l-102 28l52 130h145zM27 361q0 64 24 127.5t70 113.5t112 81t150 31q100 0 173.5 -43t109.5 -112l-126 -88q-12 28 -30.5 46.5t-40.5 30t-45 16t-45 4.5q-47 0 -82 -19t-58 -49t-34 -68t-11 -77q0 -42 13 -81t37.5 -69t59 -47.5t77.5 -17.5q22 0 45.5 5.5t45 17 t39.5 30t29 45.5l134 -79q-16 -39 -47.5 -70t-72.5 -52t-87 -32t-90 -11q-77 0 -141.5 31.5t-111 83.5t-72 118t-25.5 134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 570,
    d: "M351 572l-102 28l52 130h145zM24 263q0 54 19 103.5t55 87t88.5 59.5t119.5 22q91 0 153 -38.5t93 -100.5l-156 -47q-31 50 -91 50q-50 0 -83.5 -37t-33.5 -99q0 -31 9 -56.5t25 -43.5t37.5 -28t45.5 -10q30 0 55 14.5t37 37.5l156 -48q-29 -61 -92.5 -100t-154.5 -39 q-66 0 -118.5 22.5t-89 60t-55.5 87t-19 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 688,
    d: "M213 807l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM27 361q0 64 24 127.5t70 113.5t112 81t150 31q100 0 173.5 -43t109.5 -112l-126 -88q-12 28 -30.5 46.5t-40.5 30t-45 16t-45 4.5q-47 0 -82 -19t-58 -49t-34 -68t-11 -77q0 -42 13 -81t37.5 -69t59 -47.5 t77.5 -17.5q22 0 45.5 5.5t45 17t39.5 30t29 45.5l134 -79q-16 -39 -47.5 -70t-72.5 -52t-87 -32t-90 -11q-77 0 -141.5 31.5t-111 83.5t-72 118t-25.5 134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 570,
    d: "M138 622l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM24 263q0 54 19 103.5t55 87t88.5 59.5t119.5 22q91 0 153 -38.5t93 -100.5l-156 -47q-31 50 -91 50q-50 0 -83.5 -37t-33.5 -99q0 -31 9 -56.5t25 -43.5t37.5 -28t45.5 -10q30 0 55 14.5t37 37.5l156 -48 q-29 -61 -92.5 -100t-154.5 -39q-66 0 -118.5 22.5t-89 60t-55.5 87t-19 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 688,
    d: "M27 361q0 64 24 127.5t70 113.5t112 81t150 31q100 0 173.5 -43t109.5 -112l-126 -88q-12 28 -30.5 46.5t-40.5 30t-45 16t-45 4.5q-47 0 -82 -19t-58 -49t-34 -68t-11 -77q0 -42 13 -81t37.5 -69t59 -47.5t77.5 -17.5q22 0 45.5 5.5t45 17t39.5 30t29 45.5l134 -79 q-16 -39 -47.5 -70t-72.5 -52t-87 -32t-90 -11q-77 0 -141.5 31.5t-111 83.5t-72 118t-25.5 134zM314 778v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 570,
    d: "M24 263q0 54 19 103.5t55 87t88.5 59.5t119.5 22q91 0 153 -38.5t93 -100.5l-156 -47q-31 50 -91 50q-50 0 -83.5 -37t-33.5 -99q0 -31 9 -56.5t25 -43.5t37.5 -28t45.5 -10q30 0 55 14.5t37 37.5l156 -48q-29 -61 -92.5 -100t-154.5 -39q-66 0 -118.5 22.5t-89 60 t-55.5 87t-19 103.5zM234 593v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 688,
    d: "M304 915l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM27 361q0 64 24 127.5t70 113.5t112 81t150 31q100 0 173.5 -43t109.5 -112l-126 -88q-12 28 -30.5 46.5t-40.5 30t-45 16t-45 4.5q-47 0 -82 -19t-58 -49t-34 -68t-11 -77q0 -42 13 -81t37.5 -69t59 -47.5 t77.5 -17.5q22 0 45.5 5.5t45 17t39.5 30t29 45.5l134 -79q-16 -39 -47.5 -70t-72.5 -52t-87 -32t-90 -11q-77 0 -141.5 31.5t-111 83.5t-72 118t-25.5 134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 570,
    d: "M220 730l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM24 263q0 54 19 103.5t55 87t88.5 59.5t119.5 22q91 0 153 -38.5t93 -100.5l-156 -47q-31 50 -91 50q-50 0 -83.5 -37t-33.5 -99q0 -31 9 -56.5t25 -43.5t37.5 -28t45.5 -10q30 0 55 14.5t37 37.5l156 -48 q-29 -61 -92.5 -100t-154.5 -39q-66 0 -118.5 22.5t-89 60t-55.5 87t-19 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 716,
    d: "M239 915l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM68 0v710h265q88 0 154 -28t110.5 -76t67 -112.5t22.5 -137.5q0 -81 -25 -146.5t-71.5 -112t-112 -72t-145.5 -25.5h-265zM520 356q0 47 -12.5 85.5t-36.5 66.5t-59 43t-79 15h-101v-422h101q45 0 80 16t58.5 44.5 t36 67t12.5 84.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 654,
    d: "M711 572l-102 28l52 130h145zM273 -10q-54 0 -99.5 20.5t-78.5 57.5t-51.5 86.5t-18.5 108.5q0 57 17 107t48 86.5t73.5 57.5t93.5 21q55 0 99.5 -26t68.5 -70v291h160v-550q0 -24 7.5 -33.5t26.5 -11.5v-135q-22 -5 -38 -6.5t-30 -1.5q-42 0 -68 17.5t-30 50.5l-3 27 q-28 -49 -75.5 -73t-101.5 -24zM316 125q33 0 63.5 19.5t46.5 53.5v110q-15 40 -48.5 65.5t-69.5 25.5q-26 0 -47.5 -11.5t-37.5 -30.5t-24.5 -44t-8.5 -53q0 -29 9.5 -54t26 -43t40 -28t50.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 721,
    d: "M73 0v298h-43v118h43v294h265q88 0 154 -28t110.5 -76t67 -112.5t22.5 -137.5q0 -81 -25 -146.5t-71.5 -112t-112 -72t-145.5 -25.5h-265zM525 356q0 47 -12.5 85.5t-36.5 66.5t-59 43t-79 15h-101v-150h128v-118h-128v-154h101q45 0 80 16t58.5 44.5t36 67t12.5 84.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 654,
    d: "M273 -10q-54 0 -99.5 20.5t-78.5 57.5t-51.5 86.5t-18.5 108.5q0 57 17 107t48 86.5t73.5 57.5t93.5 21q55 0 99.5 -26t68.5 -70v149h-93v94h93v48h160v-48h61v-94h-61v-408q0 -24 7.5 -33.5t26.5 -11.5v-135q-22 -5 -38 -6.5t-30 -1.5q-42 0 -68 17.5t-30 50.5l-3 27 q-28 -49 -75.5 -73t-101.5 -24zM316 125q33 0 63.5 19.5t46.5 53.5v110q-15 40 -48.5 65.5t-69.5 25.5q-26 0 -47.5 -11.5t-37.5 -30.5t-24.5 -44t-8.5 -53q0 -29 9.5 -54t26 -43t40 -28t50.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 599,
    d: "M567 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335zM170 806v97h304v-97h-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 604,
    d: "M306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39z M417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226zM153 621v97h304v-97h-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 599,
    d: "M567 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335zM321 838q23 0 40.5 21.5t20.5 55.5h83q0 -32 -10.5 -59t-29.5 -46.5t-45.5 -30.5t-58.5 -11t-58 11t-45.5 30.5t-30 46.5t-10.5 59h85q0 -32 17.5 -54.5t41.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 604,
    d: "M306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39z M417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226zM304 653q23 0 40.5 21.5t20.5 55.5h83q0 -32 -10.5 -59t-29.5 -46.5t-45.5 -30.5t-58.5 -11t-58 11t-45.5 30.5t-30 46.5t-10.5 59h85q0 -32 17.5 -54.5t41.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 599,
    d: "M567 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335zM250 778v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 604,
    d: "M306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39z M417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226zM233 593v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 600,
    d: "M567 144v-144q-75 -45 -75 -82q0 -17 16 -27.5t49 -11.5l-31 -84q-67 8 -99.5 34t-32.5 59q0 29 21 57.5t63 54.5h-410v710h490v-144h-326v-138h280v-133h-280v-151h335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 604,
    d: "M347 -205q-67 8 -99.5 34t-32.5 59q0 55 70 103q-62 3 -110 26t-82 59t-51.5 83t-17.5 98q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5q35 0 67.5 17t43.5 46l136 -38 q-23 -48 -67 -82t-104 -48q-74 -45 -74 -82q0 -17 16 -27.5t49 -11.5zM417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 599,
    d: "M236 915l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM567 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 604,
    d: "M219 730l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5 q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39zM417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 732,
    d: "M216 807l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM556 70q-81 -75 -187 -75q-70 0 -132 26.5t-108.5 74.5t-73.5 115.5t-27 148.5q0 73 27 138t74.5 113t112.5 76t140 28q99 0 173 -41.5t111 -113.5l-122 -92q-24 48 -69.5 74.5t-98.5 26.5q-41 0 -74.5 -16.5 t-57.5 -46t-37 -68.5t-13 -84q0 -46 14 -85t39 -67.5t59.5 -44.5t76.5 -16q96 0 173 89v22h-138v119h274v-371h-136v70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 640,
    d: "M179 622l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM259 -2q-52 0 -95 21t-73.5 57t-47.5 84t-17 103q0 58 18 107.5t50 86t77 57.5t99 21q60 0 104.5 -25.5t71.5 -70.5v86h139v-489q0 -60 -22.5 -108t-62.5 -81.5t-96 -51.5t-123 -18q-85 0 -145 27t-105 78l86 87 q29 -33 72 -52.5t92 -19.5q29 0 55 8t46 24.5t31.5 43t11.5 63.5v51q-24 -44 -69 -66.5t-97 -22.5zM314 125q37 0 66 20.5t45 52.5v110q-16 42 -49 66.5t-70 24.5q-26 0 -47.5 -11.5t-37 -31t-24 -45t-8.5 -52.5q0 -29 9.5 -53.5t26.5 -42.5t39.5 -28t49.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 732,
    d: "M556 70q-81 -75 -187 -75q-70 0 -132 26.5t-108.5 74.5t-73.5 115.5t-27 148.5q0 73 27 138t74.5 113t112.5 76t140 28q99 0 173 -41.5t111 -113.5l-122 -92q-24 48 -69.5 74.5t-98.5 26.5q-41 0 -74.5 -16.5t-57.5 -46t-37 -68.5t-13 -84q0 -46 14 -85t39 -67.5 t59.5 -44.5t76.5 -16q96 0 173 89v22h-138v119h274v-371h-136v70zM383 838q23 0 40.5 21.5t20.5 55.5h83q0 -32 -10.5 -59t-29.5 -46.5t-45.5 -30.5t-58.5 -11t-58 11t-45.5 30.5t-30 46.5t-10.5 59h85q0 -32 17.5 -54.5t41.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 640,
    d: "M259 -2q-52 0 -95 21t-73.5 57t-47.5 84t-17 103q0 58 18 107.5t50 86t77 57.5t99 21q60 0 104.5 -25.5t71.5 -70.5v86h139v-489q0 -60 -22.5 -108t-62.5 -81.5t-96 -51.5t-123 -18q-85 0 -145 27t-105 78l86 87q29 -33 72 -52.5t92 -19.5q29 0 55 8t46 24.5t31.5 43 t11.5 63.5v51q-24 -44 -69 -66.5t-97 -22.5zM314 125q37 0 66 20.5t45 52.5v110q-16 42 -49 66.5t-70 24.5q-26 0 -47.5 -11.5t-37 -31t-24 -45t-8.5 -52.5q0 -29 9.5 -53.5t26.5 -42.5t39.5 -28t49.5 -10zM346 653q23 0 40.5 21.5t20.5 55.5h83q0 -32 -10.5 -59 t-29.5 -46.5t-45.5 -30.5t-58.5 -11t-58 11t-45.5 30.5t-30 46.5t-10.5 59h85q0 -32 17.5 -54.5t41.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 732,
    d: "M556 70q-81 -75 -187 -75q-70 0 -132 26.5t-108.5 74.5t-73.5 115.5t-27 148.5q0 73 27 138t74.5 113t112.5 76t140 28q99 0 173 -41.5t111 -113.5l-122 -92q-24 48 -69.5 74.5t-98.5 26.5q-41 0 -74.5 -16.5t-57.5 -46t-37 -68.5t-13 -84q0 -46 14 -85t39 -67.5 t59.5 -44.5t76.5 -16q96 0 173 89v22h-138v119h274v-371h-136v70zM313 778v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 640,
    d: "M259 -2q-52 0 -95 21t-73.5 57t-47.5 84t-17 103q0 58 18 107.5t50 86t77 57.5t99 21q60 0 104.5 -25.5t71.5 -70.5v86h139v-489q0 -60 -22.5 -108t-62.5 -81.5t-96 -51.5t-123 -18q-85 0 -145 27t-105 78l86 87q29 -33 72 -52.5t92 -19.5q29 0 55 8t46 24.5t31.5 43 t11.5 63.5v51q-24 -44 -69 -66.5t-97 -22.5zM314 125q37 0 66 20.5t45 52.5v110q-16 42 -49 66.5t-70 24.5q-26 0 -47.5 -11.5t-37 -31t-24 -45t-8.5 -52.5q0 -29 9.5 -53.5t26.5 -42.5t39.5 -28t49.5 -10zM274 593v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 732,
    d: "M321 -213l31 67h-48v99h134v-99l-47 -67h-70zM556 70q-81 -75 -187 -75q-70 0 -132 26.5t-108.5 74.5t-73.5 115.5t-27 148.5q0 73 27 138t74.5 113t112.5 76t140 28q99 0 173 -41.5t111 -113.5l-122 -92q-24 48 -69.5 74.5t-98.5 26.5q-41 0 -74.5 -16.5t-57.5 -46 t-37 -68.5t-13 -84q0 -46 14 -85t39 -67.5t59.5 -44.5t76.5 -16q96 0 173 89v22h-138v119h274v-371h-136v70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 640,
    d: "M381 749l-31 -67h48v-99h-134v99l47 67h70zM259 -2q-52 0 -95 21t-73.5 57t-47.5 84t-17 103q0 58 18 107.5t50 86t77 57.5t99 21q60 0 104.5 -25.5t71.5 -70.5v86h139v-489q0 -60 -22.5 -108t-62.5 -81.5t-96 -51.5t-123 -18q-85 0 -145 27t-105 78l86 87 q29 -33 72 -52.5t92 -19.5q29 0 55 8t46 24.5t31.5 43t11.5 63.5v51q-24 -44 -69 -66.5t-97 -22.5zM314 125q37 0 66 20.5t45 52.5v110q-16 42 -49 66.5t-70 24.5q-26 0 -47.5 -11.5t-37 -31t-24 -45t-8.5 -52.5q0 -29 9.5 -53.5t26.5 -42.5t39.5 -28t49.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 747,
    d: "M209 806l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM679 710v-710h-164v291h-283v-291h-164v710h164v-275h283v275h164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 612,
    d: "M254 624l94 105h97l93 -105l-70 -35l-72 61l-72 -61zM561 0h-160v295q0 51 -20 75t-55 24q-14 0 -30.5 -6.5t-32 -19t-28.5 -29.5t-20 -38v-301h-160v730h160v-293q29 47 76.5 72.5t104.5 25.5q53 0 85.5 -18.5t50 -47t23.5 -64t6 -69.5v-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 755,
    d: "M683 710v-93h50v-76h-50v-541h-164v291h-283v-291h-164v541h-50v76h50v93h164v-93h283v93h164zM519 435v106h-283v-106h283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 612,
    d: "M561 0h-160v295q0 51 -20 75t-55 24q-14 0 -30.5 -6.5t-32 -19t-28.5 -29.5t-20 -38v-301h-160v588h-38v94h38v48h160v-48h117v-94h-117v-151q29 47 76.5 72.5t104.5 25.5q53 0 85.5 -18.5t50 -47t23.5 -64t6 -69.5v-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 300,
    d: "M68 0v710h164v-710h-164zM213 773q-23 0 -40.5 7t-32.5 16t-29 16t-31 7t-26 -7t-14 -16t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5q17 0 27.5 7.5t16 16.5t7 17t1.5 9h86q0 -8 -7 -31t-22.5 -48 t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 270,
    d: "M55 0v525h160v-525h-160zM198 588q-23 0 -40.5 7t-32.5 16t-29 16t-31 7t-26 -7t-14 -16t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5q17 0 27.5 7.5t16 16.5t7 17t1.5 9h86q0 -8 -7 -31t-22.5 -48 t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 300,
    d: "M68 0v710h164v-710h-164zM-1 806v97h304v-97h-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 270,
    d: "M55 0v525h160v-525h-160zM-16 621v97h304v-97h-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 300,
    d: "M68 0v710h164v-710h-164zM149 838q23 0 40.5 21.5t20.5 55.5h83q0 -32 -10.5 -59t-29.5 -46.5t-45.5 -30.5t-58.5 -11t-58 11t-45.5 30.5t-30 46.5t-10.5 59h85q0 -32 17.5 -54.5t41.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 270,
    d: "M55 0v525h160v-525h-160zM134 653q23 0 40.5 21.5t20.5 55.5h83q0 -32 -10.5 -59t-29.5 -46.5t-45.5 -30.5t-58.5 -11t-58 11t-45.5 30.5t-30 46.5t-10.5 59h85q0 -32 17.5 -54.5t41.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 301,
    d: "M191 -205q-67 8 -99.5 34t-32.5 59q0 29 21 57.5t63 54.5h-75v710h164v-710q-75 -45 -75 -82q0 -17 16 -27.5t49 -11.5l-31 -84v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 270,
    d: "M174 -205q-67 8 -99.5 34t-32.5 59q0 29 21 57.5t63 54.5h-71v525h160v-525q-75 -45 -75 -82q0 -17 16 -27.5t49 -11.5zM55 585v145h160v-145h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 300,
    d: "M68 0v710h164v-710h-164zM78 778v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 270,
    d: "M55 0v525h160v-525h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 794,
    d: "M68 0v710h164v-710h-164zM340 167q10 -8 42.5 -20t75.5 -12q37 0 59 12.5t34 38.5t15.5 66.5t3.5 96.5v361h164v-361q0 -81 -8.5 -147.5t-37 -113.5t-83.5 -73t-147 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 544,
    d: "M55 0v525h160v-525h-160zM55 585v145h160v-145h-160zM297 -202q-40 0 -76 12.5t-65 37.5l67 109q11 -11 25 -16t29 -5q23 0 38 15t15 40v534h160v-522q0 -45 -14.5 -83t-40.5 -65t-61.5 -42t-76.5 -15zM330 585v145h160v-145h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 494,
    d: "M187 807l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM40 167q10 -8 42.5 -20t75.5 -12q37 0 59 12.5t34 38.5t15.5 66.5t3.5 96.5v361h164v-361q0 -81 -8.5 -147.5t-37 -113.5t-83.5 -73t-147 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 270,
    d: "M22 -202q-82 0 -141 50l67 109q11 -11 25 -16t29 -5q23 0 38 15t15 40v534h160v-522q0 -45 -14.5 -83t-40.5 -65t-61.5 -42t-76.5 -15zM-32 622l110 108h115l109 -108l-82 -36l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 679,
    d: "M307 -213l31 67h-48v99h134v-99l-47 -67h-70zM68 0v710h164v-306l260 306h184l-266 -317l284 -393h-187l-201 286l-74 -77v-209h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 569,
    d: "M241 -213l31 67h-48v99h134v-99l-47 -67h-70zM408 0l-137 211l-56 -58v-153h-160v730h160v-423l177 218h170l-189 -226l205 -299h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 569,
    d: "M408 0l-137 211l-56 -58v-153h-160v525h160v-218l177 218h170l-189 -226l205 -299h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 585,
    d: "M410 757l-102 28l52 130h145zM68 0v710h164v-566h344v-144h-508z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 335,
    d: "M176 762l-102 28l52 130h145zM53 730h160v-543q0 -60 51 -60q12 0 26.5 3.5t26.5 10.5l21 -120q-30 -14 -69 -22t-73 -8q-69 0 -106 36t-37 104v599z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 585,
    d: "M283 -213l31 67h-48v99h134v-99l-47 -67h-70zM68 0v710h164v-566h344v-144h-508z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 335,
    d: "M142 -213l31 67h-48v99h134v-99l-47 -67h-70zM53 730h160v-543q0 -60 51 -60q12 0 26.5 3.5t26.5 10.5l21 -120q-30 -14 -69 -22t-73 -8q-69 0 -106 36t-37 104v599z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 585,
    d: "M425 571l-102 28l52 130h145zM68 0v710h164v-566h344v-144h-508z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 335,
    d: "M352 571l-102 28l52 130h145zM53 730h160v-543q0 -60 51 -60q12 0 26.5 3.5t26.5 10.5l21 -120q-30 -14 -69 -22t-73 -8q-69 0 -106 36t-37 104v599z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 585,
    d: "M68 0v710h164v-566h344v-144h-508zM364 325v166h131v-166h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 429,
    d: "M53 730h160v-543q0 -60 51 -60q12 0 26.5 3.5t26.5 10.5l21 -120q-30 -14 -69 -22t-73 -8q-69 0 -106 36t-37 104v599zM281 290v166h131v-166h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 595,
    d: "M79 0v274l-50 -28l-38 86l88 49v329h164v-236l92 52l37 -86l-129 -73v-223h344v-144h-508z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 364,
    d: "M79 286l-46 -25l-38 86l84 46v337h160v-250l84 46l38 -86l-122 -67v-186q0 -60 51 -60q12 0 26.5 3.5t26.5 10.5l21 -120q-30 -14 -69 -22t-73 -8q-69 0 -106 36t-37 104v155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 759,
    d: "M424 756l-102 28l52 130h145zM232 406v-406h-164v710h128l331 -417v417h164v-710h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 612,
    d: "M370 572l-102 28l52 130h145zM561 0h-160v295q0 52 -19.5 75.5t-51.5 23.5q-17 0 -34 -7t-33 -19.5t-28.5 -29.5t-19.5 -37v-301h-160v525h144v-88q29 47 82 72.5t122 25.5q51 0 82 -18.5t48 -48t22.5 -64.5t5.5 -68v-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 759,
    d: "M324 -213l31 67h-48v99h134v-99l-47 -67h-70zM232 406v-406h-164v710h128l331 -417v417h164v-710h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 612,
    d: "M252 -213l31 67h-48v99h134v-99l-47 -67h-70zM561 0h-160v295q0 52 -19.5 75.5t-51.5 23.5q-17 0 -34 -7t-33 -19.5t-28.5 -29.5t-19.5 -37v-301h-160v525h144v-88q29 47 82 72.5t122 25.5q51 0 82 -18.5t48 -48t22.5 -64.5t5.5 -68v-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 759,
    d: "M293 914l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM232 406v-406h-164v710h128l331 -417v417h164v-710h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 612,
    d: "M239 730l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM561 0h-160v295q0 52 -19.5 75.5t-51.5 23.5q-17 0 -34 -7t-33 -19.5t-28.5 -29.5t-19.5 -37v-301h-160v525h144v-88q29 47 82 72.5t122 25.5q51 0 82 -18.5t48 -48t22.5 -64.5t5.5 -68v-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 612,
    d: "M70 572l-102 28l33 80l-9 50h174zM561 0h-160v295q0 52 -19.5 75.5t-51.5 23.5q-17 0 -34 -7t-33 -19.5t-28.5 -29.5t-19.5 -37v-301h-160v525h144v-88q29 47 82 72.5t122 25.5q51 0 82 -18.5t48 -48t22.5 -64.5t5.5 -68v-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 743,
    d: "M232 401v-401h-164v710h126l316 -409v408h164v-711q0 -45 -15 -82t-41.5 -63.5t-61.5 -40.5t-75 -14q-39 0 -75 12.5t-65 37.5l67 109q10 -11 24 -16t29 -5q23 0 38 15t15 40v44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 611,
    d: "M368 -202q-82 0 -141 50l67 109q11 -11 25 -16t29 -5q23 0 38 15t15 40v304q0 52 -19.5 75.5t-51.5 23.5q-17 0 -34 -7t-33 -19.5t-28.5 -29.5t-19.5 -37v-301h-160v525h144v-88q29 47 82 72.5t122 25.5q51 0 82.5 -18.5t48 -48t22 -64.5t5.5 -68v-333q0 -45 -15 -83 t-41 -65t-61 -42t-76 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 760,
    d: "M232 806v97h304v-97h-304zM379 -6q-79 0 -144 31t-111 81.5t-71.5 115.5t-25.5 134q0 70 26.5 135t74 114.5t112.5 79t142 29.5q79 0 144 -31t111 -82t71 -116t25 -132q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30zM194 354q0 -41 12 -79.5t35.5 -68.5t58.5 -48 t80 -18q47 0 82 19t58 49.5t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 610,
    d: "M154 621v97h304v-97h-304zM305 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5t18.5 103.5t54.5 87t88.5 60t119.5 22.5t119 -22.5t88 -60t55 -87t19 -103.5t-18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22zM188 262q0 -62 33 -99.5t84 -37.5q25 0 46 10t36.5 28 t24.5 43.5t9 55.5q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 760,
    d: "M379 -6q-79 0 -144 31t-111 81.5t-71.5 115.5t-25.5 134q0 70 26.5 135t74 114.5t112.5 79t142 29.5q79 0 144 -31t111 -82t71 -116t25 -132q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30zM194 354q0 -41 12 -79.5t35.5 -68.5t58.5 -48t80 -18q47 0 82 19t58 49.5 t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5zM384 838q23 0 40.5 21.5t20.5 55.5h83q0 -32 -10.5 -59t-29.5 -46.5t-45.5 -30.5t-58.5 -11t-58 11t-45.5 30.5t-30 46.5t-10.5 59h85q0 -32 17.5 -54.5 t41.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 610,
    d: "M305 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5t18.5 103.5t54.5 87t88.5 60t119.5 22.5t119 -22.5t88 -60t55 -87t19 -103.5t-18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22zM188 262q0 -62 33 -99.5t84 -37.5q25 0 46 10t36.5 28t24.5 43.5t9 55.5 q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5zM304 653q23 0 40.5 21.5t20.5 55.5h83q0 -32 -10.5 -59t-29.5 -46.5t-45.5 -30.5t-58.5 -11t-58 11t-45.5 30.5t-30 46.5t-10.5 59h85q0 -32 17.5 -54.5t41.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 760,
    d: "M321 758l-77 28l45 130h120zM496 758l-77 28l44 130h120zM379 -6q-79 0 -144 31t-111 81.5t-71.5 115.5t-25.5 134q0 70 26.5 135t74 114.5t112.5 79t142 29.5q79 0 144 -31t111 -82t71 -116t25 -132q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30zM194 354 q0 -41 12 -79.5t35.5 -68.5t58.5 -48t80 -18q47 0 82 19t58 49.5t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 610,
    d: "M241 573l-77 28l45 130h120zM416 573l-77 28l44 130h120zM305 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5t18.5 103.5t54.5 87t88.5 60t119.5 22.5t119 -22.5t88 -60t55 -87t19 -103.5t-18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22zM188 262 q0 -62 33 -99.5t84 -37.5q25 0 46 10t36.5 28t24.5 43.5t9 55.5q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1060,
    d: "M1028 144v-144h-483v75q-34 -35 -80 -57.5t-100 -22.5q-76 0 -138 30.5t-106.5 81t-69 115.5t-24.5 134q0 70 25.5 135t71 115t108 79.5t136.5 29.5q54 0 99 -22t78 -57v74h474v-144h-310v-133h256v-143h-256v-146h319zM366 141q43 0 75.5 18.5t54 49t32 69t10.5 78.5 q0 41 -11.5 79.5t-33.5 68t-54 47.5t-73 18q-43 0 -75 -18.5t-53.5 -49t-32.5 -69t-11 -78.5q0 -41 11.5 -79.5t33 -68t53.5 -47.5t74 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1002,
    d: "M303 -10q-61 0 -112 20.5t-88 56.5t-58 86t-21 109t21 109t58 86.5t88 57t111 20.5q64 0 113.5 -27t87.5 -79q42 54 91 80t112 26q60 0 110.5 -20t87.5 -56.5t58 -86.5t22 -110q0 -12 -1 -25.5t-3 -23.5h-388q2 -24 12 -44t26 -35t37.5 -23.5t45.5 -8.5q38 0 70 18.5 t43 47.5l131 -38q-16 -32 -41.5 -58t-58 -44t-70.5 -28t-79 -10q-59 0 -106.5 24.5t-98.5 75.5q-50 -53 -96 -76.5t-104 -23.5zM305 125q51 0 83.5 38.5t32.5 98.5t-32.5 98.5t-83.5 38.5q-26 0 -47 -10t-37 -28.5t-24.5 -43.5t-8.5 -55q0 -61 33 -99t84 -38zM818 310 q-5 50 -37.5 80t-79.5 30q-48 0 -78.5 -30.5t-35.5 -79.5h231z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    d: "M365 756l-102 28l52 130h145zM68 0v710h320q50 0 92.5 -21t73.5 -55t48.5 -77t17.5 -87q0 -33 -8 -63.5t-23 -57.5t-36.5 -48.5t-48.5 -36.5l156 -264h-185l-136 229h-107v-229h-164zM232 372h150q29 0 50 27.5t21 70.5q0 44 -24 70t-52 26h-145v-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 400,
    d: "M291 572l-102 28l52 130h145zM388 388q-58 -1 -105 -19t-68 -54v-315h-160v525h147v-106q27 53 69.5 83t90.5 31h16t10 -1v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    d: "M294 -213l31 67h-48v99h134v-99l-47 -67h-70zM68 0v710h320q50 0 92.5 -21t73.5 -55t48.5 -77t17.5 -87q0 -33 -8 -63.5t-23 -57.5t-36.5 -48.5t-48.5 -36.5l156 -264h-185l-136 229h-107v-229h-164zM232 372h150q29 0 50 27.5t21 70.5q0 44 -24 70t-52 26h-145v-194z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 400,
    d: "M75 -213l31 67h-48v99h134v-99l-47 -67h-70zM388 388q-58 -1 -105 -19t-68 -54v-315h-160v525h147v-106q27 53 69.5 83t90.5 31h16t10 -1v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    d: "M234 914l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM68 0v710h320q50 0 92.5 -21t73.5 -55t48.5 -77t17.5 -87q0 -33 -8 -63.5t-23 -57.5t-36.5 -48.5t-48.5 -36.5l156 -264h-185l-136 229h-107v-229h-164zM232 372h150q29 0 50 27.5t21 70.5q0 44 -24 70t-52 26 h-145v-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 400,
    d: "M160 730l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM388 388q-58 -1 -105 -19t-68 -54v-315h-160v525h147v-106q27 53 69.5 83t90.5 31h16t10 -1v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 615,
    d: "M369 761l-102 28l52 130h145zM494 502q-3 4 -21 15t-45 23t-59 21t-64 9q-88 0 -88 -59q0 -18 9.5 -30t28 -21.5t46.5 -17.5t65 -18q51 -14 92 -30.5t69.5 -41t44 -59.5t15.5 -84q0 -60 -22.5 -101.5t-59.5 -67t-85 -37t-99 -11.5q-39 0 -80 6t-80 17.5t-75.5 27.5 t-67.5 37l72 143q4 -5 26 -19t54.5 -28t72.5 -25t81 -11q87 0 87 53q0 20 -13 33t-36 23.5t-54.5 19.5t-68.5 20q-49 15 -85 32.5t-59.5 40.5t-35 53t-11.5 70q0 56 21 99t57 72.5t83.5 44.5t100.5 15q37 0 73 -7t69 -18t61.5 -25t52.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 499,
    d: "M289 572l-102 28l52 130h145zM262 -10q-67 0 -132 21.5t-110 62.5l57 98q48 -33 93.5 -51t87.5 -18q31 0 48 11t17 32t-21.5 33.5t-75.5 26.5q-53 15 -89.5 29t-59.5 31t-33 39t-10 52q0 40 16 73t44 56t66.5 36t83.5 13q59 0 110.5 -16t99.5 -58l-62 -96q-45 31 -80 45 t-68 14q-26 0 -44 -10.5t-18 -33.5q0 -22 19.5 -33t72.5 -24q56 -15 94.5 -30t62.5 -33.5t35 -42.5t11 -57q0 -78 -58 -124t-157 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 615,
    d: "M157 811l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM494 502q-3 4 -21 15t-45 23t-59 21t-64 9q-88 0 -88 -59q0 -18 9.5 -30t28 -21.5t46.5 -17.5t65 -18q51 -14 92 -30.5t69.5 -41t44 -59.5t15.5 -84q0 -60 -22.5 -101.5t-59.5 -67t-85 -37t-99 -11.5q-39 0 -80 6 t-80 17.5t-75.5 27.5t-67.5 37l72 143q4 -5 26 -19t54.5 -28t72.5 -25t81 -11q87 0 87 53q0 20 -13 33t-36 23.5t-54.5 19.5t-68.5 20q-49 15 -85 32.5t-59.5 40.5t-35 53t-11.5 70q0 56 21 99t57 72.5t83.5 44.5t100.5 15q37 0 73 -7t69 -18t61.5 -25t52.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 499,
    d: "M77 622l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM262 -10q-67 0 -132 21.5t-110 62.5l57 98q48 -33 93.5 -51t87.5 -18q31 0 48 11t17 32t-21.5 33.5t-75.5 26.5q-53 15 -89.5 29t-59.5 31t-33 39t-10 52q0 40 16 73t44 56t66.5 36t83.5 13q59 0 110.5 -16 t99.5 -58l-62 -96q-45 31 -80 45t-68 14q-26 0 -44 -10.5t-18 -33.5q0 -22 19.5 -33t72.5 -24q56 -15 94.5 -30t62.5 -33.5t35 -42.5t11 -57q0 -78 -58 -124t-157 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 615,
    d: "M236 -127q11 -7 37 -13.5t53 -6.5q24 0 40 7t16 25q0 17 -15 24.5t-39 7.5q-21 0 -44.5 -4t-34.5 -7l42 87q-72 5 -144 27t-129 60l72 143q4 -5 26 -19t54.5 -28t72.5 -25t81 -11q87 0 87 53q0 20 -13 33t-36 23.5t-54.5 19.5t-68.5 20q-49 15 -85 32.5t-59.5 40.5 t-35 53t-11.5 70q0 56 21 99t57 72.5t83.5 44.5t100.5 15q37 0 73 -7t69 -18t61.5 -25t52.5 -28l-72 -136q-3 4 -21 15t-45 23t-59 21t-64 9q-88 0 -88 -59q0 -18 9.5 -30t28 -21.5t46.5 -17.5t65 -18q51 -14 92 -30.5t69.5 -41t44 -59.5t15.5 -84q0 -55 -19 -94.5 t-50.5 -65t-73.5 -39t-88 -16.5l-21 -32q13 3 30 3q36 0 63 -17.5t27 -56.5q0 -40 -34 -67.5t-106 -27.5q-35 0 -62 6.5t-47 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 499,
    d: "M181 -127q11 -7 37 -13.5t53 -6.5q24 0 40 7t16 25q0 17 -15 24.5t-39 7.5q-21 0 -44.5 -4t-34.5 -7l42 85q-61 4 -118 25t-98 58l57 98q48 -33 93.5 -51t87.5 -18q31 0 48 11t17 32t-21.5 33.5t-75.5 26.5q-53 15 -89.5 29t-59.5 31t-33 39t-10 52q0 40 16 73t44 56 t66.5 36t83.5 13q59 0 110.5 -16t99.5 -58l-62 -96q-45 31 -80 45t-68 14q-26 0 -44 -10.5t-18 -33.5q0 -22 19.5 -33t72.5 -24q56 -15 94.5 -30t62.5 -33.5t35 -42.5t11 -57q0 -71 -47 -115t-129 -53l-21 -30q13 3 30 3q36 0 63 -17.5t27 -56.5q0 -40 -34 -67.5t-106 -27.5 q-35 0 -62 6.5t-47 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 615,
    d: "M239 919l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM494 502q-3 4 -21 15t-45 23t-59 21t-64 9q-88 0 -88 -59q0 -18 9.5 -30t28 -21.5t46.5 -17.5t65 -18q51 -14 92 -30.5t69.5 -41t44 -59.5t15.5 -84q0 -60 -22.5 -101.5t-59.5 -67t-85 -37t-99 -11.5q-39 0 -80 6 t-80 17.5t-75.5 27.5t-67.5 37l72 143q4 -5 26 -19t54.5 -28t72.5 -25t81 -11q87 0 87 53q0 20 -13 33t-36 23.5t-54.5 19.5t-68.5 20q-49 15 -85 32.5t-59.5 40.5t-35 53t-11.5 70q0 56 21 99t57 72.5t83.5 44.5t100.5 15q37 0 73 -7t69 -18t61.5 -25t52.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 499,
    d: "M159 730l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM262 -10q-67 0 -132 21.5t-110 62.5l57 98q48 -33 93.5 -51t87.5 -18q31 0 48 11t17 32t-21.5 33.5t-75.5 26.5q-53 15 -89.5 29t-59.5 31t-33 39t-10 52q0 40 16 73t44 56t66.5 36t83.5 13q59 0 110.5 -16 t99.5 -58l-62 -96q-45 31 -80 45t-68 14q-26 0 -44 -10.5t-18 -33.5q0 -22 19.5 -33t72.5 -24q56 -15 94.5 -30t62.5 -33.5t35 -42.5t11 -57q0 -78 -58 -124t-157 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 621,
    d: "M220 -127q11 -7 37 -13.5t53 -6.5q24 0 40 7t16 25q0 17 -15 24.5t-39 7.5q-21 0 -44.5 -4t-34.5 -7l46 94h-50v566h-217v144h597v-144h-216v-566h-48l-26 -38q13 3 30 3q36 0 63 -17.5t27 -56.5q0 -40 -34 -67.5t-106 -27.5q-35 0 -62 6.5t-47 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 402,
    d: "M153 -127q11 -7 37 -13.5t53 -6.5q24 0 40 7t16 25q0 17 -15 24.5t-39 7.5q-21 0 -44.5 -4t-34.5 -7l42 86q-51 6 -85.5 38t-34.5 100v274h-67v121h67v167h160v-167h107v-121h-107v-219q0 -26 13 -37.5t33 -11.5q18 0 37 6t33 13l31 -127q-26 -11 -57.5 -20.5 t-64.5 -14.5l-21 -31q13 3 30 3q36 0 63 -17.5t27 -56.5q0 -40 -34 -67.5t-106 -27.5q-35 0 -62 6.5t-47 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 621,
    d: "M232 915l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM609 566h-216v-566h-164v566h-217v144h597v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 402,
    d: "M388 572l-102 28l52 130h145zM395 28q-33 -14 -75.5 -26t-85.5 -12q-30 0 -56.5 7.5t-46.5 24t-31.5 43.5t-11.5 65v274h-67v121h67v167h160v-167h107v-121h-107v-219q0 -26 13 -37.5t33 -11.5q18 0 37 6t33 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 645,
    d: "M621 566h-216v-198h178v-76h-178v-292h-164v292h-179v76h179v198h-217v144h597v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 403,
    d: "M396 28q-33 -14 -75.5 -26t-85.5 -12q-30 0 -56.5 7.5t-46.5 24t-31.5 43.5t-11.5 65v117h-67v93h67v64h-67v121h67v167h160v-167h107v-121h-107v-64h107v-93h-107v-62q0 -26 13 -37.5t33 -11.5q18 0 37 6t33 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 747,
    d: "M373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5v363h164v-363q0 -74 -18.5 -138t-57 -112t-98 -75.5t-141.5 -27.5q-85 0 -145 29t-97.5 77.5t-55 112.5t-17.5 134v363h164v-363q0 -41 8 -78t26 -66t46.5 -46t70.5 -17zM437 773q-23 0 -40.5 7t-32.5 16t-29 16t-31 7 t-26 -7t-14 -16t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5q17 0 27.5 7.5t16 16.5t7 17t1.5 9h86q0 -8 -7 -31t-22.5 -48t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 627,
    d: "M214 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-23 -5 -39 -6.5t-29 -1.5q-86 0 -98 67l-3 32q-36 -52 -89.5 -76.5t-119.5 -24.5zM368 588q-23 0 -40.5 7t-32.5 16 t-29 16t-31 7t-26 -7t-14 -16t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5q17 0 27.5 7.5t16 16.5t7 17t1.5 9h86q0 -8 -7 -31t-22.5 -48t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 747,
    d: "M373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5v363h164v-363q0 -74 -18.5 -138t-57 -112t-98 -75.5t-141.5 -27.5q-85 0 -145 29t-97.5 77.5t-55 112.5t-17.5 134v363h164v-363q0 -41 8 -78t26 -66t46.5 -46t70.5 -17zM222 806v97h304v-97h-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 627,
    d: "M214 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-23 -5 -39 -6.5t-29 -1.5q-86 0 -98 67l-3 32q-36 -52 -89.5 -76.5t-119.5 -24.5zM153 621v97h304v-97h-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 747,
    d: "M373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5v363h164v-363q0 -74 -18.5 -138t-57 -112t-98 -75.5t-141.5 -27.5q-85 0 -145 29t-97.5 77.5t-55 112.5t-17.5 134v363h164v-363q0 -41 8 -78t26 -66t46.5 -46t70.5 -17zM373 838q23 0 40.5 21.5t20.5 55.5h83 q0 -32 -10.5 -59t-29.5 -46.5t-45.5 -30.5t-58.5 -11t-58 11t-45.5 30.5t-30 46.5t-10.5 59h85q0 -32 17.5 -54.5t41.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 627,
    d: "M214 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-23 -5 -39 -6.5t-29 -1.5q-86 0 -98 67l-3 32q-36 -52 -89.5 -76.5t-119.5 -24.5zM303 653q23 0 40.5 21.5t20.5 55.5h83 q0 -32 -10.5 -59t-29.5 -46.5t-45.5 -30.5t-58.5 -11t-58 11t-45.5 30.5t-30 46.5t-10.5 59h85q0 -32 17.5 -54.5t41.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 747,
    d: "M266 833q0 41 29.5 61.5t77.5 20.5t77 -20.5t29 -61.5q0 -40 -29 -60.5t-77 -20.5t-77.5 20.5t-29.5 60.5zM373 868q-17 0 -28.5 -9.5t-11.5 -24.5t11.5 -25t28.5 -10q16 0 28 9.5t12 25.5q0 15 -11.5 24.5t-28.5 9.5zM373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5 v363h164v-363q0 -74 -18.5 -138t-57 -112t-98 -75.5t-141.5 -27.5q-85 0 -145 29t-97.5 77.5t-55 112.5t-17.5 134v363h164v-363q0 -41 8 -78t26 -66t46.5 -46t70.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 627,
    d: "M197 648q0 41 29.5 61.5t77.5 20.5t77 -20.5t29 -61.5q0 -40 -29 -60.5t-77 -20.5t-77.5 20.5t-29.5 60.5zM304 683q-17 0 -28.5 -9.5t-11.5 -24.5t11.5 -25t28.5 -10q16 0 28 9.5t12 25.5q0 15 -11.5 24.5t-28.5 9.5zM214 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160 v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-23 -5 -39 -6.5t-29 -1.5q-86 0 -98 67l-3 32q-36 -52 -89.5 -76.5t-119.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 747,
    d: "M373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5v363h164v-363q0 -74 -18.5 -138t-57 -112t-98 -75.5t-141.5 -27.5q-85 0 -145 29t-97.5 77.5t-55 112.5t-17.5 134v363h164v-363q0 -41 8 -78t26 -66t46.5 -46t70.5 -17zM309 758l-77 28l45 130h120zM484 758l-77 28 l44 130h120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 627,
    d: "M214 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-23 -5 -39 -6.5t-29 -1.5q-86 0 -98 67l-3 32q-36 -52 -89.5 -76.5t-119.5 -24.5zM240 573l-77 28l45 130h120zM415 573 l-77 28l44 130h120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 747,
    d: "M373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5v363h164v-363q0 -69 -16.5 -130.5t-51 -108.5t-87 -76.5t-125.5 -35.5q-67 -42 -67 -78q0 -17 16 -27.5t49 -11.5l-31 -84q-67 8 -99.5 34t-32.5 59q0 28 19.5 55.5t60.5 53.5q-71 9 -121.5 40.5t-82.5 78.5 t-46.5 106.5t-14.5 124.5v363h164v-363q0 -41 8 -78t26 -66t46.5 -46t70.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 628,
    d: "M215 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-75 -45 -75 -82q0 -17 16 -27.5t49 -11.5l-31 -84q-67 8 -99.5 34t-32.5 59q0 27 18.5 54.5t56.5 52.5q-59 9 -68 64 l-3 32q-36 -52 -89.5 -76.5t-119.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1055,
    d: "M360 807l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM304 709h151l72 -227l72 227h152l-119 -330l72 -191l178 522h179l-284 -710h-137l-113 278l-112 -278h-138l-283 710h178l179 -522l70 191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 850,
    d: "M258 622l110 108h115l109 -108l-82 -36l-85 63l-85 -63zM702 525h152l-217 -525h-131l-81 216l-81 -216h-131l-217 525h151l143 -377l49 143l-93 234h128l51 -158l50 158h128l-92 -234l49 -143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 663,
    d: "M178 710l153 -326l155 326h179l-253 -468v-242h-163v244l-249 466h178zM163 807l110 108h115l109 -108l-82 -36l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 552,
    d: "M59 -79q20 -7 37.5 -10t31.5 -3q29 0 45 20t29 72l-200 525h165l122 -388l105 388h150l-200 -610q-21 -65 -75 -105.5t-128 -40.5q-20 0 -40.5 3.5t-41.5 11.5v137zM122 622l110 108h115l109 -108l-82 -36l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 663,
    d: "M178 710l153 -326l155 326h179l-253 -468v-242h-163v244l-249 466h178zM160 779v129h132v-129h-132zM370 779v129h132v-129h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 625,
    d: "M369 757l-102 28l52 130h145zM28 123l370 443h-356v144h545v-123l-352 -443h356v-144h-563v123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 494,
    d: "M292 572l-102 28l52 130h145zM24 96l268 318h-254v111h421v-96l-266 -318h273v-111h-442v96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 625,
    d: "M28 123l370 443h-356v144h545v-123l-352 -443h356v-144h-563v123zM251 778v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 494,
    d: "M24 96l268 318h-254v111h421v-96l-266 -318h273v-111h-442v96zM174 593v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 625,
    d: "M238 915l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM28 123l370 443h-356v144h545v-123l-352 -443h356v-144h-563v123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 494,
    d: "M161 730l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM24 96l268 318h-254v111h421v-96l-266 -318h273v-111h-442v96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 752,
    d: "M372 -5q-83 0 -149 31.5t-112 81t-70.5 111t-24.5 122.5q0 17 2 34.5t4 29.5h523q-4 40 -19.5 70.5t-39 51.5t-53 31.5t-61.5 10.5q-25 0 -49.5 -6.5t-44.5 -19t-35 -30t-21 -39.5l-169 52q41 85 124 136.5t196 51.5q81 0 146 -31t110.5 -81t70 -113t24.5 -127 q0 -69 -24 -135t-69 -117.5t-110.5 -83t-148.5 -31.5zM374 139q68 0 114 38.5t54 104.5h-345q4 -32 19 -58.5t38.5 -45.5t54 -29t65.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 556,
    d: "M169 -202q-39 0 -75 12.5t-65 37.5l67 109q10 -11 24 -16t29 -5q23 0 38 15t15 40v352h-67v121h67v61q0 49 13 89t37 68t58 43t75 15q64 0 137 -31l-29 -120q-16 7 -35.5 11.5t-36.5 4.5q-59 0 -59 -74v-67h122v-121h-122v-348q0 -44 -15 -80t-41 -62t-61.5 -40.5 t-75.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1341,
    d: "M954 915l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM744 123l370 443h-356v144h545v-123l-352 -443h356v-144h-563v123zM68 0v710h265q88 0 154 -28t110.5 -76t67 -112.5t22.5 -137.5q0 -81 -25 -146.5t-71.5 -112t-112 -72t-145.5 -25.5h-265zM520 356 q0 47 -12.5 85.5t-36.5 66.5t-59 43t-79 15h-101v-422h101q45 0 80 16t58.5 44.5t36 67t12.5 84.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1210,
    d: "M877 730l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM740 96l268 318h-254v111h421v-96l-266 -318h273v-111h-442v96zM68 0v710h265q88 0 154 -28t110.5 -76t67 -112.5t22.5 -137.5q0 -81 -25 -146.5t-71.5 -112t-112 -72t-145.5 -25.5h-265zM520 356q0 47 -12.5 85.5 t-36.5 66.5t-59 43t-79 15h-101v-422h101q45 0 80 16t58.5 44.5t36 67t12.5 84.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1148,
    d: "M815 730l85 -63l85 63l82 -37l-109 -107h-115l-110 107zM678 96l268 318h-254v111h421v-96l-266 -318h273v-111h-442v96zM273 -10q-54 0 -99.5 20.5t-78.5 57.5t-51.5 86.5t-18.5 108.5q0 57 17 107t48 86.5t73.5 57.5t93.5 21q55 0 99.5 -26t68.5 -70v291h160v-550 q0 -24 7.5 -33.5t26.5 -11.5v-135q-22 -5 -38 -6.5t-30 -1.5q-42 0 -68 17.5t-30 50.5l-3 27q-28 -49 -75.5 -73t-101.5 -24zM316 125q33 0 63.5 19.5t46.5 53.5v110q-15 40 -48.5 65.5t-69.5 25.5q-26 0 -47.5 -11.5t-37.5 -30.5t-24.5 -44t-8.5 -53q0 -29 9.5 -54t26 -43 t40 -28t50.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1079,
    d: "M625 167q10 -8 42.5 -20t75.5 -12q37 0 59 12.5t34 38.5t15.5 66.5t3.5 96.5v361h164v-361q0 -81 -8.5 -147.5t-37 -113.5t-83.5 -73t-147 -26q-90 0 -154 44zM68 0v710h164v-566h344v-144h-508z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 859,
    d: "M612 -202q-40 0 -76 12.5t-65 37.5l67 109q11 -11 25 -16t29 -5q23 0 38 15t15 40v534h160v-522q0 -45 -14.5 -83t-40.5 -65t-61.5 -42t-76.5 -15zM645 585v145h160v-145h-160zM68 0v710h164v-566h344v-144h-508z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 609,
    d: "M362 -202q-40 0 -76 12.5t-65 37.5l67 109q11 -11 25 -16t29 -5q23 0 38 15t15 40v534h160v-522q0 -45 -14.5 -83t-40.5 -65t-61.5 -42t-76.5 -15zM395 585v145h160v-145h-160zM53 730h160v-543q0 -60 51 -60q12 0 26.5 3.5t26.5 10.5l21 -120q-30 -14 -69 -22t-73 -8 q-69 0 -106 36t-37 104v599z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1253,
    d: "M799 167q10 -8 42.5 -20t75.5 -12q37 0 59 12.5t34 38.5t15.5 66.5t3.5 96.5v361h164v-361q0 -81 -8.5 -147.5t-37 -113.5t-83.5 -73t-147 -26q-90 0 -154 44zM232 406v-406h-164v710h128l331 -417v417h164v-710h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 1033,
    d: "M786 -202q-40 0 -76 12.5t-65 37.5l67 109q11 -11 25 -16t29 -5q23 0 38 15t15 40v534h160v-522q0 -45 -14.5 -83t-40.5 -65t-61.5 -42t-76.5 -15zM819 585v145h160v-145h-160zM232 406v-406h-164v710h128l331 -417v417h164v-710h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 886,
    d: "M639 -202q-40 0 -76 12.5t-65 37.5l67 109q11 -11 25 -16t29 -5q23 0 38 15t15 40v534h160v-522q0 -45 -14.5 -83t-40.5 -65t-61.5 -42t-76.5 -15zM672 585v145h160v-145h-160zM561 0h-160v295q0 52 -19.5 75.5t-51.5 23.5q-17 0 -34 -7t-33 -19.5t-28.5 -29.5t-19.5 -37 v-301h-160v525h144v-88q29 47 82 72.5t122 25.5q51 0 82 -18.5t48 -48t22.5 -64.5t5.5 -68v-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 760,
    d: "M376 -205q-67 8 -99.5 34t-32.5 59q0 28 20 56t61 54q-68 10 -123 44t-94 82.5t-60 108.5t-21 123q0 70 26.5 135t74 114.5t112.5 79t142 29.5q79 0 144 -31t111 -82t71 -116t25 -132t-24 -129t-67 -110.5t-102.5 -80t-130.5 -37.5q-67 -42 -67 -78q0 -17 16 -27.5 t49 -11.5zM194 354q0 -41 12 -79.5t35.5 -68.5t58.5 -48t80 -18q47 0 82 19t58 49.5t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 610,
    d: "M343 -205q-67 8 -99.5 34t-32.5 59q0 55 70 103q-62 4 -109.5 27.5t-80.5 60.5t-50 84t-17 99q0 54 18.5 103.5t54.5 87t88.5 60t119.5 22.5t119 -22.5t88 -60t55 -87t19 -103.5q0 -46 -13.5 -88.5t-39.5 -77.5t-64 -60t-87 -37q-73 -43 -73 -81q0 -17 16 -27.5t49 -11.5 zM188 262q0 -62 33 -99.5t84 -37.5q25 0 46 10t36.5 28t24.5 43.5t9 55.5q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1330,
    d: "M734 123l370 443h-356v144h545v-123l-352 -443h356v-144h-563v123zM68 0v710h265q88 0 154 -28t110.5 -76t67 -112.5t22.5 -137.5q0 -81 -25 -146.5t-71.5 -112t-112 -72t-145.5 -25.5h-265zM520 356q0 47 -12.5 85.5t-36.5 66.5t-59 43t-79 15h-101v-422h101q45 0 80 16 t58.5 44.5t36 67t12.5 84.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1205,
    d: "M736 96l268 318h-254v111h421v-96l-266 -318h273v-111h-442v96zM68 0v710h265q88 0 154 -28t110.5 -76t67 -112.5t22.5 -137.5q0 -81 -25 -146.5t-71.5 -112t-112 -72t-145.5 -25.5h-265zM520 356q0 47 -12.5 85.5t-36.5 66.5t-59 43t-79 15h-101v-422h101q45 0 80 16 t58.5 44.5t36 67t12.5 84.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1148,
    d: "M678 96l268 318h-254v111h421v-96l-266 -318h273v-111h-442v96zM273 -10q-54 0 -99.5 20.5t-78.5 57.5t-51.5 86.5t-18.5 108.5q0 57 17 107t48 86.5t73.5 57.5t93.5 21q55 0 99.5 -26t68.5 -70v291h160v-550q0 -24 7.5 -33.5t26.5 -11.5v-135q-22 -5 -38 -6.5t-30 -1.5 q-42 0 -68 17.5t-30 50.5l-3 27q-28 -49 -75.5 -73t-101.5 -24zM316 125q33 0 63.5 19.5t46.5 53.5v110q-15 40 -48.5 65.5t-69.5 25.5q-26 0 -47.5 -11.5t-37.5 -30.5t-24.5 -44t-8.5 -53q0 -29 9.5 -54t26 -43t40 -28t50.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 732,
    d: "M431 757l-102 28l52 130h145zM556 70q-81 -75 -187 -75q-70 0 -132 26.5t-108.5 74.5t-73.5 115.5t-27 148.5q0 73 27 138t74.5 113t112.5 76t140 28q99 0 173 -41.5t111 -113.5l-122 -92q-24 48 -69.5 74.5t-98.5 26.5q-41 0 -74.5 -16.5t-57.5 -46t-37 -68.5t-13 -84 q0 -46 14 -85t39 -67.5t59.5 -44.5t76.5 -16q96 0 173 89v22h-138v119h274v-371h-136v70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    horizAdvX: 640,
    d: "M363 572l-102 28l52 130h145zM259 -2q-52 0 -95 21t-73.5 57t-47.5 84t-17 103q0 58 18 107.5t50 86t77 57.5t99 21q60 0 104.5 -25.5t71.5 -70.5v86h139v-489q0 -60 -22.5 -108t-62.5 -81.5t-96 -51.5t-123 -18q-85 0 -145 27t-105 78l86 87q29 -33 72 -52.5t92 -19.5 q29 0 55 8t46 24.5t31.5 43t11.5 63.5v51q-24 -44 -69 -66.5t-97 -22.5zM314 125q37 0 66 20.5t45 52.5v110q-16 42 -49 66.5t-70 24.5q-26 0 -47.5 -11.5t-37 -31t-24 -45t-8.5 -52.5q0 -29 9.5 -53.5t26.5 -42.5t39.5 -28t49.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    d: "M413 804q28 -20 28 -60q0 -35 -24 -57l251 -687h-168l-55 159h-221l-54 -159h-168l250 687q-24 19 -24 57q0 33 19.5 52.5t53.5 26.5l43 95h145zM418 272l-83 251l-85 -251h168zM335 779q-17 0 -28.5 -9.5t-11.5 -24.5t11.5 -25t28.5 -10q16 0 28 9.5t12 25.5 q0 15 -11.5 24.5t-28.5 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 586,
    d: "M204 -10q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-21 -5 -38 -6.5 t-31 -1.5q-45 0 -68 17.5t-29 49.5l-3 24q-35 -45 -83.5 -69t-102.5 -24zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5zM322 751l-102 28l52 130h145zM169 648q0 41 29.5 61.5t77.5 20.5 t77 -20.5t29 -61.5q0 -40 -29 -60.5t-77 -20.5t-77.5 20.5t-29.5 60.5zM276 683q-17 0 -28.5 -9.5t-11.5 -24.5t11.5 -25t28.5 -10q16 0 28 9.5t12 25.5q0 15 -11.5 24.5t-28.5 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 968,
    d: "M643 757l-102 28l52 130h145zM412 710h515v-144h-309v-133h255v-143h-255v-146h318v-144h-481v159h-215l-91 -159h-175zM442 303v224l-133 -224h133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 939,
    d: "M505 572l-102 28l52 130h145zM203 -10q-39 0 -72 12.5t-57 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q32 0 61 -5.5t52 -14.5q0 5 1 15.5t3 14.5q-3 42 -28 62.5t-76 20.5q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q60 0 106 -16.5t77 -47.5 q34 29 79 46.5t102 17.5q67 0 119.5 -22t88.5 -59.5t55 -87t19 -104.5q0 -12 -1.5 -25.5t-3.5 -23.5h-390q2 -26 12.5 -46.5t27 -34t37 -20.5t42.5 -7q36 0 68 17t43 46l136 -38q-30 -62 -95.5 -101t-156.5 -39q-77 0 -135 28.5t-93 76.5q-19 -28 -44 -48t-53 -32.5 t-57 -18.5t-56 -6zM250 105q26 0 50.5 9t41.5 24q23 18 23 37q-1 2 -2 9.5t-1.5 16.5t-1 16.5t-0.5 10.5q-20 7 -43 11t-43 4q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t55 -18.5zM753 310q-5 50 -36 80t-79 30t-78.5 -30t-35.5 -80h229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 759,
    d: "M721 710l-81 -114q44 -51 68 -114t24 -129q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30t-144 31l-18 -25h-177l79 111q-45 51 -68.5 114.5t-23.5 130.5q0 70 26.5 135t74 114.5t112.5 79t142 29.5t144 -31l19 27h177zM193 354q0 -28 5.5 -55t16.5 -51l221 311 q-13 4 -27 6.5t-30 2.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5zM565 356q0 27 -5.5 53.5t-16.5 50.5l-221 -312q27 -8 57 -8q47 0 82 19t58 49.5t34.5 69t11.5 78.5zM425 757l-102 28l52 130h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 610,
    d: "M33 -5l65 75q-36 38 -55 87.5t-19 104.5q0 54 18.5 103.5t54.5 87t88.5 60t119.5 22.5q44 0 81 -10t68 -27l27 32h88l-62 -72q38 -38 58.5 -88.5t20.5 -107.5q0 -54 -18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22q-90 0 -155 40l-30 -35h-87zM305 125q25 0 46 10 t36.5 28t24.5 43.5t9 55.5q0 44 -19 77l-159 -196q25 -18 62 -18zM188 262q0 -43 16 -74l158 195q-27 16 -57 16q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5zM350 572l-102 28l52 130h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    d: "M261 710h148l259 -710h-168l-55 159h-221l-54 -159h-168zM418 272l-83 251l-85 -251h168zM318 916h121l44 -130l-77 -28zM144 916h120l45 -130l-78 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    horizAdvX: 586,
    d: "M204 -10q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-21 -5 -38 -6.5 t-31 -1.5q-45 0 -68 17.5t-29 49.5l-3 24q-35 -45 -83.5 -69t-102.5 -24zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5zM256 730h121l44 -130l-77 -28zM82 730h120l45 -130l-78 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    d: "M261 710h148l259 -710h-168l-55 159h-221l-54 -159h-168zM418 272l-83 251l-85 -251h168zM335 845q-24 0 -41.5 -22.5t-17.5 -54.5h-85q0 32 10.5 59t30 46.5t45.5 30.5t58 11t58.5 -11t45.5 -30.5t29.5 -46.5t10.5 -59h-83q-3 34 -20.5 55.5t-40.5 21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    horizAdvX: 586,
    d: "M204 -10q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-21 -5 -38 -6.5 t-31 -1.5q-45 0 -68 17.5t-29 49.5l-3 24q-35 -45 -83.5 -69t-102.5 -24zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5zM287 660q-24 0 -41.5 -22.5t-17.5 -54.5h-85q0 32 10.5 59t30 46.5 t45.5 30.5t58 11t58.5 -11t45.5 -30.5t29.5 -46.5t10.5 -59h-83q-3 34 -20.5 55.5t-40.5 21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    horizAdvX: 599,
    d: "M295 916h121l44 -130l-77 -28zM121 916h120l45 -130l-78 -28zM567 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    horizAdvX: 604,
    d: "M290 730h121l44 -130l-77 -28zM116 730h120l45 -130l-78 -28zM306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5 q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39zM417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    horizAdvX: 599,
    d: "M318 845q-24 0 -41.5 -22.5t-17.5 -54.5h-85q0 32 10.5 59t30 46.5t45.5 30.5t58 11t58.5 -11t45.5 -30.5t29.5 -46.5t10.5 -59h-83q-3 34 -20.5 55.5t-40.5 21.5zM567 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    horizAdvX: 604,
    d: "M308 660q-24 0 -41.5 -22.5t-17.5 -54.5h-85q0 32 10.5 59t30 46.5t45.5 30.5t58 11t58.5 -11t45.5 -30.5t29.5 -46.5t10.5 -59h-83q-3 34 -20.5 55.5t-40.5 21.5zM306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22 t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39zM417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 300,
    d: "M68 0v710h164v-710h-164zM137 916h121l44 -130l-77 -28zM-37 916h120l45 -130l-78 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 270,
    d: "M125 730h121l44 -130l-77 -28zM-49 730h120l45 -130l-78 -28zM55 0v525h160v-525h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 300,
    d: "M68 0v710h164v-710h-164zM149 845q-24 0 -41.5 -22.5t-17.5 -54.5h-85q0 32 10.5 59t30 46.5t45.5 30.5t58 11t58.5 -11t45.5 -30.5t29.5 -46.5t10.5 -59h-83q-3 34 -20.5 55.5t-40.5 21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 270,
    d: "M135 660q-24 0 -41.5 -22.5t-17.5 -54.5h-85q0 32 10.5 59t30 46.5t45.5 30.5t58 11t58.5 -11t45.5 -30.5t29.5 -46.5t10.5 -59h-83q-3 34 -20.5 55.5t-40.5 21.5zM55 0v525h160v-525h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 760,
    d: "M357 916h121l44 -130l-77 -28zM183 916h120l45 -130l-78 -28zM379 -6q-79 0 -144 31t-111 81.5t-71.5 115.5t-25.5 134q0 70 26.5 135t74 114.5t112.5 79t142 29.5q79 0 144 -31t111 -82t71 -116t25 -132q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30zM194 354 q0 -41 12 -79.5t35.5 -68.5t58.5 -48t80 -18q47 0 82 19t58 49.5t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    horizAdvX: 610,
    d: "M288 730h121l44 -130l-77 -28zM114 730h120l45 -130l-78 -28zM305 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5t18.5 103.5t54.5 87t88.5 60t119.5 22.5t119 -22.5t88 -60t55 -87t19 -103.5t-18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22zM188 262 q0 -62 33 -99.5t84 -37.5q25 0 46 10t36.5 28t24.5 43.5t9 55.5q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 760,
    d: "M381 845q-24 0 -41.5 -22.5t-17.5 -54.5h-85q0 32 10.5 59t30 46.5t45.5 30.5t58 11t58.5 -11t45.5 -30.5t29.5 -46.5t10.5 -59h-83q-3 34 -20.5 55.5t-40.5 21.5zM379 -6q-79 0 -144 31t-111 81.5t-71.5 115.5t-25.5 134q0 70 26.5 135t74 114.5t112.5 79t142 29.5 q79 0 144 -31t111 -82t71 -116t25 -132q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30zM194 354q0 -41 12 -79.5t35.5 -68.5t58.5 -48t80 -18q47 0 82 19t58 49.5t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5 t-11.5 -78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    horizAdvX: 610,
    d: "M304 660q-24 0 -41.5 -22.5t-17.5 -54.5h-85q0 32 10.5 59t30 46.5t45.5 30.5t58 11t58.5 -11t45.5 -30.5t29.5 -46.5t10.5 -59h-83q-3 34 -20.5 55.5t-40.5 21.5zM305 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5t18.5 103.5t54.5 87t88.5 60t119.5 22.5 t119 -22.5t88 -60t55 -87t19 -103.5t-18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22zM188 262q0 -62 33 -99.5t84 -37.5q25 0 46 10t36.5 28t24.5 43.5t9 55.5q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    d: "M295 916h121l44 -130l-77 -28zM121 916h120l45 -130l-78 -28zM68 0v710h320q50 0 92.5 -21t73.5 -55t48.5 -77t17.5 -87q0 -33 -8 -63.5t-23 -57.5t-36.5 -48.5t-48.5 -36.5l156 -264h-185l-136 229h-107v-229h-164zM232 372h150q29 0 50 27.5t21 70.5q0 44 -24 70 t-52 26h-145v-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 400,
    d: "M208 730h121l44 -130l-77 -28zM34 730h120l45 -130l-78 -28zM388 388q-58 -1 -105 -19t-68 -54v-315h-160v525h147v-106q27 53 69.5 83t90.5 31h16t10 -1v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    d: "M322 845q-24 0 -41.5 -22.5t-17.5 -54.5h-85q0 32 10.5 59t30 46.5t45.5 30.5t58 11t58.5 -11t45.5 -30.5t29.5 -46.5t10.5 -59h-83q-3 34 -20.5 55.5t-40.5 21.5zM68 0v710h320q50 0 92.5 -21t73.5 -55t48.5 -77t17.5 -87q0 -33 -8 -63.5t-23 -57.5t-36.5 -48.5 t-48.5 -36.5l156 -264h-185l-136 229h-107v-229h-164zM232 372h150q29 0 50 27.5t21 70.5q0 44 -24 70t-52 26h-145v-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 400,
    d: "M218 660q-24 0 -41.5 -22.5t-17.5 -54.5h-85q0 32 10.5 59t30 46.5t45.5 30.5t58 11t58.5 -11t45.5 -30.5t29.5 -46.5t10.5 -59h-83q-3 34 -20.5 55.5t-40.5 21.5zM388 388q-58 -1 -105 -19t-68 -54v-315h-160v525h147v-106q27 53 69.5 83t90.5 31h16t10 -1v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 747,
    d: "M354 916h121l44 -130l-77 -28zM180 916h120l45 -130l-78 -28zM373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5v363h164v-363q0 -74 -18.5 -138t-57 -112t-98 -75.5t-141.5 -27.5q-85 0 -145 29t-97.5 77.5t-55 112.5t-17.5 134v363h164v-363q0 -41 8 -78t26 -66 t46.5 -46t70.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 627,
    d: "M291 730h121l44 -130l-77 -28zM117 730h120l45 -130l-78 -28zM214 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-23 -5 -39 -6.5t-29 -1.5q-86 0 -98 67l-3 32 q-36 -52 -89.5 -76.5t-119.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 747,
    d: "M372 845q-24 0 -41.5 -22.5t-17.5 -54.5h-85q0 32 10.5 59t30 46.5t45.5 30.5t58 11t58.5 -11t45.5 -30.5t29.5 -46.5t10.5 -59h-83q-3 34 -20.5 55.5t-40.5 21.5zM373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5v363h164v-363q0 -74 -18.5 -138t-57 -112t-98 -75.5 t-141.5 -27.5q-85 0 -145 29t-97.5 77.5t-55 112.5t-17.5 134v363h164v-363q0 -41 8 -78t26 -66t46.5 -46t70.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 627,
    d: "M301 660q-24 0 -41.5 -22.5t-17.5 -54.5h-85q0 32 10.5 59t30 46.5t45.5 30.5t58 11t58.5 -11t45.5 -30.5t29.5 -46.5t10.5 -59h-83q-3 34 -20.5 55.5t-40.5 21.5zM214 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324 h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-23 -5 -39 -6.5t-29 -1.5q-86 0 -98 67l-3 32q-36 -52 -89.5 -76.5t-119.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 615,
    d: "M271 -213l31 67h-48v99h134v-99l-47 -67h-70zM494 502q-3 4 -21 15t-45 23t-59 21t-64 9q-88 0 -88 -59q0 -18 9.5 -30t28 -21.5t46.5 -17.5t65 -18q51 -14 92 -30.5t69.5 -41t44 -59.5t15.5 -84q0 -60 -22.5 -101.5t-59.5 -67t-85 -37t-99 -11.5q-39 0 -80 6t-80 17.5 t-75.5 27.5t-67.5 37l72 143q4 -5 26 -19t54.5 -28t72.5 -25t81 -11q87 0 87 53q0 20 -13 33t-36 23.5t-54.5 19.5t-68.5 20q-49 15 -85 32.5t-59.5 40.5t-35 53t-11.5 70q0 56 21 99t57 72.5t83.5 44.5t100.5 15q37 0 73 -7t69 -18t61.5 -25t52.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 499,
    d: "M208 -213l31 67h-48v99h134v-99l-47 -67h-70zM262 -10q-67 0 -132 21.5t-110 62.5l57 98q48 -33 93.5 -51t87.5 -18q31 0 48 11t17 32t-21.5 33.5t-75.5 26.5q-53 15 -89.5 29t-59.5 31t-33 39t-10 52q0 40 16 73t44 56t66.5 36t83.5 13q59 0 110.5 -16t99.5 -58l-62 -96 q-45 31 -80 45t-68 14q-26 0 -44 -10.5t-18 -33.5q0 -22 19.5 -33t72.5 -24q56 -15 94.5 -30t62.5 -33.5t35 -42.5t11 -57q0 -78 -58 -124t-157 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 621,
    d: "M264 -213l31 67h-48v99h134v-99l-47 -67h-70zM609 566h-216v-566h-164v566h-217v144h597v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 402,
    d: "M180 -213l31 67h-48v99h134v-99l-47 -67h-70zM395 28q-33 -14 -75.5 -26t-85.5 -12q-30 0 -56.5 7.5t-46.5 24t-31.5 43.5t-11.5 65v274h-67v121h67v167h160v-167h107v-121h-107v-219q0 -26 13 -37.5t33 -11.5q18 0 37 6t33 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 270,
    d: "M22 -202q-82 0 -141 50l67 109q11 -11 25 -16t29 -5q23 0 38 15t15 40v534h160v-522q0 -45 -14.5 -83t-40.5 -65t-61.5 -42t-76.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    horizAdvX: 604,
    d: "M299 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5q0 13 1 26.5t3 23.5h388q-4 53 -38.5 80t-78.5 27q-36 0 -68 -17t-43 -46l-136 39q31 61 96 100.5t156 39.5q66 0 118.5 -22t89 -58.5t55.5 -85.5t19 -103q0 -56 -18.5 -106.5t-54.5 -88t-88.5 -59.5 t-119.5 -22zM301 105q47 0 77 29.5t35 79.5h-226q5 -50 36.5 -79.5t77.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 525,
    d: "M276 572l-102 28l33 80l-9 50h174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 384,
    d: "M25 622l110 108h115l109 -108l-82 -36l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 384,
    d: "M107 730l85 -63l85 63l82 -37l-109 -107h-115l-110 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 428,
    d: "M62 621v97h304v-97h-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 347,
    d: "M173 653q23 0 40.5 21.5t20.5 55.5h83q0 -32 -10.5 -59t-29.5 -46.5t-45.5 -30.5t-58.5 -11t-58 11t-45.5 30.5t-30 46.5t-10.5 59h85q0 -32 17.5 -54.5t41.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 244,
    d: "M50 593v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 268,
    d: "M27 648q0 41 29.5 61.5t77.5 20.5t77 -20.5t29 -61.5q0 -40 -29 -60.5t-77 -20.5t-77.5 20.5t-29.5 60.5zM134 683q-17 0 -28.5 -9.5t-11.5 -24.5t11.5 -25t28.5 -10q16 0 28 9.5t12 25.5q0 15 -11.5 24.5t-28.5 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 309,
    d: "M201 -204q-67 8 -99.5 34t-32.5 59q0 35 31.5 70t94.5 64l47 -22q-75 -45 -75 -82q0 -17 16 -27.5t49 -11.5l-31 -84v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 450,
    d: "M292 588q-23 0 -40.5 7t-32.5 16t-29 16t-31 7t-26 -7t-14 -16t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5q17 0 27.5 7.5t16 16.5t7 17t1.5 9h86q0 -8 -7 -31t-22.5 -48t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 381,
    d: "M106 572l-77 28l45 130h120zM281 572l-77 28l44 130h120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 381,
    d: "M187 730h121l44 -130l-77 -28zM13 730h120l45 -130l-78 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 347,
    d: "M173 660q-24 0 -41.5 -22.5t-17.5 -54.5h-85q0 32 10.5 59t30 46.5t45.5 30.5t58 11t58.5 -11t45.5 -30.5t29.5 -46.5t10.5 -59h-83q-3 34 -20.5 55.5t-40.5 21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 655,
    d: "M639 126v-126h-623v126l246 584h133zM481 144l-153 385l-149 -385h302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 783,
    d: "M34 114h158q-69 40 -108.5 106.5t-39.5 151.5q0 68 26.5 130t73 109.5t110 75.5t137.5 28q75 0 138.5 -28t110 -75.5t72.5 -109.5t26 -130q0 -85 -39 -151.5t-108 -106.5h157v-114h-317v114q34 13 61 39.5t46 61.5t29 75.5t10 81.5q0 37 -13 72t-37 63t-58.5 45t-77.5 17 t-77.5 -17t-58.5 -45t-36.5 -63t-12.5 -72q0 -41 10 -81.5t29 -75.5t46 -61.5t60 -39.5v-114h-317v114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 639,
    d: "M55 525h160v-301q0 -48 19 -73.5t58 -25.5q28 0 58 17t53 59v324h160v-345q0 -24 9 -33.5t32 -11.5v-135q-25 -5 -43 -6.5t-32 -1.5q-42 0 -67.5 18.5t-30.5 50.5l-3 30q-6 -15 -21 -32.5t-34.5 -32.5t-43 -25.5t-47.5 -10.5q-18 0 -31.5 5.5t-23.5 13t-15.5 16 t-6.5 13.5l10 -251h-160v738z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 661,
    d: "M258 386v-386h-159v386h-73v136h582v-136h-88v-199q0 -60 51 -60q12 0 26.5 3.5t26.5 10.5l21 -120q-30 -14 -69 -22t-73 -8q-68 0 -105.5 36t-37.5 104v255h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0400",
    unicode: "\u0400",
    horizAdvX: 602,
    d: "M570 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335zM183 916h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0401",
    unicode: "\u0401",
    horizAdvX: 602,
    d: "M154 779v129h132v-129h-132zM364 779v129h132v-129h-132zM570 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0402",
    unicode: "\u0402",
    horizAdvX: 748,
    d: "M152 570h-140v140h574v-140h-274v-163q34 27 78.5 41.5t94.5 14.5q59 0 106 -17t79.5 -48t50 -75t17.5 -98q0 -112 -63.5 -173.5t-180.5 -61.5q-67 0 -130 22l44 133q38 -19 73 -19q42 0 68.5 23t26.5 76q0 50 -27.5 76t-75.5 26q-87 0 -161 -64v-263h-160v570z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0403",
    unicode: "\u0403",
    horizAdvX: 529,
    d: "M333 757l-102 28l52 130h145zM519 566h-283v-566h-165v710h448v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0404",
    unicode: "\u0404",
    horizAdvX: 696,
    d: "M681 159q-17 -39 -48.5 -70t-72 -52t-87 -32t-93.5 -11q-79 0 -144 31.5t-111.5 83.5t-72 118t-25.5 134q0 64 24 127.5t69.5 113.5t112.5 81t153 31q103 0 176.5 -43t109.5 -112l-126 -88q-12 28 -30.5 46.5t-41 30t-46.5 16t-46 4.5q-38 0 -67 -11.5t-51 -30.5 t-36.5 -44.5t-22.5 -53.5h247v-131h-251q7 -33 23 -61.5t39.5 -50t54 -33.5t66.5 -12q23 0 47 5.5t46 17t40 30t29 45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0405",
    unicode: "\u0405",
    horizAdvX: 615,
    d: "M494 502q-3 4 -21 15t-45 23t-59 21t-64 9q-88 0 -88 -59q0 -18 9.5 -30t28 -21.5t46.5 -17.5t65 -18q51 -14 92 -30.5t69.5 -41t44 -59.5t15.5 -84q0 -60 -22.5 -101.5t-59.5 -67t-85 -37t-99 -11.5q-39 0 -80 6t-80 17.5t-75.5 27.5t-67.5 37l72 143q4 -5 26 -19 t54.5 -28t72.5 -25t81 -11q87 0 87 53q0 20 -13 33t-36 23.5t-54.5 19.5t-68.5 20q-49 15 -85 32.5t-59.5 40.5t-35 53t-11.5 70q0 56 21 99t57 72.5t83.5 44.5t100.5 15q37 0 73 -7t69 -18t61.5 -25t52.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0406",
    unicode: "\u0406",
    horizAdvX: 307,
    d: "M71 0v710h164v-710h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0407",
    unicode: "\u0407",
    horizAdvX: 307,
    d: "M71 0v710h164v-710h-164zM-18 779v129h132v-129h-132zM192 779v129h132v-129h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0408",
    unicode: "\u0408",
    horizAdvX: 497,
    d: "M40 167q10 -8 42.5 -20t75.5 -12q37 0 59 12.5t34 38.5t15.5 66.5t3.5 96.5v361h164v-361q0 -81 -8.5 -147.5t-37 -113.5t-83.5 -73t-147 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0409",
    unicode: "\u0409",
    horizAdvX: 1068,
    d: "M11 137q36 4 60.5 17.5t41.5 52t28.5 109.5t22.5 190l18 204h461v-266h161q55 0 99.5 -15t76.5 -43t49.5 -68.5t17.5 -92.5q0 -53 -17 -95t-48 -71t-74.5 -44t-96.5 -15h-332v566h-148l-10 -102q-14 -136 -33.5 -226.5t-53 -144.5t-86.5 -77t-132 -23zM791 139 q44 0 66.5 23.5t22.5 64.5q0 37 -22.5 62t-66.5 25h-148v-175h148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040A",
    unicode: "\u040A",
    horizAdvX: 1093,
    d: "M71 710h165v-271h268v271h164v-266h161q55 0 99.5 -15t76.5 -43t49.5 -68.5t17.5 -92.5q0 -53 -17 -95t-48 -71t-74.5 -44t-96.5 -15h-332v296h-268v-296h-165v710zM816 139q44 0 66.5 19t22.5 62q0 80 -89 80h-148v-161h148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040B",
    unicode: "\u040B",
    horizAdvX: 743,
    d: "M550 166q0 71 -26 107.5t-86 36.5q-35 0 -67.5 -10.5t-58.5 -28.5v-271h-160v570h-140v140h560v-140h-260v-145q32 17 74.5 26.5t92.5 9.5q53 0 96 -13.5t73 -42t46.5 -72t16.5 -102.5v-231h-161v166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040C",
    unicode: "\u040C",
    d: "M388 757l-102 28l52 130h145zM235 428h37l207 282h185l-255 -343l278 -367h-183l-217 279h-52v-279h-164v710h164v-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040D",
    unicode: "\u040D",
    horizAdvX: 756,
    d: "M261 916h145l52 -130l-101 -28zM236 255l334 455h122v-710h-164v444l-330 -444h-127v710h165v-455z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040E",
    unicode: "\u040E",
    horizAdvX: 643,
    d: "M204 -7q-11 0 -26 2t-30.5 5.5t-30.5 9.5t-27 15l29 135q8 -5 27 -15t42 -10q26 0 44 14t29 46l-262 515h180l156 -352l144 352h173l-250 -540q-22 -48 -42.5 -81.5t-43.5 -54.5t-50 -31t-62 -10zM331 767q-43 0 -78 11t-60.5 30.5t-39.5 47t-14 60.5h99q0 -13 7.5 -24.5 t20 -20t29.5 -13.5t36 -5q36 0 62.5 18t31.5 45h98q0 -33 -14 -60.5t-39.5 -47t-60.5 -30.5t-78 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040F",
    unicode: "\u040F",
    horizAdvX: 718,
    d: "M71 710h164v-566h248v566h164v-710h-212v-172h-153v172h-211v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0410",
    unicode: "\u0410",
    d: "M261 710h148l259 -710h-168l-55 159h-221l-54 -159h-168zM418 272l-83 251l-85 -251h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0411",
    unicode: "\u0411",
    horizAdvX: 674,
    d: "M71 710h531v-144h-366v-136h172q115 0 179.5 -55.5t64.5 -156.5q0 -104 -62 -161t-175 -57h-344v710zM396 139q43 0 65.5 21.5t22.5 59.5q0 35 -22 57.5t-66 22.5h-160v-161h160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0412",
    unicode: "\u0412",
    horizAdvX: 688,
    d: "M653 182q0 -46 -19 -80t-52 -56.5t-77 -34t-93 -11.5h-346v710h395q37 0 67 -16t51 -41.5t32.5 -58t11.5 -66.5q0 -51 -25.5 -96t-76.5 -68q61 -18 96.5 -64t35.5 -118zM486 215q0 33 -19 56t-48 23h-189v-155h182q32 0 53 21t21 55zM230 570v-147h161q27 0 48 18t21 56 q0 35 -18.5 54t-44.5 19h-167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0413",
    horizAdvX: 529,
    d: "M519 566h-283v-566h-165v710h448v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0414",
    unicode: "\u0414",
    horizAdvX: 781,
    d: "M17 144h33q27 0 47.5 17t35.5 58t26.5 110.5t20.5 176.5l18 204h461v-566h103v-316h-158v172h-430v-172h-157v316zM495 144v422h-149l-9 -102q-11 -116 -28.5 -194t-45.5 -126h232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0415",
    unicode: "\u0415",
    horizAdvX: 602,
    d: "M570 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0416",
    unicode: "\u0416",
    horizAdvX: 1032,
    d: "M251 367l-244 343h186l194 -282h45v282h168v-282h45l194 282h186l-244 -343l267 -367h-184l-202 279h-62v-279h-168v279h-62l-202 -279h-184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0417",
    unicode: "\u0417",
    horizAdvX: 566,
    d: "M29 615q48 50 108.5 75.5t143.5 25.5q105 0 167 -46t62 -136q0 -50 -24.5 -93t-83.5 -64q66 -16 100.5 -61.5t34.5 -110.5q0 -50 -20 -89.5t-55.5 -66.5t-84 -41t-104.5 -14q-81 0 -142 23.5t-116 73.5l84 121q34 -32 73.5 -51.5t93.5 -19.5q45 0 74.5 22.5t29.5 67.5 q0 38 -27.5 64t-88.5 26h-86v114h74q57 0 86 20t29 57q0 32 -21 49.5t-65 17.5q-48 0 -85.5 -17t-70.5 -49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0418",
    unicode: "\u0418",
    horizAdvX: 763,
    d: "M236 255l334 455h122v-710h-164v444l-330 -444h-127v710h165v-455z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0419",
    unicode: "\u0419",
    horizAdvX: 763,
    d: "M590 916q0 -33 -14 -60.5t-39.5 -47t-60.5 -30.5t-78 -11t-78 11t-60.5 30.5t-39.5 47t-14 60.5h99q0 -13 7.5 -24.5t20 -20t29.5 -13.5t36 -5q36 0 62.5 18t31.5 45h98zM236 255l334 455h122v-710h-164v444l-330 -444h-127v710h165v-455z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041A",
    unicode: "\u041A",
    d: "M235 428h37l207 282h185l-255 -343l278 -367h-183l-217 279h-52v-279h-164v710h164v-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041B",
    unicode: "\u041B",
    horizAdvX: 714,
    d: "M321 464q-13 -135 -32.5 -225.5t-53.5 -145t-87 -77.5t-132 -23l-5 144q36 4 60.5 17.5t41.5 52t28.5 109.5t22.5 190l18 204h461v-710h-164v566h-148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041C",
    unicode: "\u041C",
    horizAdvX: 867,
    d: "M631 0v425l-154 -309h-88l-154 309v-425h-164v710h178l184 -371l185 371h177v-710h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041D",
    unicode: "\u041D",
    horizAdvX: 754,
    d: "M682 710v-710h-164v291h-283v-291h-164v710h164v-275h283v275h164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041E",
    unicode: "\u041E",
    horizAdvX: 760,
    d: "M379 -6q-79 0 -144 31t-111 81.5t-71.5 115.5t-25.5 134q0 70 26.5 135t74 114.5t112.5 79t142 29.5q79 0 144 -31t111 -82t71 -116t25 -132q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30zM194 354q0 -41 12 -79.5t35.5 -68.5t58.5 -48t80 -18q47 0 82 19t58 49.5 t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u041F",
    horizAdvX: 739,
    d: "M71 710h597v-710h-164v566h-268v-566h-165v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0420",
    unicode: "\u0420",
    horizAdvX: 626,
    d: "M71 0v710h303q51 0 93.5 -21t73 -55t48 -77t17.5 -87q0 -47 -16.5 -90t-46 -77t-71.5 -54t-93 -20h-144v-229h-164zM235 372h134q29 0 50 25t21 73q0 25 -6.5 43t-17.5 30t-25 17.5t-28 5.5h-128v-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0421",
    unicode: "\u0421",
    horizAdvX: 688,
    d: "M27 361q0 64 24 127.5t70 113.5t112 81t150 31q100 0 173.5 -43t109.5 -112l-126 -88q-12 28 -30.5 46.5t-40.5 30t-45 16t-45 4.5q-47 0 -82 -19t-58 -49t-34 -68t-11 -77q0 -42 13 -81t37.5 -69t59 -47.5t77.5 -17.5q22 0 45.5 5.5t45 17t39.5 30t29 45.5l134 -79 q-16 -39 -47.5 -70t-72.5 -52t-87 -32t-90 -11q-77 0 -141.5 31.5t-111 83.5t-72 118t-25.5 134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0422",
    unicode: "\u0422",
    horizAdvX: 621,
    d: "M609 566h-216v-566h-164v566h-217v144h597v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0423",
    unicode: "\u0423",
    horizAdvX: 643,
    d: "M204 -7q-11 0 -26 2t-30.5 5.5t-30.5 9.5t-27 15l29 135q8 -5 27 -15t42 -10q26 0 44 14t29 46l-262 515h180l156 -352l144 352h173l-250 -540q-22 -48 -42.5 -81.5t-43.5 -54.5t-50 -31t-62 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u0424",
    horizAdvX: 804,
    d: "M325 53q-77 9 -134 34.5t-95 66t-56.5 94t-18.5 117.5q0 61 18 114.5t55 94.5t94.5 68t136.5 36v96h156v-96q78 -9 135 -36.5t93.5 -68.5t54.5 -94t18 -114q0 -128 -74.5 -210.5t-226.5 -100.5v-87h-156v86zM481 204q76 14 109 55t33 107q0 68 -33.5 108t-108.5 53v-323z M325 527q-77 -13 -111.5 -52.5t-34.5 -108.5q0 -66 34 -107.5t112 -54.5v323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0425",
    unicode: "\u0425",
    horizAdvX: 651,
    d: "M171 710l155 -245l155 245h177l-246 -360l238 -350h-177l-147 235l-147 -235h-178l238 350l-246 360h178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0426",
    unicode: "\u0426",
    horizAdvX: 763,
    d: "M586 0h-514v710h164v-566h241v566h164v-566h103v-316h-158v172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0427",
    unicode: "\u0427",
    horizAdvX: 646,
    d: "M414 710h161v-710h-161v265q-30 -13 -64.5 -19.5t-89.5 -6.5q-63 0 -106 18.5t-70 51.5t-38.5 77.5t-11.5 96.5v227h161v-177q0 -73 26 -108.5t94 -35.5q32 0 57 5.5t42 15.5v300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0428",
    unicode: "\u0428",
    horizAdvX: 1007,
    d: "M936 710v-710h-865v710h165v-566h186v566h164v-566h186v566h164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0429",
    unicode: "\u0429",
    horizAdvX: 1058,
    d: "M882 0h-810v710h164v-566h186v566h164v-566h186v566h164v-566h103v-316h-157v172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042A",
    unicode: "\u042A",
    horizAdvX: 766,
    d: "M11 710h354v-243h127q57 0 103.5 -15.5t79.5 -45t51 -72.5t18 -97q0 -56 -18 -100t-50 -74.5t-77 -46.5t-100 -16h-298v574h-190v136zM365 139h114q48 0 73 26.5t25 72.5q0 42 -25 70.5t-73 28.5h-114v-198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042B",
    unicode: "\u042B",
    horizAdvX: 939,
    d: "M71 710h165v-243h126q57 0 103.5 -15.5t79.5 -45t51 -72.5t18 -97q0 -56 -17.5 -100t-50 -74.5t-77.5 -46.5t-100 -16h-298v710zM703 0v710h164v-710h-164zM236 139h113q49 0 73.5 26.5t24.5 72.5q0 42 -25 70.5t-73 28.5h-113v-198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042C",
    unicode: "\u042C",
    horizAdvX: 636,
    d: "M71 710h165v-243h126q57 0 103.5 -15.5t79.5 -45t51 -72.5t18 -97q0 -56 -17.5 -100t-50 -74.5t-77.5 -46.5t-100 -16h-298v710zM236 139h113q49 0 73.5 26.5t24.5 72.5q0 42 -25 70.5t-73 28.5h-113v-198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042D",
    unicode: "\u042D",
    horizAdvX: 696,
    d: "M316 -6q-47 0 -93.5 11t-87 32t-72.5 52t-48 70l135 79q11 -27 29 -45.5t40 -30t46 -17t47 -5.5q36 0 66.5 12t54 33.5t39 50t23.5 61.5h-251v131h247q-8 28 -22.5 53.5t-36.5 44.5t-51.5 30.5t-66.5 11.5q-23 0 -46.5 -4.5t-46 -16t-41 -30t-30.5 -46.5l-126 88 q36 69 109.5 112t176.5 43q86 0 153 -31t112.5 -81t69.5 -113.5t24 -127.5q0 -68 -25.5 -134t-72 -118t-111.5 -83.5t-144 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042E",
    unicode: "\u042E",
    horizAdvX: 1018,
    d: "M656 -6q-65 0 -120 21.5t-97 60.5t-69 93t-37 118h-97v-287h-164v710h164v-280h98q10 64 38.5 116t71.5 89.5t97.5 58t117.5 20.5q75 0 135.5 -28t104 -76.5t67 -114.5t23.5 -142q0 -81 -25 -147.5t-69 -113.5t-105.5 -72.5t-133.5 -25.5zM494 354q0 -100 41.5 -157 t121.5 -57q42 0 73 15.5t51.5 44t31 68.5t10.5 88q0 100 -43 156t-123 56q-81 0 -122 -58.5t-41 -155.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042F",
    unicode: "\u042F",
    horizAdvX: 674,
    d: "M438 0v256h-85l-158 -256h-178l172 275q-60 26 -94.5 80.5t-34.5 127.5q0 48 17.5 89t48 72t73 48.5t93.5 17.5h310v-710h-164zM438 570h-125q-16 0 -31.5 -5.5t-28 -16t-20 -27t-7.5 -38.5q0 -44 25 -65.5t60 -21.5h127v174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0430",
    unicode: "\u0430",
    horizAdvX: 587,
    d: "M204 -10q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 39 16.5 71t46.5 55t71 36t91 13q33 0 64 -5.5t54 -16.5v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q52 34 108 51t119 17q119 0 184 -56t65 -164v-135q0 -24 7.5 -33.5t26.5 -11.5v-135q-21 -5 -38 -6.5 t-31 -1.5q-45 0 -68 17.5t-29 49.5l-3 24q-35 -45 -83.5 -69t-102.5 -24zM251 105q26 0 50.5 9t40.5 24q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-44 0 -72.5 -20t-28.5 -52q0 -29 22 -47.5t56 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0431",
    unicode: "\u0431",
    horizAdvX: 618,
    d: "M318 559q-54 -11 -86.5 -45.5t-43.5 -100.5q28 35 71 55t100 20q47 0 89 -18.5t74 -51t50.5 -76t18.5 -92.5q0 -53 -18.5 -100.5t-53.5 -83t-87 -56t-118 -20.5q-136 0 -206 80.5t-70 235.5q0 93 17.5 160t52 113.5t87 74.5t123.5 43l210 43l5 -136zM203 252 q0 -58 31.5 -93t81.5 -35q49 0 80 34.5t31 90.5q0 48 -31.5 79t-81.5 31q-49 0 -80 -30t-31 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0432",
    unicode: "\u0432",
    horizAdvX: 574,
    d: "M394 525q30 0 54 -11t41 -29.5t26.5 -43t9.5 -50.5q0 -35 -18.5 -68.5t-60.5 -50.5q47 -14 74.5 -45.5t27.5 -87.5q0 -74 -54 -106.5t-148 -32.5h-289v525h337zM316 309q23 0 37 12.5t14 38.5q0 21 -13 35.5t-36 14.5h-101v-101h99zM336 115q22 0 36.5 15t14.5 38 q0 25 -14 40t-37 15h-119v-108h119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0433",
    unicode: "\u0433",
    horizAdvX: 435,
    d: "M421 389h-205v-389h-159v525h364v-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0434",
    unicode: "\u0434",
    horizAdvX: 650,
    d: "M14 139h27q23 2 38.5 11.5t26.5 33.5t18 65t14 105l18 171h391v-386h75v-280h-143v141h-327v-141h-138v280zM388 139v249h-94l-7 -59q-8 -65 -21 -110t-33 -80h155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0435",
    unicode: "\u0435",
    horizAdvX: 604,
    d: "M306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39z M417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0436",
    unicode: "\u0436",
    horizAdvX: 873,
    d: "M191 525l130 -193h34v193h164v-193h34l129 193h181l-178 -253l195 -272h-190l-132 196h-40v-196h-163v196h-39l-132 -196h-190l193 272l-177 253h181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0437",
    unicode: "\u0437",
    horizAdvX: 457,
    d: "M30 467q44 35 94.5 51.5t101.5 16.5q36 0 68.5 -8.5t57.5 -25.5t40 -43.5t15 -62.5q0 -39 -22 -71.5t-62 -40.5q56 -14 84 -49.5t28 -85.5q0 -35 -16.5 -64t-45 -50t-68 -32.5t-84.5 -11.5q-66 0 -121.5 20t-86.5 55l73 102q17 -21 47 -33t65 -12q38 0 60.5 13.5 t22.5 41.5q0 29 -22.5 44.5t-83.5 15.5h-45v83h43q47 0 70.5 16.5t23.5 42.5q0 22 -16.5 32.5t-42.5 10.5q-27 0 -58.5 -11.5t-55.5 -32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0438",
    unicode: "\u0438",
    horizAdvX: 617,
    d: "M216 229l229 296h115v-525h-160v287l-226 -287h-117v525h159v-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0439",
    unicode: "\u0439",
    horizAdvX: 617,
    d: "M489 730q-1 -67 -48 -107t-123 -40t-123 40t-49 107h85q1 -35 23 -56t64 -21q40 0 61.5 20t24.5 57h85zM216 229l229 296h115v-525h-160v287l-226 -287h-117v525h159v-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u043A",
    horizAdvX: 561,
    d: "M384 525h171l-205 -254l222 -271h-184l-152 187h-21v-187h-158v525h158v-197h18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043B",
    unicode: "\u043B",
    horizAdvX: 584,
    d: "M10 138q27 1 44.5 9.5t29 32t19 65t15.5 109.5l18 171h392v-525h-160v388h-93l-8 -59q-13 -97 -30.5 -160.5t-46 -101.5t-71 -54t-105.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043C",
    unicode: "\u043C",
    horizAdvX: 731,
    d: "M366 276l143 249h165v-525h-152v285l-121 -209h-71l-121 209v-285h-152v525h166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043D",
    unicode: "\u043D",
    horizAdvX: 609,
    d: "M216 338h177v187h159v-525h-159v200h-177v-200h-159v525h159v-187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043E",
    unicode: "\u043E",
    horizAdvX: 610,
    d: "M305 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5t18.5 103.5t54.5 87t88.5 60t119.5 22.5t119 -22.5t88 -60t55 -87t19 -103.5t-18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22zM188 262q0 -62 33 -99.5t84 -37.5q25 0 46 10t36.5 28t24.5 43.5t9 55.5 q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043F",
    unicode: "\u043F",
    horizAdvX: 594,
    d: "M537 0h-159v386h-162v-386h-159v525h480v-525z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0440",
    unicode: "\u0440",
    horizAdvX: 641,
    d: "M389 -10q-60 0 -104 25t-68 70v-298h-160v738h139v-85q29 45 72.5 70t103.5 25q53 0 97.5 -21t77 -57.5t51 -86t18.5 -106.5q0 -59 -17 -109t-47 -86.5t-72 -57.5t-91 -21zM335 125q26 0 47.5 11.5t37.5 30.5t24.5 44.5t8.5 53.5q0 29 -9.5 53.5t-26 42.5t-40 28 t-50.5 10q-33 0 -63.5 -19.5t-46.5 -52.5v-108q16 -40 48.5 -67t69.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0441",
    unicode: "\u0441",
    horizAdvX: 570,
    d: "M24 263q0 54 19 103.5t55 87t88.5 59.5t119.5 22q91 0 153 -38.5t93 -100.5l-156 -47q-31 50 -91 50q-50 0 -83.5 -37t-33.5 -99q0 -31 9 -56.5t25 -43.5t37.5 -28t45.5 -10q30 0 55 14.5t37 37.5l156 -48q-29 -61 -92.5 -100t-154.5 -39q-66 0 -118.5 22.5t-89 60 t-55.5 87t-19 103.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0442",
    unicode: "\u0442",
    horizAdvX: 503,
    d: "M332 0h-159v386h-158v139h474v-139h-157v-386z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0443",
    unicode: "\u0443",
    horizAdvX: 552,
    d: "M80 -79q17 -8 32.5 -10.5t26.5 -2.5q23 0 38.5 19.5t24.5 72.5l-200 525h165l122 -388l105 388h150l-193 -591q-28 -85 -77 -125t-118 -40q-20 0 -39.5 3.5t-36.5 11.5v137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u0444",
    horizAdvX: 739,
    d: "M452 529q130 -18 196.5 -90.5t66.5 -177.5q0 -109 -67.5 -178.5t-195.5 -86.5v-209h-160v208q-131 15 -199.5 84.5t-68.5 181.5q0 53 17 98.5t50.5 80.5t84 58t116.5 32v200h160v-201zM292 403q-61 -12 -87.5 -47.5t-26.5 -92.5q0 -58 25.5 -94t88.5 -49v283zM452 122 q59 13 84 49t25 92t-25.5 91t-83.5 48v-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0445",
    unicode: "\u0445",
    horizAdvX: 542,
    d: "M166 525l95 -148l10 -19l10 19l94 148h164l-182 -263l186 -262h-164l-99 147l-9 19l-9 -19l-99 -147h-164l186 262l-182 263h163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0446",
    unicode: "\u0446",
    horizAdvX: 625,
    d: "M57 525h159v-386h146v386h160v-386h81v-280h-143v141h-403v525z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0447",
    unicode: "\u0447",
    horizAdvX: 530,
    d: "M473 0h-156v176q-25 -9 -49.5 -14t-55.5 -5q-43 0 -77 14t-57.5 38.5t-36 58t-12.5 71.5v186h152v-163q0 -43 18 -62.5t54 -19.5q38 0 64 17v228h156v-525z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0448",
    unicode: "\u0448",
    horizAdvX: 860,
    d: "M57 0v525h159v-386h134v386h160v-386h133v386h160v-525h-746z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0449",
    unicode: "\u0449",
    horizAdvX: 907,
    d: "M57 525h159v-386h134v386h160v-386h133v386h160v-386h82v-280h-144v141h-684v525z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044A",
    unicode: "\u044A",
    horizAdvX: 633,
    d: "M303 367h105q47 0 86 -12.5t66.5 -35.5t42.5 -56.5t15 -75.5q0 -44 -14.5 -78.5t-41 -58.5t-64 -37t-83.5 -13h-271v394h-130v131h289v-158zM393 123q29 0 45.5 15.5t16.5 44.5t-17 45.5t-45 16.5h-90v-122h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044B",
    unicode: "\u044B",
    horizAdvX: 786,
    d: "M57 525h159v-158h83q48 0 86.5 -12.5t66.5 -35.5t43 -56.5t15 -75.5q0 -44 -14.5 -78.5t-41 -58.5t-64 -37t-83.5 -13h-250v525zM570 525h159v-525h-159v525zM285 123q29 0 45.5 15.5t16.5 44.5t-17 45.5t-45 16.5h-69v-122h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044C",
    unicode: "\u044C",
    horizAdvX: 546,
    d: "M57 525h159v-158h104q48 0 86.5 -12.5t66.5 -35.5t43 -56.5t15 -75.5q0 -44 -14.5 -78.5t-41 -58.5t-64 -37t-83.5 -13h-271v525zM306 123q29 0 46 15.5t17 44.5t-17.5 45.5t-45.5 16.5h-90v-122h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044D",
    unicode: "\u044D",
    horizAdvX: 557,
    d: "M253 -10q-39 0 -75.5 8.5t-68 24.5t-56 39t-39.5 52l120 71q18 -31 51 -47t65 -16q41 0 71 24.5t41 65.5h-164v99h166q-13 42 -45.5 67t-76.5 25q-30 0 -61 -13.5t-51 -44.5l-109 73q29 52 88.5 84.5t138.5 32.5q66 0 119 -23t90 -61t57 -86.5t20 -99.5 q0 -53 -20.5 -102.5t-57.5 -87.5t-89 -61.5t-114 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044E",
    unicode: "\u044E",
    horizAdvX: 808,
    d: "M284 337q10 46 32.5 82.5t54.5 62t72.5 39.5t87.5 14q57 0 103.5 -20t79.5 -56.5t51 -87.5t18 -112q0 -64 -19 -114t-53 -84.5t-80 -52.5t-101 -18q-100 0 -165 56.5t-83 151.5h-66v-198h-160v525h160v-188h68zM429 262q0 -67 27.5 -99.5t72.5 -32.5q47 0 74 33.5 t27 100.5t-27.5 99t-72.5 32q-47 0 -74 -33.5t-27 -99.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044F",
    unicode: "\u044F",
    horizAdvX: 562,
    d: "M150 196q-48 16 -74.5 53t-26.5 99q0 42 14.5 75t40.5 56t61 35.5t77 12.5h263v-527h-159v171h-54l-106 -171h-170zM346 287v117h-81q-21 0 -37.5 -15.5t-16.5 -43.5q0 -27 15.5 -42.5t38.5 -15.5h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0450",
    unicode: "\u0450",
    horizAdvX: 604,
    d: "M306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39z M417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226zM163 731h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0451",
    unicode: "\u0451",
    horizAdvX: 604,
    d: "M134 594v129h132v-129h-132zM344 594v129h132v-129h-132zM306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5 q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39zM417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0452",
    unicode: "\u0452",
    horizAdvX: 617,
    d: "M563 3q0 -45 -14.5 -82.5t-40 -65t-61.5 -42.5t-78 -15q-39 0 -75 13t-64 37l67 109q9 -10 23 -15.5t29 -5.5q24 0 39 15t15 40v252q0 51 -20 75t-52 24q-38 0 -69 -33.5t-45 -87.5v-221h-160v550h-78v96h78v84h160v-84h210v-96h-210v-183q27 55 74.5 85t107.5 30 q51 0 83 -17.5t50 -45.5t24.5 -63.5t6.5 -71.5v-281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0453",
    unicode: "\u0453",
    horizAdvX: 436,
    d: "M284 572l-102 28l52 130h145zM421 389h-205v-389h-159v525h364v-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0454",
    unicode: "\u0454",
    horizAdvX: 558,
    d: "M305 -10q-62 0 -114 21.5t-89.5 58.5t-58 87t-20.5 108q0 54 20 102.5t57 86t90.5 59.5t119.5 22q78 0 138.5 -32.5t89.5 -84.5l-119 -83q-16 35 -49 51.5t-61 16.5q-23 0 -42 -8t-33.5 -20.5t-24.5 -29t-16 -34.5h166v-99h-164q11 -38 41 -64t72 -26q30 0 61.5 17.5 t45.5 49.5l129 -75q-12 -29 -37.5 -52t-58.5 -39t-70 -24.5t-73 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0455",
    unicode: "\u0455",
    horizAdvX: 499,
    d: "M262 -10q-67 0 -132 21.5t-110 62.5l57 98q48 -33 93.5 -51t87.5 -18q31 0 48 11t17 32t-21.5 33.5t-75.5 26.5q-53 15 -89.5 29t-59.5 31t-33 39t-10 52q0 40 16 73t44 56t66.5 36t83.5 13q59 0 110.5 -16t99.5 -58l-62 -96q-45 31 -80 45t-68 14q-26 0 -44 -10.5 t-18 -33.5q0 -22 19.5 -33t72.5 -24q56 -15 94.5 -30t62.5 -33.5t35 -42.5t11 -57q0 -78 -58 -124t-157 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0456",
    unicode: "\u0456",
    horizAdvX: 274,
    d: "M57 0v525h160v-525h-160zM57 585v145h160v-145h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0457",
    unicode: "\u0457",
    horizAdvX: 274,
    d: "M-34 594v129h132v-129h-132zM176 594v129h132v-129h-132zM57 0v525h160v-525h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0458",
    unicode: "\u0458",
    horizAdvX: 278,
    d: "M29 -202q-40 0 -76 12.5t-65 37.5l67 109q11 -11 25 -16t29 -5q23 0 38 15t15 40v534h160v-522q0 -45 -14.5 -83t-40.5 -65t-61.5 -42t-76.5 -15zM62 585v145h160v-145h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0459",
    unicode: "\u0459",
    horizAdvX: 842,
    d: "M10 138q27 1 44.5 9.5t29 32t19 65t15.5 109.5l19 171h391v-180h92q46 0 83.5 -11.5t64 -33.5t41 -53.5t14.5 -70.5q0 -84 -52.5 -130t-141.5 -46h-260v388h-94l-7 -59q-12 -98 -29 -161.5t-46 -101t-72 -53.5t-106 -17zM603 124q26 0 40 13t14 38q0 24 -14.5 37.5 t-38.5 13.5h-76v-102h75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045A",
    unicode: "\u045A",
    horizAdvX: 866,
    d: "M57 525h159v-185h179v185h160v-180h90q92 0 146.5 -45t54.5 -124q0 -84 -52 -130t-142 -46h-257v201h-179v-201h-159v525zM628 124q26 0 40 13t14 38q0 24 -14.5 37.5t-39.5 13.5h-73v-102h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045B",
    unicode: "\u045B",
    horizAdvX: 616,
    d: "M403 243q0 51 -20 75t-52 24q-38 0 -69 -32.5t-45 -87.5v-222h-160v550h-78v96h78v84h160v-84h210v-96h-210v-182q26 54 73.5 84t107.5 30q51 0 83.5 -17.5t50.5 -45.5t24.5 -63.5t6.5 -71.5v-284h-160v243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045C",
    unicode: "\u045C",
    horizAdvX: 561,
    d: "M336 572l-102 28l52 130h145zM384 525h171l-205 -254l222 -271h-184l-152 187h-21v-187h-158v525h158v-197h18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045D",
    unicode: "\u045D",
    horizAdvX: 610,
    d: "M216 229l229 296h115v-525h-160v287l-226 -287h-117v525h159v-296zM176 731h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045E",
    unicode: "\u045E",
    horizAdvX: 552,
    d: "M87 -86q17 -4 30.5 -5.5t22.5 -1.5q11 0 19.5 3.5t16 13t14 28t12.5 48.5l-200 525h165l122 -388l105 388h150l-201 -610q-23 -72 -70.5 -109t-116.5 -37q-16 0 -34 2t-35 7v136zM460 730q-1 -67 -48 -107t-123 -40t-123 40t-49 107h85q1 -35 23 -56t64 -21q40 0 61.5 20 t24.5 57h85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045F",
    unicode: "\u045F",
    horizAdvX: 586,
    d: "M219 0h-162v525h159v-386h154v386h159v-525h-163v-141h-147v141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0490",
    unicode: "\u0490",
    horizAdvX: 528,
    d: "M71 710h305l7 165h135v-309h-283v-566h-164v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0491",
    unicode: "\u0491",
    horizAdvX: 436,
    d: "M57 525h224l10 141h130v-278h-205v-388h-159v525z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B0",
    unicode: "\u04B0",
    horizAdvX: 638,
    d: "M564 230v-103h-164v-127h-163v127h-163v103h163v14l-249 466h178l153 -326l155 326h178l-252 -466v-14h164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B1",
    unicode: "\u04B1",
    horizAdvX: 540,
    d: "M197 0h-137v102h127v4l-191 419h171l103 -287l110 287h164l-193 -419v-4h128v-102h-138v-213h-144v213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 716,
    d: "M271 -204v137h144v-137h-144zM68 0v710h265q88 0 154 -28t110.5 -76t67 -112.5t22.5 -137.5q0 -81 -25 -146.5t-71.5 -112t-112 -72t-145.5 -25.5h-265zM520 356q0 47 -12.5 85.5t-36.5 66.5t-59 43t-79 15h-101v-422h101q45 0 80 16t58.5 44.5t36 67t12.5 84.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    horizAdvX: 654,
    d: "M267 -204v137h144v-137h-144zM273 -10q-54 0 -99.5 20.5t-78.5 57.5t-51.5 86.5t-18.5 108.5q0 57 17 107t48 86.5t73.5 57.5t93.5 21q55 0 99.5 -26t68.5 -70v291h160v-550q0 -24 7.5 -33.5t26.5 -11.5v-135q-22 -5 -38 -6.5t-30 -1.5q-42 0 -68 17.5t-30 50.5l-3 27 q-28 -49 -75.5 -73t-101.5 -24zM316 125q33 0 63.5 19.5t46.5 53.5v110q-15 40 -48.5 65.5t-69.5 25.5q-26 0 -47.5 -11.5t-37.5 -30.5t-24.5 -44t-8.5 -53q0 -29 9.5 -54t26 -43t40 -28t50.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 747,
    d: "M679 710v-710h-164v291h-283v-291h-164v710h164v-275h283v275h164zM300 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 612,
    d: "M561 0h-160v295q0 51 -20 75t-55 24q-14 0 -30.5 -6.5t-32 -19t-28.5 -29.5t-20 -38v-301h-160v730h160v-293q29 47 76.5 72.5t104.5 25.5q53 0 85.5 -18.5t50 -47t23.5 -64t6 -69.5v-336zM236 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 759,
    d: "M306 777v137h144v-137h-144zM232 406v-406h-164v710h128l331 -417v417h164v-710h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 612,
    d: "M252 593v137h144v-137h-144zM561 0h-160v295q0 52 -19.5 75.5t-51.5 23.5q-17 0 -34 -7t-33 -19.5t-28.5 -29.5t-19.5 -37v-301h-160v525h144v-88q29 47 82 72.5t122 25.5q51 0 82 -18.5t48 -48t22.5 -64.5t5.5 -68v-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    d: "M68 0v710h320q50 0 92.5 -21t73.5 -55t48.5 -77t17.5 -87q0 -33 -8 -63.5t-23 -57.5t-36.5 -48.5t-48.5 -36.5l156 -264h-185l-136 229h-107v-229h-164zM232 372h150q29 0 50 27.5t21 70.5q0 44 -24 70t-52 26h-145v-194zM268 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 400,
    d: "M388 388q-58 -1 -105 -19t-68 -54v-315h-160v525h147v-106q27 53 69.5 83t90.5 31h16t10 -1v-144zM63 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 615,
    d: "M494 502q-3 4 -21 15t-45 23t-59 21t-64 9q-88 0 -88 -59q0 -18 9.5 -30t28 -21.5t46.5 -17.5t65 -18q51 -14 92 -30.5t69.5 -41t44 -59.5t15.5 -84q0 -60 -22.5 -101.5t-59.5 -67t-85 -37t-99 -11.5q-39 0 -80 6t-80 17.5t-75.5 27.5t-67.5 37l72 143q4 -5 26 -19 t54.5 -28t72.5 -25t81 -11q87 0 87 53q0 20 -13 33t-36 23.5t-54.5 19.5t-68.5 20q-49 15 -85 32.5t-59.5 40.5t-35 53t-11.5 70q0 56 21 99t57 72.5t83.5 44.5t100.5 15q37 0 73 -7t69 -18t61.5 -25t52.5 -28zM232 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 499,
    d: "M262 -10q-67 0 -132 21.5t-110 62.5l57 98q48 -33 93.5 -51t87.5 -18q31 0 48 11t17 32t-21.5 33.5t-75.5 26.5q-53 15 -89.5 29t-59.5 31t-33 39t-10 52q0 40 16 73t44 56t66.5 36t83.5 13q59 0 110.5 -16t99.5 -58l-62 -96q-45 31 -80 45t-68 14q-26 0 -44 -10.5 t-18 -33.5q0 -22 19.5 -33t72.5 -24q56 -15 94.5 -30t62.5 -33.5t35 -42.5t11 -57q0 -78 -58 -124t-157 -46zM178 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 621,
    d: "M236 -204v137h144v-137h-144zM609 566h-216v-566h-164v566h-217v144h597v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 402,
    d: "M157 -204v137h144v-137h-144zM395 28q-33 -14 -75.5 -26t-85.5 -12q-30 0 -56.5 7.5t-46.5 24t-31.5 43.5t-11.5 65v274h-67v121h67v167h160v-167h107v-121h-107v-219q0 -26 13 -37.5t33 -11.5q18 0 37 6t33 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1055,
    d: "M304 709h151l72 -227l72 227h152l-119 -330l72 -191l178 522h179l-284 -710h-137l-113 278l-112 -278h-138l-283 710h178l179 -522l70 191zM386 916h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 850,
    d: "M702 525h152l-217 -525h-131l-81 216l-81 -216h-131l-217 525h151l143 -377l49 143l-93 234h128l51 -158l50 158h128l-92 -234l49 -143zM284 731h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1055,
    d: "M573 757l-102 28l52 130h145zM304 709h151l72 -227l72 227h152l-119 -330l72 -191l178 522h179l-284 -710h-137l-113 278l-112 -278h-138l-283 710h178l179 -522l70 191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 850,
    d: "M471 572l-102 28l52 130h145zM702 525h152l-217 -525h-131l-81 216l-81 -216h-131l-217 525h151l143 -377l49 143l-93 234h128l51 -158l50 158h128l-92 -234l49 -143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1055,
    d: "M356 779v129h132v-129h-132zM566 779v129h132v-129h-132zM304 709h151l72 -227l72 227h152l-119 -330l72 -191l178 522h179l-284 -710h-137l-113 278l-112 -278h-138l-283 710h178l179 -522l70 191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 850,
    d: "M254 594v129h132v-129h-132zM464 594v129h132v-129h-132zM702 525h152l-217 -525h-131l-81 216l-81 -216h-131l-217 525h151l143 -377l49 143l-93 234h128l51 -158l50 158h128l-92 -234l49 -143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 625,
    d: "M28 123l370 443h-356v144h545v-123l-352 -443h356v-144h-563v123zM244 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 494,
    d: "M24 96l268 318h-254v111h421v-96l-266 -318h273v-111h-442v96zM173 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    horizAdvX: 599,
    d: "M567 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335zM246 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    horizAdvX: 604,
    d: "M306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39z M417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226zM228 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    horizAdvX: 599,
    d: "M567 144v-144h-499v710h490v-144h-326v-138h280v-133h-280v-151h335zM385 773q-23 0 -40.5 7t-32.5 16t-29 16t-31 7t-26 -7t-14 -16t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5q17 0 27.5 7.5t16 16.5 t7 17t1.5 9h86q0 -8 -7 -31t-22.5 -48t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    horizAdvX: 604,
    d: "M306 -10q-66 0 -118.5 21.5t-89 58.5t-55.5 85.5t-19 101.5q0 57 19 107.5t55 88.5t88.5 60t119.5 22t119 -22t88 -59.5t54.5 -86.5t18.5 -103q0 -14 -1 -27.5t-3 -23.5h-388q4 -53 38.5 -80.5t78.5 -27.5q35 0 67.5 17t43.5 46l136 -38q-31 -62 -96 -101t-156 -39z M417 312q-5 50 -36 79t-77 29q-47 0 -77.5 -29.5t-35.5 -78.5h226zM368 588q-23 0 -40.5 7t-32.5 16t-29 16t-31 7t-26 -7t-14 -16t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5q17 0 27.5 7.5t16 16.5t7 17 t1.5 9h86q0 -8 -7 -31t-22.5 -48t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 300,
    d: "M68 0v710h164v-710h-164zM76 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 270,
    d: "M55 0v525h160v-525h-160zM55 585v145h160v-145h-160zM61 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 760,
    d: "M306 -204v137h144v-137h-144zM379 -6q-79 0 -144 31t-111 81.5t-71.5 115.5t-25.5 134q0 70 26.5 135t74 114.5t112.5 79t142 29.5q79 0 144 -31t111 -82t71 -116t25 -132q0 -70 -26.5 -135t-73.5 -114.5t-112 -79.5t-142 -30zM194 354q0 -41 12 -79.5t35.5 -68.5 t58.5 -48t80 -18q47 0 82 19t58 49.5t34.5 69t11.5 78.5q0 41 -12 79.5t-36 68t-58.5 47t-79.5 17.5q-47 0 -81.5 -18.5t-58 -48.5t-35 -68.5t-11.5 -78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    horizAdvX: 610,
    d: "M233 -204v137h144v-137h-144zM305 -10q-67 0 -119.5 22t-88.5 59.5t-54.5 87t-18.5 103.5t18.5 103.5t54.5 87t88.5 60t119.5 22.5t119 -22.5t88 -60t55 -87t19 -103.5t-18.5 -103.5t-54.5 -87t-88.5 -59.5t-119.5 -22zM188 262q0 -62 33 -99.5t84 -37.5q25 0 46 10 t36.5 28t24.5 43.5t9 55.5q0 62 -33 99.5t-83 37.5q-25 0 -46.5 -10t-37 -28t-24.5 -43.5t-9 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 747,
    d: "M373 140q42 0 71 17.5t47 46.5t25.5 66.5t7.5 76.5v363h164v-363q0 -74 -18.5 -138t-57 -112t-98 -75.5t-141.5 -27.5q-85 0 -145 29t-97.5 77.5t-55 112.5t-17.5 134v363h164v-363q0 -41 8 -78t26 -66t46.5 -46t70.5 -17zM299 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 627,
    d: "M214 -10q-81 0 -122.5 50.5t-41.5 148.5v336h160v-301q0 -48 19 -73.5t54 -25.5q32 0 62 17t53 59v324h160v-345q0 -24 7.5 -33.5t26.5 -11.5v-135q-23 -5 -39 -6.5t-29 -1.5q-86 0 -98 67l-3 32q-36 -52 -89.5 -76.5t-119.5 -24.5zM230 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 663,
    d: "M178 710l153 -326l155 326h179l-253 -468v-242h-163v244l-249 466h178zM189 916h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 552,
    d: "M59 -79q20 -7 37.5 -10t31.5 -3q29 0 45 20t29 72l-200 525h165l122 -388l105 388h150l-200 -610q-21 -65 -75 -105.5t-128 -40.5q-20 0 -40.5 3.5t-41.5 11.5v137zM148 731h145l52 -130l-101 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 663,
    d: "M178 710l153 -326l155 326h179l-253 -468v-242h-163v244l-249 466h178zM394 773q-23 0 -40.5 7t-32.5 16t-29 16t-31 7t-26 -7t-14 -16t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5q17 0 27.5 7.5 t16 16.5t7 17t1.5 9h86q0 -8 -7 -31t-22.5 -48t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 552,
    d: "M59 -79q20 -7 37.5 -10t31.5 -3q29 0 45 20t29 72l-200 525h165l122 -388l105 388h150l-200 -610q-21 -65 -75 -105.5t-128 -40.5q-20 0 -40.5 3.5t-41.5 11.5v137zM353 588q-23 0 -40.5 7t-32.5 16t-29 16t-31 7t-26 -7t-14 -16t-6 -16.5t-1 -8.5h-86q0 11 6.5 34.5 t21.5 47.5t39.5 42t59.5 18q24 0 41 -7.5t31.5 -16.5t28.5 -16.5t32 -7.5q17 0 27.5 7.5t16 16.5t7 17t1.5 9h86q0 -8 -7 -31t-22.5 -48t-40.5 -44t-62 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 611
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 934
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 615,
    d: "M54 203v144h507v-144h-507z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 937,
    d: "M54 203v144h829v-144h-829z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 268,
    d: "M195 730l-24 -126h45v-147h-163v150l38 123h104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 258,
    d: "M70 467l24 126h-45v147h163v-150l-38 -123h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 272,
    d: "M75 -140l25 140h-46v163h164v-167l-39 -136h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 484,
    d: "M195 730l-24 -126h45v-147h-163v150l38 123h104zM411 730l-24 -126h45v-147h-163v150l38 123h104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 474,
    d: "M70 467l24 126h-45v147h163v-150l-38 -123h-104zM286 467l24 126h-45v147h163v-150l-38 -123h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 480,
    d: "M75 -140l25 140h-46v163h164v-167l-39 -136h-104zM283 -140l25 140h-46v163h163v-167l-38 -136h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 483,
    d: "M166 -130v329h-132v144h132v432h152v-432h131v-144h-131v-329h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 503,
    d: "M176 -130v209h-132v144h132v112h-132v144h132v296h152v-296h131v-144h-131v-112h131v-144h-131v-209h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 367,
    d: "M293 351q0 -23 -8.5 -43t-23.5 -35t-35 -23.5t-43 -8.5t-43 8.5t-35 23.5t-23.5 35t-8.5 43q0 22 8.5 42t23.5 35t35 24t43 9t43 -9t35 -24t23.5 -35t8.5 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 658,
    d: "M54 0v163h131v-163h-131zM264 0v163h130v-163h-130zM473 0v163h130v-163h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1210,
    d: "M209 411q-36 0 -67 12t-54.5 33t-36.5 49.5t-13 60.5t13 60t36.5 49t54.5 33t67 12t67 -12t54.5 -33t36.5 -49t13 -60t-13 -60.5t-36.5 -49.5t-54.5 -33t-67 -12zM209 489q25 0 42.5 22.5t17.5 54.5t-18 54t-42 22q-25 0 -42.5 -22.5t-17.5 -53.5q0 -32 18 -54.5 t42 -22.5zM615 -10q-36 0 -67 12t-54.5 33t-36.5 49t-13 60t13 60.5t36.5 49.5t54.5 33t67 12t67 -12t54.5 -33t36.5 -49.5t13 -60.5t-13 -60t-36.5 -49t-54.5 -33t-67 -12zM615 68q25 0 42.5 22.5t17.5 53.5q0 32 -17.5 54.5t-42.5 22.5t-42.5 -22.5t-17.5 -54.5t17.5 -54 t42.5 -22zM1008 -10q-36 0 -67 12t-54.5 33t-36.5 49t-13 60t13 60.5t36.5 49.5t54.5 33t67 12t67 -12t54.5 -33t36.5 -49.5t13 -60.5t-13 -60t-36.5 -49t-54.5 -33t-67 -12zM1008 68q25 0 42.5 22.5t17.5 53.5q0 32 -18 54.5t-42 22.5q-25 0 -43 -22.5t-18 -54.5t18 -54 t43 -22zM107 56l282 324l256 339l72 -64l-273 -316l-266 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 360,
    d: "M33 293l270 193v-129l-144 -98l144 -91v-129l-270 178v76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 360,
    d: "M327 217l-270 -178v129l144 91l-144 98v129l270 -193v-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 219,
    d: "M-196 56l282 324l256 339l72 -64l-273 -316l-266 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 498,
    d: "M250 381q-55 0 -96.5 20.5t-69 52t-41.5 70.5t-14 75q0 39 15.5 78t44 70t69.5 50.5t92 19.5q54 0 95 -21t68.5 -53t41.5 -70.5t14 -73.5q0 -39 -15 -78t-43.5 -70t-69 -50.5t-91.5 -19.5zM125 599q0 -22 7.5 -44t23 -40t39 -29.5t55.5 -11.5t55.5 12t38.5 31t22.5 40.5 t7.5 41.5q0 22 -8 44t-23.5 40t-39 29.5t-53.5 11.5q-33 0 -56.5 -12t-39 -30.5t-22.5 -40.5t-7 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 420,
    d: "M238 388v88h-218v91l247 251h64v-251h62v-91h-62v-88h-93zM108 567h134v139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 403,
    d: "M209 668q36 0 66.5 -10.5t53 -29t35.5 -44t13 -55.5q0 -33 -14 -60t-39 -46.5t-60 -30.5t-76 -11q-54 0 -98 19t-67 52l54 63q20 -20 50 -32t67 -12t62.5 15t25.5 47q0 17 -7.5 29.5t-19 20.5t-25.5 11.5t-27 3.5q-25 0 -50 -12t-36 -32h-82q6 31 14 65t16.5 68.5t16 68 t12.5 62.5h250v-93h-182l-21 -71q9 5 26 9.5t42 4.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 432,
    d: "M405 528q0 -32 -14.5 -59.5t-39.5 -47.5t-59 -32t-74 -12q-87 0 -136.5 54t-49.5 153q0 111 53 172t146 61q46 0 86.5 -15.5t67.5 -46.5l-54 -65q-16 18 -44 28t-60 10q-49 0 -78.5 -23t-30.5 -66q16 16 46 23.5t59 7.5q40 0 73.5 -11t57.5 -30t37.5 -45t13.5 -56z M220 463q19 0 37 5t31 14t21 20.5t8 24.5q0 26 -28.5 44t-68.5 18q-42 0 -70 -17.5t-28 -43.5q0 -13 8 -25t21.5 -21t31 -14t37.5 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 402,
    d: "M258 725h-234v93h380l-253 -430h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 429,
    d: "M399 515q0 -29 -15 -53.5t-40 -42.5t-59 -28t-71 -10q-38 0 -71.5 10.5t-58.5 28.5t-39.5 43t-14.5 54q0 39 24.5 62t57.5 38q-26 11 -46 30.5t-20 50.5q0 26 15 48t39 37.5t54 24.5t60 9t60 -8.5t54.5 -24t39.5 -37.5t15 -48q0 -29 -19 -50t-47 -32q35 -16 58.5 -40.5 t23.5 -61.5zM305 525q0 12 -8 21t-20.5 15.5t-29 10t-33.5 3.5q-36 0 -63 -13.5t-27 -36.5q0 -12 8 -21t21 -16t29 -10.5t33 -3.5t33.5 3.5t29 10.5t20 16.5t7.5 20.5zM139 689q0 -18 24 -28t51 -10t51.5 10t24.5 28t-23 28t-53 10t-52.5 -10.5t-22.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 432,
    d: "M27 666q0 32 14 59.5t39 48t59 32t74 11.5q87 0 137 -54t50 -153q0 -111 -53 -172t-146 -61q-47 0 -87 16t-68 47l54 65q17 -19 45 -29.5t60 -10.5q48 0 77.5 24t31.5 66q-16 -15 -46.5 -23t-59.5 -8q-40 0 -73 11t-57 30t-37.5 45t-13.5 56zM212 731q-20 0 -37.5 -5 t-30.5 -14t-20.5 -21t-7.5 -25q0 -25 28.5 -43t68.5 -18t68 18t28 43q0 13 -7.5 25t-21 21t-31 14t-37.5 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 498,
    d: "M250 -93q-55 0 -96.5 20.5t-69 52t-41.5 70.5t-14 75q0 39 15.5 78t44 70t69.5 50.5t92 19.5q54 0 95 -21t68.5 -53t41.5 -70.5t14 -73.5q0 -39 -15 -78t-43.5 -70t-69 -50.5t-91.5 -19.5zM125 125q0 -22 7.5 -44t23 -40t39 -29.5t55.5 -11.5t55.5 12t38.5 31t22.5 40.5 t7.5 41.5q0 22 -8 44t-23.5 40t-39 29.5t-53.5 11.5q-33 0 -56.5 -12t-39 -30.5t-22.5 -40.5t-7 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 350,
    d: "M333 4v-91h-285v91h99v243q-6 -7 -19.5 -16t-30 -17t-34 -13.5t-32.5 -5.5v93q19 0 39.5 9t37.5 19.5t28 20t11 10.5h94v-343h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 433,
    d: "M28 -87q0 42 6.5 73t22 54.5t41 41.5t63.5 34q24 10 47 19.5t41.5 20t30 23.5t11.5 31q0 25 -21 36t-59 11q-42 0 -72.5 -15t-48.5 -32l-59 69q19 24 69 46.5t126 22.5q83 0 126.5 -36t43.5 -103q0 -33 -12.5 -56.5t-32 -39.5t-42 -25.5t-41.5 -15.5q-86 -25 -86 -68h215 v-91h-369z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 414,
    d: "M193 -93q-63 0 -106.5 19t-60.5 57l49 70q14 -19 42.5 -35.5t73.5 -16.5q39 0 68 10.5t29 33.5q0 26 -39.5 37.5t-109.5 11.5h-24v85h24q59 0 96.5 10.5t37.5 35.5q0 10 -7.5 17t-19 11.5t-25 6.5t-25.5 2q-39 0 -65 -13t-46 -34l-60 76q12 14 30.5 24.5t41 18t48 11.5 t50.5 4q38 0 70.5 -9t56 -25t37 -37.5t13.5 -46.5q0 -35 -25.5 -58.5t-70.5 -30.5q50 -7 78 -38.5t28 -72.5q0 -33 -16 -56.5t-42.5 -38.5t-60.5 -22t-70 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 419,
    d: "M238 -86v88h-218v91l247 251h64v-251h62v-91h-62v-88h-93zM108 93h134v138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 402,
    d: "M209 193q36 0 66.5 -10t53 -28.5t35.5 -44t13 -56.5q0 -32 -14 -59t-39.5 -46.5t-60.5 -30.5t-76 -11q-54 0 -98 19t-67 51l54 64q20 -20 50 -32t67 -12t62.5 15t25.5 47q0 17 -7.5 29t-19 20t-25.5 12t-27 4q-25 0 -50 -12t-36 -32h-81q6 31 14 65t16 68.5t16 68 t13 62.5h249v-93h-182l-21 -71q10 5 26.5 9t42.5 4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 432,
    d: "M405 57q0 -32 -14 -59t-39 -47.5t-59.5 -32t-74.5 -11.5q-86 0 -136 53.5t-50 153.5q0 111 53 172t146 61q47 0 87 -16t67 -46l-53 -66q-17 19 -45 29t-60 10q-49 0 -78 -23t-31 -66q16 15 46.5 22.5t58.5 7.5q40 0 73.5 -11t57.5 -30t37.5 -45t13.5 -56zM220 -7 q20 0 37.5 5t31 14t21 20.5t7.5 24.5q0 26 -28.5 44t-68.5 18q-20 0 -38 -5t-31.5 -13t-21 -19.5t-7.5 -24.5t8 -24.5t21.5 -20.5t31 -14t37.5 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 402,
    d: "M259 251h-235v93h380l-253 -430h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 429,
    d: "M399 41q0 -29 -15 -53.5t-40 -42.5t-59 -28t-71 -10q-38 0 -71.5 10.5t-58.5 28.5t-39.5 43t-14.5 54q0 39 24.5 61.5t57.5 38.5q-26 11 -46 30.5t-20 50.5q0 26 15 48t39 37.5t54 24.5t60 9t60 -8.5t54.5 -24t39.5 -37.5t15 -48q0 -29 -19 -50t-47 -32q35 -17 58.5 -41 t23.5 -61zM305 51q0 12 -8 21t-20.5 15.5t-29 10t-33.5 3.5q-36 0 -63 -14t-27 -36q0 -12 8 -21t21 -16t29 -10.5t33 -3.5t33.5 3.5t29 10.5t20 16.5t7.5 20.5zM139 215q0 -18 24 -28t51 -10t51.5 10t24.5 28q0 17 -23 27.5t-53 10.5t-52.5 -10.5t-22.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 432,
    d: "M27 196q0 31 14 59t39 48t59.5 32t74.5 12q86 0 136 -54.5t50 -153.5q0 -110 -52.5 -171t-145.5 -61q-47 0 -87.5 16t-67.5 46l53 65q17 -18 45 -28.5t60 -10.5q49 0 78.5 23.5t30.5 66.5q-15 -16 -46 -24t-60 -8q-40 0 -73 11t-57 30t-37.5 45.5t-13.5 56.5zM212 261 q-20 0 -37 -5t-30.5 -14t-21 -21t-7.5 -25q0 -26 28.5 -43.5t68.5 -17.5t68.5 17.5t28.5 43.5q0 13 -8 25t-21.5 21t-31 14t-37.5 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 577,
    d: "M200 9q-41 15 -73 41t-54 59.5t-33.5 72.5t-11.5 81t11.5 81t33.5 72.5t54 59t73 40.5v129h72v-112q9 1 18.5 1.5t19.5 0.5h11t11 -1v111h72v-123q54 -17 91.5 -49.5t60.5 -76.5l-156 -47q-31 50 -91 50q-49 0 -83 -37t-34 -99q0 -31 9 -56.5t25 -43.5t37.5 -28t45.5 -10 q30 0 55 14.5t37 37.5l156 -48q-21 -44 -60 -77t-93 -49v-123h-72v111q-5 -1 -11 -1h-11q-10 0 -19.5 0.5t-18.5 1.5v-112h-72v129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 608,
    d: "M107 0v91h-74v105h74v514h482v-144h-318v-153h262v-133h-262v-84h109v-105h-109v-91h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 552,
    d: "M40 445h64q-9 22 -15 44t-6 45q0 38 16.5 71t46 57.5t69 38.5t84.5 14q63 0 120.5 -27.5t97.5 -77.5l-83 -98q-25 32 -63.5 53t-73.5 21q-32 0 -52 -19t-20 -50q0 -17 6 -35t15 -37h168v-100h-127q2 -10 4 -19.5t3 -19.5h120v-100h-137q-17 -39 -60 -83q23 8 41.5 11 t35.5 3q35 0 67.5 -8t65.5 -8q17 0 33.5 3.5t36.5 10.5l39 -118q-24 -14 -56 -23t-61 -9q-23 0 -46.5 5t-48 10.5t-49 10.5t-48.5 5q-28 0 -64.5 -7t-71.5 -18l-33 114q28 20 49 46t34 55h-101v100h116q-3 22 -10 39h-106v100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 865,
    d: "M827 416h-82v-137h82v-100h-82v-179h-132l-144 179h-183v-179h-164v179h-84v100h84v137h-84v100h84v194h128l154 -194h177v194h164v-194h82v-100zM286 279h102l-102 127v-127zM581 293v123h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1158,
    d: "M42 262h180l-39 98h-141v100h101l-99 250h178l85 -250h135l-88 249h151l72 -227l72 227h152l-90 -249h135l86 250h179l-100 -250h106v-100h-146l-39 -98h185v-100h-225l-65 -162h-137l-113 278l-112 -278h-138l-65 162h-220v100zM726 262h53l33 98h-123zM375 262h53 l36 98h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 800,
    d: "M122 452q14 52 43.5 99.5t73 83.5t101 57.5t126.5 21.5q100 0 173.5 -43t109.5 -112l-126 -88q-12 28 -30.5 46.5t-40.5 30t-45 16t-45 4.5q-65 0 -106 -33.5t-61 -82.5h222l-34 -86h-206v-11q0 -10 0.5 -19t1.5 -18h208l-34 -86h-144q24 -42 63.5 -67t91.5 -25 q22 0 45.5 5.5t45 17t39.5 30t29 45.5l134 -79q-16 -39 -47.5 -70t-72.5 -52t-87 -32t-90 -11q-59 0 -110.5 19t-93 51t-73 75.5t-49.5 92.5h-100l34 86h44q-1 11 -1.5 21.5t-0.5 21.5v5h-69l34 86h47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 555,
    d: "M518 442h-102q-8 -57 -41 -104.5t-87 -73.5l178 -264h-186l-231 358h132q24 0 43.5 23t25.5 61h-209v100h192q-11 18 -26.5 28.5t-31.5 10.5h-134v129h477v-100h-146q21 -30 34 -68h112v-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 329,
    d: "M212 101q10 0 24 3.5t26 8.5l20 -99q-22 -9 -52 -15t-53 -6q-59 0 -92 29t-33 81v507q0 28 11.5 51.5t31.5 41t47.5 27.5t59.5 10q63 0 101.5 -36t38.5 -94q0 -42 -15.5 -96t-41 -109t-58.5 -105.5t-68 -85.5v-51q0 -29 14 -45.5t39 -16.5zM242 576q0 67 -39 67 q-20 0 -32 -17t-12 -44v-229q17 25 32 55t26.5 60t18 58t6.5 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1153,
    d: "M246 406v-406h-165v710h128l331 -417v417h164v-710h-132zM956 336q-45 0 -80 15.5t-59 41.5t-36.5 60t-12.5 72t12.5 72t36.5 60t59 41.5t80 15.5t80.5 -15.5t59.5 -41.5t36.5 -60t12.5 -72t-12.5 -72t-36.5 -60t-59 -41.5t-81 -15.5zM883 525q0 -42 21 -67t52 -25 q32 0 53 25t21 67t-21 67t-53 25q-31 0 -52 -25t-21 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 818,
    d: "M605 710h154v-303h-102v174l-57 -132h-83l-57 132v-174h-102v303h152l48 -145zM273 610q-26 14 -48 21.5t-45 7.5q-36 0 -36 -16q0 -9 11 -15.5t46 -13.5q66 -13 93 -34.5t27 -61.5q0 -47 -35.5 -72t-94.5 -25q-39 0 -81 11t-71 28l39 74q26 -16 55 -25.5t56 -9.5 q38 0 38 14q0 9 -13.5 15t-48.5 15q-31 8 -52 16t-34.5 18.5t-19.5 24.5t-6 32q0 46 35.5 74t92.5 28q31 0 64 -9t65 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 867,
    d: "M353 610h-95v-203h-102v203h-95v102h292v-102zM647 710h153v-303h-102v174l-57 -132h-83l-56 132v-174h-103v303h153l47 -145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 783,
    d: "M34 115h158q-69 39 -108.5 105.5t-39.5 151.5q0 68 26.5 130t73 109.5t110 75.5t137.5 28q75 0 138.5 -28t110 -75.5t72.5 -109.5t26 -130q0 -85 -39 -151.5t-108 -105.5h157v-115h-317v115q34 13 61 39.5t46 61t29 75t10 81.5q0 37 -13 72t-37 63t-58.5 45t-77.5 17 t-77.5 -17t-58.5 -45t-36.5 -63t-12.5 -72q0 -41 10 -81.5t29 -75t46 -61t60 -39.5v-115h-317v115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 613,
    d: "M312 41q72 0 121 21t79 50l33 -39q-38 -35 -95 -59t-138 -24q-63 0 -115 22t-89 59t-57 86t-20 103q0 56 20.5 106t57.5 87.5t88.5 59.5t114.5 22t115 -23t89 -62.5t57.5 -93.5t20.5 -115h-427v-137q26 -28 64.5 -45.5t80.5 -17.5zM312 483q-42 0 -80.5 -18.5 t-64.5 -54.5v-115h292v114q-27 37 -65.5 55.5t-81.5 18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 996,
    d: "M148 56l282 324l256 339l72 -64l-273 -316l-266 -348zM299 389v-92h-240v92h77v243q-5 -7 -16 -16t-24.5 -17t-27.5 -13.5t-26 -5.5v93q15 0 31.5 9t30.5 19.5t23 19.5t9 10h94v-342h69zM773 -6q-63 0 -106.5 19t-60.5 57l49 70q15 -19 43 -35.5t73 -16.5q39 0 68 10.5 t29 33.5q0 26 -39.5 37.5t-109.5 11.5h-24v85h24q59 0 96.5 10.5t37.5 35.5q0 10 -7.5 17.5t-19 11.5t-25 6t-25.5 2q-39 0 -65 -13t-46 -34l-60 76q12 14 30.5 25t41 18.5t48 11t50.5 3.5q38 0 70.5 -9t56 -25t37 -37.5t13.5 -46.5q0 -35 -25.5 -58t-70.5 -31 q50 -7 78 -38.5t28 -72.5q0 -33 -16 -56.5t-42.5 -38.5t-60.5 -22t-70 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 1032,
    d: "M41 296q0 42 6 73t21 54.5t40 42t63 34.5q24 10 47.5 19t41.5 19.5t29.5 23.5t11.5 31q0 25 -21 36t-58 11q-42 0 -72 -14.5t-48 -31.5l-58 68q9 12 26 24.5t41.5 22t56 16t68.5 6.5q83 0 126 -36t43 -103q0 -33 -12.5 -56.5t-31.5 -39.5t-41.5 -25.5t-41.5 -15.5 q-43 -13 -69 -29.5t-26 -38.5h208v-91h-350zM224 56l282 324l256 339l72 -64l-273 -316l-266 -348zM809 -6q-63 0 -106.5 19t-60.5 57l49 70q15 -19 43 -35.5t73 -16.5q39 0 68 10.5t29 33.5q0 26 -39.5 37.5t-109.5 11.5h-24v85h24q59 0 96.5 10.5t37.5 35.5 q0 10 -7.5 17.5t-19 11.5t-25 6t-25.5 2q-39 0 -65 -13t-46 -34l-60 76q12 14 30.5 25t41 18.5t48 11t50.5 3.5q38 0 70.5 -9t56 -25t37 -37.5t13.5 -46.5q0 -35 -25.5 -58t-70.5 -31q50 -7 78 -38.5t28 -72.5q0 -33 -16 -56.5t-42.5 -38.5t-60.5 -22t-70 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 992,
    d: "M161 56l282 324l256 339l72 -64l-273 -316l-266 -348zM299 389v-92h-240v92h77v243q-5 -7 -16 -16t-24.5 -17t-27.5 -13.5t-26 -5.5v93q15 0 31.5 9t30.5 19.5t23 19.5t9 10h94v-342h69zM959 128q0 -29 -15 -53.5t-40 -42.5t-59 -28t-71 -10q-38 0 -71.5 10.5t-58.5 28.5 t-39.5 43t-14.5 54q0 39 24.5 61.5t57.5 38.5q-26 11 -46 30.5t-20 50.5q0 26 15 48t39 37.5t54 24.5t60 9t60 -8.5t54.5 -24t39.5 -37.5t15 -48q0 -29 -19 -50t-47 -32q35 -17 58.5 -41t23.5 -61zM865 138q0 12 -8 21t-20.5 15.5t-29 10t-33.5 3.5q-36 0 -63 -13.5 t-27 -36.5q0 -12 8 -21t21 -16t29 -10.5t33 -3.5t33.5 3.5t29 10.5t20 16.5t7.5 20.5zM699 302q0 -18 24 -28t51 -10t51.5 10t24.5 28q0 17 -23 27.5t-53 10.5t-52.5 -10.5t-22.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 1003,
    d: "M206 289q-63 0 -106.5 19t-60.5 57l49 70q15 -19 43 -35.5t73 -16.5q39 0 68 10.5t29 33.5q0 26 -39.5 37.5t-109.5 11.5h-24v85h24q59 0 96.5 10.5t37.5 36.5q0 10 -7.5 17t-19 11.5t-25 6.5t-25.5 2q-39 0 -65 -13t-46 -34l-60 75q12 14 30.5 25t41 18.5t48 11 t50.5 3.5q38 0 70.5 -9t56 -25t37 -37.5t13.5 -46.5q0 -35 -25.5 -58t-70.5 -31q50 -7 78 -38t28 -73q0 -33 -16 -56.5t-42.5 -38.5t-60.5 -22t-70 -7zM197 56l282 324l256 339l72 -64l-273 -316l-266 -348zM969 128q0 -29 -15 -53.5t-40 -42.5t-59 -28t-71 -10 q-38 0 -71.5 10.5t-58.5 28.5t-39.5 43t-14.5 54q0 39 24.5 61.5t57.5 38.5q-26 11 -46 30.5t-20 50.5q0 26 15 48t39 37.5t54 24.5t60 9t60 -8.5t54.5 -24t39.5 -37.5t15 -48q0 -29 -19 -50t-47 -32q35 -17 58.5 -41t23.5 -61zM875 138q0 12 -8 21t-20.5 15.5t-29 10 t-33.5 3.5q-36 0 -63 -13.5t-27 -36.5q0 -12 8 -21t21 -16t29 -10.5t33 -3.5t33.5 3.5t29 10.5t20 16.5t7.5 20.5zM709 302q0 -18 24 -28t51 -10t51.5 10t24.5 28q0 17 -23 27.5t-53 10.5t-52.5 -10.5t-22.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 1020,
    d: "M220 580q36 0 66.5 -10t53 -28.5t35.5 -44t13 -55.5q0 -33 -14 -60t-39.5 -46.5t-60.5 -30.5t-76 -11q-54 0 -98 19t-67 52l54 63q20 -20 50 -32t67 -12t62.5 15t25.5 47q0 17 -7.5 29.5t-19 20.5t-25.5 11.5t-27 3.5q-25 0 -50 -12t-36 -32h-81q6 31 14 65t16 68.5 t16 68t13 62.5h249v-93h-182l-21 -71q10 5 26.5 9t42.5 4zM200 56l282 324l256 339l72 -64l-273 -316l-266 -348zM985 128q0 -29 -15 -53.5t-40 -42.5t-59 -28t-71 -10q-38 0 -71.5 10.5t-58.5 28.5t-39.5 43t-14.5 54q0 39 24.5 61.5t57.5 38.5q-26 11 -46 30.5t-20 50.5 q0 26 15 48t39 37.5t54 24.5t60 9t60 -8.5t54.5 -24t39.5 -37.5t15 -48q0 -29 -19 -50t-47 -32q35 -17 58.5 -41t23.5 -61zM891 138q0 12 -8 21t-20.5 15.5t-29 10t-33.5 3.5q-36 0 -63 -13.5t-27 -36.5q0 -12 8 -21t21 -16t29 -10.5t33 -3.5t33.5 3.5t29 10.5t20 16.5 t7.5 20.5zM725 302q0 -18 24 -28t51 -10t51.5 10t24.5 28q0 17 -23 27.5t-53 10.5t-52.5 -10.5t-22.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 958,
    d: "M104 56l282 324l256 339l72 -64l-273 -316l-266 -348zM924 128q0 -29 -15 -53.5t-40 -42.5t-59 -28t-71 -10q-38 0 -71.5 10.5t-58.5 28.5t-39.5 43t-14.5 54q0 39 24.5 61.5t57.5 38.5q-26 11 -46 30.5t-20 50.5q0 26 15 48t39 37.5t54 24.5t60 9t60 -8.5t54.5 -24 t39.5 -37.5t15 -48q0 -29 -19 -50t-47 -32q35 -17 58.5 -41t23.5 -61zM830 138q0 12 -8 21t-20.5 15.5t-29 10t-33.5 3.5q-36 0 -63 -13.5t-27 -36.5q0 -12 8 -21t21 -16t29 -10.5t33 -3.5t33.5 3.5t29 10.5t20 16.5t7.5 20.5zM664 302q0 -18 24 -28t51 -10t51.5 10t24.5 28 q0 17 -23 27.5t-53 10.5t-52.5 -10.5t-22.5 -27.5zM275 638h-234v93h380l-253 -430h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 579,
    d: "M253 -10q-51 0 -95 16t-75.5 44.5t-49.5 67.5t-18 84q0 51 22 94.5t58.5 75.5t83.5 50t98 18q83 0 119 -51v17q0 93 -29 135.5t-83 42.5q-27 0 -56 -9t-48 -25l-87 92q41 35 93 54.5t110 19.5q117 0 181.5 -83.5t64.5 -248.5q0 -92 -20.5 -165t-58 -124t-91 -78 t-119.5 -27zM264 110q22 0 42 9.5t36 25.5t25.5 37t9.5 44q0 41 -28 68t-69 27q-23 0 -43 -9t-35 -24t-24 -35t-9 -43q0 -21 7.5 -39.5t20 -32t30 -21t37.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 634,
    d: "M628 126v-126h-622v126l245 584h133zM471 144l-153 385l-149 -385h302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 724,
    d: "M457 574h-190v-664h-156v664h-80v136h661v-136h-80v-664h-155v664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 572,
    d: "M531 590h-307v-4l175 -217l-188 -229v-4h324v-136h-503v107l209 249l-202 249v105h492v-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 521,
    d: "M59 277v127h403v-127h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 629,
    d: "M-18 67l574 652l91 -75l-574 -653z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 239,
    d: "M54 240v166h131v-166h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 579,
    d: "M7 386h221l70 -274l112 678h140l-152 -790h-200l-80 276h-111v110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 733,
    d: "M212 545q31 0 54.5 -7t41.5 -18.5t32 -27t26 -32.5q12 17 26 32.5t32 27t41.5 18.5t54.5 7q40 0 72 -15.5t54.5 -42t35 -61.5t12.5 -75t-13.5 -75t-37 -61.5t-55.5 -41.5t-69 -15q-59 0 -93.5 22.5t-57.5 53.5q-11 -15 -25 -29t-32.5 -24.5t-42.5 -16.5t-56 -6 q-33 0 -64.5 15.5t-55.5 42t-39 61.5t-15 75t13.5 75t36.5 61.5t55 41.5t69 15zM226 277q18 0 31 6t23.5 15.5t19.5 23t17 28.5q-17 31 -36 53t-55 22q-24 0 -46.5 -17t-22.5 -56q0 -40 22.5 -57.5t46.5 -17.5zM506 277q25 0 46.5 17.5t21.5 57.5q0 39 -21.5 56t-46.5 17 q-36 0 -55 -23.5t-34 -55.5q16 -29 35.5 -49t53.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 381,
    d: "M93 680q-4 67 32 103.5t105 36.5q33 0 72 -8t71 -22l-25 -117q-11 6 -23.5 10t-23.5 4q-24 0 -37 -15t-11 -45l35 -654q4 -69 -32 -104.5t-105 -35.5q-33 0 -72 8t-70 22l24 117q11 -6 23.5 -10t22.5 -4q52 0 49 60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 457,
    d: "M410 370q-15 -30 -43 -55.5t-71 -25.5q-23 0 -40.5 7t-32.5 16t-29.5 16t-30.5 7q-18 0 -27.5 -7t-14.5 -17l-74 44q14 29 41 53t69 24q23 0 40 -7.5t32 -17t29 -17t32 -7.5q20 0 31 8t17 19zM410 199q-8 -14 -18.5 -28.5t-24.5 -25.5t-32 -18t-39 -7q-23 0 -40.5 7.5 t-32.5 16t-29.5 16t-30.5 7.5q-18 0 -27.5 -7.5t-14.5 -16.5l-74 44q14 29 41 52.5t69 23.5q23 0 40 -7.5t32 -16.5t29 -16.5t32 -7.5q20 0 31 7.5t17 18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 454,
    d: "M68 421h192l63 128l57 -31l-48 -97h54v-102h-104l-42 -86h146v-102h-196l-60 -123l-57 29l46 94h-51v102h101l42 86h-143v102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 482,
    d: "M46 16v127h366v-127h-366zM48 462l362 167v-154l-199 -68l199 -62v-154l-362 153v118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 482,
    d: "M70 16v127h366v-127h-366zM434 344l-362 -153v154l199 62l-199 68v154l362 -167v-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 587,
    d: "M383 729l186 -364l-186 -366h-179l-186 366l186 364h179zM426 353l-134 266l-123 -245l132 -267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 220,
    d: "M79 -213l31 67h-48v99h134v-99l-47 -67h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 886,
    d: "M878 28q-32 -14 -75 -26t-85 -12q-30 0 -56.5 7.5t-46.5 24t-31.5 43.5t-11.5 65v274h-67v121h67q0 39 -3 65.5t-11 43t-22 24t-36 7.5q-45 0 -66 -24t-21 -58q0 -32 13.5 -61.5t29.5 -46.5l-61 -101q-46 28 -82 39t-66 11q-29 0 -49 -10.5t-20 -34.5q0 -28 27 -38 t72 -19q54 -11 92 -24.5t62 -32t35 -43.5t11 -58q0 -43 -15.5 -75.5t-44 -54.5t-67.5 -33t-85 -11q-32 0 -66.5 5t-67.5 14t-63 21t-53 26l60 109q50 -30 96.5 -46t88.5 -16q31 0 51 10t20 33q0 13 -7.5 21.5t-21 14.5t-33 11t-44.5 11q-48 12 -83.5 25t-58.5 30t-34 40 t-11 56q0 43 16.5 76.5t44.5 56.5t64 35t74 12q12 0 28 -1.5t34 -5t36 -9.5t34 -15q-11 19 -16.5 38.5t-5.5 44.5q0 31 11 57.5t34.5 46.5t60 31.5t88.5 11.5q66 0 104 -14t57.5 -40.5t24.5 -65.5t5 -89h106v-121h-106v-219q0 -26 13 -37.5t33 -11.5q17 0 36 6t35 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 420,
    d: "M238 1v88h-218v91l247 251h64v-251h62v-91h-62v-88h-93zM108 180h134v138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 309,
    d: "M288 389v-92h-240v92h77v243q-5 -7 -16 -16t-24.5 -17t-27.5 -13.5t-26 -5.5v93q15 0 31.5 9t30.5 19.5t23 19.5t9 10h94v-342h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 434,
    d: "M28 0q0 42 6.5 73t22 54.5t41 42t63.5 34.5q24 10 47 19t41.5 19.5t30 23.5t11.5 31q0 25 -21 36t-59 11q-42 0 -72.5 -15t-48.5 -32l-59 69q19 24 69 46.5t126 22.5q83 0 126.5 -36t43.5 -103q0 -33 -12.5 -56.5t-32 -39.5t-42 -25.5t-41.5 -15.5q-86 -25 -86 -68h215 v-91h-369z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 414,
    d: "M193 289q-63 0 -106.5 19t-60.5 57l49 70q15 -19 43 -35.5t73 -16.5q39 0 68 10.5t29 33.5q0 26 -39.5 37.5t-109.5 11.5h-24v85h24q59 0 96.5 10.5t37.5 36.5q0 10 -7.5 17t-19 11.5t-25 6.5t-25.5 2q-39 0 -65 -13t-46 -34l-60 75q12 14 30.5 25t41 18.5t48 11 t50.5 3.5q38 0 70.5 -9t56 -25t37 -37.5t13.5 -46.5q0 -35 -25.5 -58t-70.5 -31q50 -7 78 -38t28 -73q0 -33 -16 -56.5t-42.5 -38.5t-60.5 -22t-70 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 269,
    d: "M148 572l-102 28l52 130h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 244,
    d: "M50 -204v137h144v-137h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 414,
    d: "M193 -6q-63 0 -106.5 19t-60.5 57l49 70q15 -19 43 -35.5t73 -16.5q39 0 68 10.5t29 33.5q0 26 -39.5 37.5t-109.5 11.5h-24v85h24q59 0 96.5 10.5t37.5 35.5q0 10 -7.5 17.5t-19 11.5t-25 6t-25.5 2q-39 0 -65 -13t-46 -34l-60 76q12 14 30.5 25t41 18.5t48 11t50.5 3.5 q38 0 70.5 -9t56 -25t37 -37.5t13.5 -46.5q0 -35 -25.5 -58t-70.5 -31q50 -7 78 -38.5t28 -72.5q0 -33 -16 -56.5t-42.5 -38.5t-60.5 -22t-70 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 428,
    d: "M28 296q0 42 6.5 73t21.5 54.5t40.5 42t63.5 34.5q24 10 47.5 19t42 19.5t30 23.5t11.5 31q0 25 -21 36t-59 11q-42 0 -72.5 -14.5t-48.5 -31.5l-59 68q18 24 68.5 46.5t125.5 22.5q84 0 127.5 -36t43.5 -103q0 -33 -13 -56.5t-32 -39.5t-41.5 -25.5t-41.5 -15.5 q-44 -13 -70 -29.5t-26 -38.5h210v-91h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 429,
    d: "M399 128q0 -29 -15 -53.5t-40 -42.5t-59 -28t-71 -10q-38 0 -71.5 10.5t-58.5 28.5t-39.5 43t-14.5 54q0 39 24.5 61.5t57.5 38.5q-26 11 -46 30.5t-20 50.5q0 26 15 48t39 37.5t54 24.5t60 9t60 -8.5t54.5 -24t39.5 -37.5t15 -48q0 -29 -19 -50t-47 -32q35 -17 58.5 -41 t23.5 -61zM305 138q0 12 -8 21t-20.5 15.5t-29 10t-33.5 3.5q-36 0 -63 -13.5t-27 -36.5q0 -12 8 -21t21 -16t29 -10.5t33 -3.5t33.5 3.5t29 10.5t20 16.5t7.5 20.5zM139 302q0 -18 24 -28t51 -10t51.5 10t24.5 28q0 17 -23 27.5t-53 10.5t-52.5 -10.5t-22.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 402,
    d: "M209 580q36 0 66.5 -10t53 -28.5t35.5 -44t13 -55.5q0 -33 -14 -60t-39.5 -46.5t-60.5 -30.5t-76 -11q-54 0 -98 19t-67 52l54 63q20 -20 50 -32t67 -12t62.5 15t25.5 47q0 17 -7.5 29.5t-19 20.5t-25.5 11.5t-27 3.5q-25 0 -50 -12t-36 -32h-81q6 31 14 65t16 68.5 t16 68t13 62.5h249v-93h-182l-21 -71q10 5 26.5 9t42.5 4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 402,
    d: "M258 638h-234v93h380l-253 -430h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 604,
    d: "M62 0v563h283q45 0 82.5 -17t64.5 -44t42.5 -61.5t15.5 -70.5q0 -51 -27.5 -94t-75.5 -68l145 -208h-163l-126 176h-97v-176h-144zM206 302h134q26 0 45 18t19 50t-21.5 50t-47.5 18h-129v-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 607,
    d: "M566 215q0 -51 -21 -92t-56.5 -70.5t-83.5 -45.5t-102 -16q-53 0 -100.5 16.5t-83.5 46.5t-57 72.5t-21 94.5q0 28 9 52.5t23 44.5t32 35t35 26q-33 18 -55.5 53t-22.5 74q0 49 22.5 87.5t57.5 64t77.5 39t83.5 13.5t84 -13t78.5 -38.5t58 -63.5t22.5 -87q0 -20 -6.5 -39 t-17 -36.5t-25.5 -31t-31 -22.5q18 -11 36 -27t32.5 -36.5t23 -45.5t8.5 -55zM404 225q0 21 -8.5 37.5t-22.5 27.5t-32 17t-38 6q-42 0 -71 -24t-29 -65q0 -20 8.5 -36t22.5 -27.5t32 -18t38 -6.5t38.5 6.5t32 18.5t21.5 28.5t8 35.5zM224 503q0 -18 7 -31t18.5 -21.5 t25.5 -13t28 -4.5t28.5 4.5t26 13.5t18.5 22t7 30q0 29 -23.5 47.5t-56.5 18.5t-56 -18.5t-23 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 429,
    d: "M399 428q0 -29 -15 -53.5t-40 -42.5t-59 -28t-71 -10q-38 0 -71.5 10.5t-58.5 28.5t-39.5 43t-14.5 54q0 39 24.5 61.5t57.5 38.5q-26 11 -46 30.5t-20 50.5q0 26 15 48t39 37.5t54 24.5t60 9t60 -8.5t54.5 -24t39.5 -37.5t15 -48q0 -29 -19 -50t-47 -32q35 -17 58.5 -41 t23.5 -61zM305 438q0 12 -8 21t-20.5 15.5t-29 10t-33.5 3.5q-36 0 -63 -13.5t-27 -36.5q0 -12 8 -21t21 -16t29 -10.5t33 -3.5t33.5 3.5t29 10.5t20 16.5t7.5 20.5zM139 602q0 -18 24 -28t51 -10t51.5 10t24.5 28t-23 28t-53 10t-52.5 -10.5t-22.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 536,
    d: "M427 387q-6 5 -21.5 14t-37.5 17.5t-48.5 15t-53.5 6.5q-72 0 -72 -36q0 -12 8.5 -20.5t24 -15t39 -13t53.5 -14.5q43 -12 78.5 -25.5t60 -33t38 -47t13.5 -66.5q0 -50 -19.5 -83.5t-51.5 -54t-73.5 -29.5t-84.5 -9q-68 0 -137 18.5t-123 49.5l63 125q7 -8 26 -18.5 t46 -21t59.5 -17.5t67.5 -7q71 0 71 34q0 13 -11 22t-30 16.5t-46 14t-58 15.5q-84 24 -123 60t-39 101q0 45 18 79t48.5 57t71.5 35t86 12q65 0 122 -20t97 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 268,
    d: "M62 0v563h144v-563h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 888,
    d: "M529 0l-85 275l-86 -275h-173l-179 525h165l108 -335l90 335h150l90 -335l108 335h165l-179 -525h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 553,
    d: "M544 525l-240 -738h-186l5.5 14t13.5 35t18 46t19 48.5t16.5 42.5t11.5 27l-200 525h165l122 -388l106 388h149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 537,
    d: "M504 125v-125h-442v563h434v-125h-290v-93h249v-117h-249v-103h298z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 498,
    d: "M250 -6q-55 0 -96.5 20.5t-69 52t-41.5 70.5t-14 75q0 39 15.5 78t44 70t69.5 50.5t92 19.5q54 0 95 -21t68.5 -53t41.5 -70.5t14 -73.5q0 -39 -15 -78t-43.5 -70t-69 -50.5t-91.5 -19.5zM125 212q0 -22 7.5 -44t23 -40t39 -29.5t55.5 -11.5t55.5 12t38.5 31t22.5 40.5 t7.5 41.5q0 22 -8 44t-23.5 40t-39 29.5t-53.5 11.5q-33 0 -56.5 -12t-39 -30.5t-22.5 -40.5t-7 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 707,
    d: "M353 -10q-78 0 -136.5 34t-98 86.5t-59.5 116t-20 123.5q0 64 22 128.5t62.5 116t98.5 83.5t131 32q78 0 137 -34.5t98.5 -87.5t59.5 -116.5t20 -121.5q0 -65 -22 -129t-62.5 -115.5t-99 -83.5t-131.5 -32zM205 350q0 -38 9 -76t27 -68.5t46 -50t66 -19.5q40 0 68.5 21 t46.5 52.5t26 69t8 71.5q0 37 -9 75.5t-27.5 69t-46.5 50t-66 19.5q-40 0 -68 -21t-46 -52.5t-26 -69t-8 -71.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 498,
    d: "M250 294q-55 0 -96.5 20.5t-69 52t-41.5 70.5t-14 75q0 39 15.5 78t44 70t69.5 50.5t92 19.5q54 0 95 -21t68.5 -53t41.5 -70.5t14 -73.5q0 -39 -15 -78t-43.5 -70t-69 -50.5t-91.5 -19.5zM125 512q0 -22 7.5 -44t23 -40t39 -29.5t55.5 -11.5t55.5 12t38.5 31t22.5 40.5 t7.5 41.5q0 22 -8 44t-23.5 40t-39 29.5t-53.5 11.5q-33 0 -56.5 -12t-39 -30.5t-22.5 -40.5t-7 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 557,
    d: "M543 438h-192v-438h-144v438h-192v125h528v-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 403,
    d: "M209 280q36 0 66.5 -10t53 -28.5t35.5 -44t13 -56.5q0 -32 -14 -59t-39 -46.5t-60 -30.5t-76 -11q-54 0 -98 19t-67 51l54 64q20 -20 50 -32t67 -12t62.5 15t25.5 47q0 17 -7.5 29.5t-19 20.5t-25.5 11.5t-27 3.5q-25 0 -50 -12t-36 -32h-82q6 31 14 65t16.5 68.5t16 68 t12.5 62.5h250v-93h-182l-21 -71q9 5 26 9t42 4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 575,
    d: "M303 462q51 0 94 -17t74.5 -47t49 -72t17.5 -93q0 -54 -20 -98.5t-55.5 -76.5t-85 -49.5t-107.5 -17.5q-78 0 -140 31t-95 87l90 99q28 -35 67 -56t79 -21q46 0 74.5 26.5t28.5 71.5q0 43 -26.5 69.5t-67.5 26.5q-27 0 -50.5 -12t-36.5 -34h-139q0 1 4 20.5t9.5 50.5 t13 69.5t15.5 78.5q18 94 41 213h353v-146h-237l-21 -121q7 7 24.5 12.5t46.5 5.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 654,
    d: "M327 123q37 0 62 13t40 34t21.5 48t6.5 56v289h143v-289q0 -59 -16 -109.5t-49.5 -88.5t-85 -59.5t-122.5 -21.5q-74 0 -125.5 23t-84.5 61t-48 88.5t-15 106.5v289h144v-289q0 -30 7 -57t22 -48t39.5 -33.5t60.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 591,
    d: "M305 1v149h-279v143l330 418h109v-418h88v-143h-88v-149h-160zM185 293h138v178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 602,
    d: "M574 144q0 -37 -17 -64t-45.5 -45t-67 -26.5t-81.5 -8.5h-301v563h344q33 0 59 -12.5t44 -33t28 -46.5t10 -53q0 -39 -22 -75.5t-66 -53.5q53 -14 84 -50t31 -95zM428 174q0 23 -16.5 38.5t-42.5 15.5h-163v-107h157q27 0 46 14.5t19 38.5zM206 440v-99h139q24 0 42 11 t18 39q0 26 -16 37.5t-39 11.5h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 420,
    d: "M238 301v88h-218v91l247 251h64v-251h62v-91h-62v-88h-93zM108 480h134v138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    horizAdvX: 597,
    d: "M150 563l150 -360l148 360h151l-239 -563h-121l-241 563h152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 1128,
    d: "M1123 711l-221 -710h-170l-169 441l-167 -442h-170l-221 710h186l137 -463l145 463h179l148 -462l136 463h187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 444,
    d: "M40 143q9 -5 38 -14.5t67 -9.5q33 0 52.5 9t30 28t14 49t3.5 72v286h143v-286q0 -65 -7.5 -117.5t-32.5 -90t-73.5 -58t-129.5 -20.5q-79 0 -137 35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 937,
    d: "M271 562h133l64 -176l64 176h133l-106 -265l59 -124l166 390h157l-252 -563h-120l-101 210l-100 -210h-121l-251 563h156l167 -390l56 124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 270,
    d: "M55 517h160v-730h-160v730zM55 728h159v-143h-159v143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 607,
    d: "M62 0v563h144v-241l244 241h150l-236 -251l251 -312h-151l-186 231l-72 -63v-168h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 585,
    d: "M154 563l139 -185l138 185h156l-219 -285l212 -278h-156l-131 177l-131 -177h-157l212 278l-219 285h156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 593,
    d: "M27 286q0 52 20.5 102t59.5 89.5t95 64t127 24.5q85 0 147.5 -33.5t91.5 -89.5l-110 -78q-10 21 -25 35.5t-33 22.5t-37 11.5t-37 3.5q-39 0 -67.5 -14t-47.5 -36t-28.5 -50t-9.5 -56q0 -32 11 -60.5t31 -50.5t49 -35t64 -13q18 0 37.5 4t37 12.5t32 22.5t23.5 34 l118 -70q-14 -32 -41 -56t-61.5 -41t-73.5 -25.5t-76 -8.5q-65 0 -119.5 25t-94 66.5t-61.5 93.5t-22 106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 583,
    d: "M154 563l137 -250l139 250h156l-223 -374v-189h-144v190l-221 373h156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 272,
    d: "M56 730h160v-730h-160v730z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 482,
    d: "M62 0v563h144v-438h268v-125h-412z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 565,
    d: "M31 107l329 331h-317v125h484v-107l-315 -331h318v-125h-499v107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 432,
    d: "M27 283q0 31 14 59t39 48t59.5 32t74.5 12q86 0 136 -54t50 -154q0 -110 -52.5 -171t-145.5 -61q-47 0 -87.5 16t-67.5 46l53 65q17 -18 45 -28.5t60 -10.5q49 0 78.5 23.5t30.5 66.5q-15 -16 -46 -24t-60 -8q-40 0 -73 11t-57 30t-37.5 45.5t-13.5 56.5zM212 348 q-20 0 -37 -5t-30.5 -14t-21 -21t-7.5 -25q0 -26 28.5 -43.5t68.5 -17.5t68.5 17.5t28.5 43.5q0 13 -8 25t-21.5 21t-31 14t-37.5 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 607,
    d: "M38 467q0 52 20 97.5t55 79t83.5 53t104.5 19.5q62 0 111 -23t83 -66t52 -106t18 -142q0 -93 -19.5 -165.5t-56 -122t-88.5 -75.5t-116 -26q-66 0 -123 27t-100 78l90 102q26 -32 61 -50t74 -18q59 0 93.5 42t36.5 119q-20 -28 -53.5 -43t-76.5 -15q-53 0 -98.5 18 t-79 49.5t-52.5 74.5t-19 93zM301 581q-22 0 -42 -9t-35 -24.5t-24 -36.5t-9 -44t8.5 -42.5t23.5 -34t35 -23t43 -8.5q22 0 42 8.5t35 23t24 34t9 42.5t-9 44t-24 36.5t-35 24.5t-42 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 641,
    d: "M273 -10q-54 0 -99.5 20.5t-78.5 57.5t-51.5 86.5t-18.5 108.5q0 57 17.5 107t48.5 86.5t73.5 57.5t92.5 21q56 0 100.5 -26t68.5 -70v79h160v-518h-159v78q-24 -43 -61.5 -65.5t-92.5 -22.5zM427 307q-17 42 -49 67t-70 25q-26 0 -47.5 -11.5t-37 -31t-24.5 -44.5 t-9 -52q0 -29 9.5 -53.5t26 -42.5t39.5 -28.5t50 -10.5q37 0 64.5 19.5t47.5 53.5v109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 432,
    d: "M27 579q0 32 14 59.5t39 48t59 32t74 11.5q87 0 137 -54t50 -153q0 -111 -53 -172t-146 -61q-47 0 -87 16t-68 47l54 64q17 -18 45 -28.5t60 -10.5q48 0 77.5 24t31.5 66q-16 -15 -46.5 -23t-59.5 -8q-40 0 -73 11t-57 30t-37.5 45t-13.5 56zM212 644q-20 0 -37.5 -5 t-30.5 -14t-20.5 -21t-7.5 -25q0 -25 28.5 -43t68.5 -18t68 18t28 43q0 13 -7.5 25t-21 21t-31 14t-37.5 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 574,
    d: "M371 0v69q-28 -39 -70.5 -59t-96.5 -20q-39 0 -72.5 12.5t-57.5 35t-38 53t-14 66.5q0 40 17.5 72.5t48 55t71.5 35t88 12.5q37 0 67.5 -6t50.5 -16v24q0 91 -105 91q-43 0 -82 -14.5t-82 -43.5l-47 100q51 33 106.5 50.5t120.5 17.5q120 0 184.5 -57t64.5 -163v-315 h-154zM342 138q23 18 23 38v50q-21 8 -45.5 12.5t-45.5 4.5q-40 0 -70.5 -19t-30.5 -53q0 -29 22.5 -47.5t55.5 -18.5q24 0 49 8.5t42 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 765,
    d: "M559 0v314l-138 -224h-77l-138 224v-314h-144v563h156l165 -278l164 278h156v-563h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 675,
    d: "M206 297v-297h-144v563h112l295 -306v306h144v-563h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 350,
    d: "M333 91v-91h-285v91h99v243q-6 -7 -19.5 -16t-30 -17t-34 -13.5t-32.5 -5.5v93q19 0 39.5 9t37.5 19.5t28 20t11 10.5h94v-343h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 518,
    d: "M496 144v-144h-431v144h141v415q-8 -12 -27 -26.5t-43 -28t-49 -22.5t-45 -9v147q27 0 55.5 14.5t52.5 32t39.5 32.5t16.5 17h163v-572h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 509,
    d: "M62 0v563h426v-125h-282v-106h234v-117h-234v-215h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 654,
    d: "M326 -5q-67 0 -122 24.5t-94.5 64.5t-61 92t-21.5 106q0 56 22.5 107.5t63 90.5t96 62.5t120.5 23.5q67 0 122 -24.5t94 -65t60.5 -92t21.5 -105.5q0 -55 -22.5 -106.5t-62 -91t-95 -63t-121.5 -23.5zM173 281q0 -30 10 -58.5t30 -50.5t48.5 -35.5t66.5 -13.5t66.5 14 t48 36.5t29 51t9.5 57.5q0 30 -10.5 58.5t-30 50t-48 34.5t-65.5 13q-38 0 -66.5 -13.5t-48 -35.5t-29.5 -50.5t-10 -57.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    horizAdvX: 640,
    d: "M253 -10q-50 0 -91.5 21t-71.5 58t-47 87t-17 108q0 57 18.5 106.5t51 86t77 57.5t97.5 21q60 0 103.5 -26t72.5 -70v86h139v-739h-160v299q-54 -95 -172 -95zM314 125q35 0 63 19.5t48 51.5v111q-6 19 -18 36t-28 29.5t-34 19.5t-36 7q-26 0 -48 -11.5t-38 -30.5 t-25 -44t-9 -53q0 -59 34.5 -97t90.5 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 717,
    d: "M381 -5q-78 0 -143 30.5t-112 81t-73 116.5t-26 137q0 68 24 132t69 113.5t109.5 79.5t145.5 30q92 0 161.5 -38.5t110.5 -108.5l-130 -102q-6 10 -17.5 27.5t-29.5 34t-44 29t-60 12.5q-42 0 -74.5 -18.5t-54 -48.5t-32.5 -68.5t-11 -78.5q0 -37 10 -75t31 -69 t53.5 -50.5t76.5 -19.5q28 0 53 8.5t45 22.5t34 32t21 38h-134v144h312v-73q0 -64 -23 -122t-64.5 -101.5t-99.5 -69t-128 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 972,
    d: "M965 28q-33 -14 -75 -26t-86 -12q-30 0 -56.5 7.5t-46.5 24t-31.5 43.5t-11.5 65v274h-67v121h67q0 35 -3 61.5t-11 44t-23.5 26t-40.5 8.5q-45 0 -63 -26t-18 -64q0 -23 6 -49t14 -50t17.5 -45t15.5 -35l-156 -47q-32 50 -92 50q-26 0 -47 -10.5t-36.5 -28.5t-24 -43 t-8.5 -55t9 -55.5t25 -43.5t37.5 -28t45.5 -10q28 0 53.5 13.5t38.5 38.5l156 -48q-30 -63 -94 -101t-153 -38q-67 0 -119.5 22.5t-88.5 60t-55 87t-19 103.5q0 53 18.5 102.5t54.5 87t89.5 60t123.5 22.5q48 0 80 -10t64 -29q-9 22 -15 44t-6 44q0 72 49 111t146 39 q71 0 109.5 -18.5t56.5 -48.5t21 -67.5t3 -74.5h107v-121h-107v-219q0 -26 13 -37.5t33 -11.5q18 0 37 6t34 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 621,
    d: "M463 50q-34 -29 -70.5 -41.5t-79.5 -12.5q-59 0 -111 23.5t-91 63.5t-61.5 92.5t-22.5 110.5q0 59 23 110t63 89t94.5 60t117.5 22q82 0 143.5 -33t92.5 -90l-108 -81q-19 35 -55.5 55.5t-78.5 20.5q-32 0 -59 -12t-46.5 -33t-30 -50t-10.5 -63q0 -35 11.5 -63.5 t31.5 -49.5t48 -32.5t61 -11.5q38 0 73 16.5t65 48.5v5h-120v103h240v-297h-120v50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 402,
    d: "M259 338h-235v93h380l-253 -430h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 579,
    d: "M333 565h-298v146h550l-350 -710h-181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 432,
    d: "M405 144q0 -31 -14 -58.5t-39 -47.5t-59.5 -32t-74.5 -12q-86 0 -136 53.5t-50 153.5q0 111 53 172t146 61q47 0 87 -16t67 -46l-53 -65q-17 18 -45 28t-60 10q-49 0 -78 -23t-31 -66q16 16 46.5 23.5t58.5 7.5q40 0 73.5 -11t57.5 -30t37.5 -45.5t13.5 -56.5zM220 80 q20 0 37.5 5t31 14t21 20.5t7.5 24.5q0 26 -28.5 44t-68.5 18q-20 0 -38 -5t-31.5 -13t-21 -19.5t-7.5 -24.5t8 -24.5t21.5 -20.5t31 -14t37.5 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    horizAdvX: 608,
    d: "M569 239q0 -52 -20 -97.5t-55 -79t-83 -53t-104 -19.5q-62 0 -111 23t-83 66t-52 105.5t-18 142.5q0 93 19.5 165.5t55.5 122t88 75.5t117 26q66 0 122.5 -27t99.5 -78l-90 -102q-25 32 -60 50t-75 18q-59 0 -93.5 -42t-36.5 -119q20 27 53.5 42t77.5 15q53 0 98.5 -18 t78.5 -49.5t52 -74t19 -92.5zM307 125q22 0 42 9t35 24.5t24 36.5t9 44q0 22 -9 42t-24 34.5t-35 23t-42 8.5q-23 0 -43 -8.5t-35 -23t-23.5 -34.5t-8.5 -42q0 -23 9 -44t24 -36.5t35 -24.5t42 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 432,
    d: "M405 440q0 -31 -14.5 -58.5t-39.5 -47.5t-59 -32t-74 -12q-87 0 -136.5 54t-49.5 153q0 111 53 172t146 61q46 0 86.5 -15.5t67.5 -46.5l-54 -65q-16 18 -44 28t-60 10q-49 0 -78.5 -23t-30.5 -66q16 16 46 23.5t59 7.5q40 0 73.5 -11t57.5 -30t37.5 -45.5t13.5 -56.5z M220 376q19 0 37 5t31 14t21 20.5t8 24.5q0 26 -28.5 44t-68.5 18q-42 0 -70 -18t-28 -44t29 -45t69 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 639,
    d: "M62 0v563h234q78 0 136.5 -22t98 -60t59.5 -89t20 -109q0 -64 -22.5 -116.5t-63.5 -89.5t-99 -57t-129 -20h-234zM464 283q0 69 -44 112t-124 43h-90v-313h90q40 0 71.5 12t53 33t32.5 50t11 63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 403,
    d: "M105 0v381h-79v144h79v167h164v-167h121v-144h-121v-381h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 586,
    d: "M268 -9q-84 0 -142.5 32.5t-87.5 95.5l83 109q3 -9 12.5 -24t26.5 -29.5t43 -25.5t62 -11q22 0 42 5t35.5 14.5t24.5 24t9 33.5q0 46 -50.5 66t-144.5 20h-33v133h33q37 0 69 4.5t56 14.5t38 25.5t14 37.5q0 18 -8.5 30.5t-20.5 19.5t-26 10t-25 3q-30 0 -53 -7 t-40.5 -18t-30 -24t-19.5 -25l-102 118q18 23 45.5 41t60 30t68 18.5t70.5 6.5q54 0 100.5 -15t80 -41t52.5 -61.5t19 -77.5q0 -59 -36 -97t-95 -51q33 -6 60 -22.5t46 -41t29 -55t10 -63.5q0 -53 -24.5 -91.5t-63.5 -63.5t-88 -36.5t-99 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    horizAdvX: 640,
    d: "M426 0v76q-49 -86 -153 -86q-54 0 -99.5 20.5t-78.5 57.5t-51.5 86.5t-18.5 108.5q0 57 17 107t48 86.5t73.5 57.5t92.5 21q56 0 100 -26t69 -70v291h160v-730h-159zM426 308q-15 41 -49 66t-70 25q-26 0 -47 -11.5t-37 -30.5t-24.5 -44.5t-8.5 -52.5q0 -29 9.5 -54 t26 -43t39.5 -28t50 -10q35 0 65 19.5t46 53.5v110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 619,
    d: "M39 0q0 69 7.5 121t28 91t55 68.5t88.5 55.5q32 15 62 30t53.5 33.5t38 41.5t14.5 53q0 41 -24 61.5t-62 20.5q-24 0 -47 -7t-43.5 -18.5t-38.5 -25.5t-31 -28l-100 106q16 19 43 39t63 37t80.5 28t95.5 11q119 0 182.5 -59.5t63.5 -162.5q0 -44 -12 -76.5t-33 -58 t-50 -45t-64 -37.5q-31 -16 -57.5 -31t-46 -31t-30.5 -34t-11 -39h305v-144h-530z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 596,
    d: "M-3 0l243 563h117l241 -563h-152l-50 118h-197l-48 -118h-154zM298 389l-68 -146h134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 556,
    d: "M62 0v563h268q45 0 83 -17t65 -44t42.5 -61.5t15.5 -70.5q0 -37 -14.5 -72t-41 -62t-63.5 -43.5t-82 -16.5h-129v-176h-144zM206 302h120q26 0 45 16t19 52q0 37 -21.5 52.5t-47.5 15.5h-115v-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    horizAdvX: 613,
    d: "M405 0v81q-28 -48 -77.5 -69.5t-103.5 -21.5q-92 0 -133 51.5t-41 147.5v336h160v-301q0 -45 17.5 -72t59.5 -27q29 0 58.5 18t52.5 58v324h160v-525h-153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 664,
    d: "M602 563v-563h-143v225h-253v-225h-144v563h144v-212h253v212h143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 655,
    d: "M479 35q-33 -19 -71.5 -29t-81.5 -10q-67 0 -122 24.5t-94.5 64.5t-61 91.5t-21.5 105.5q0 56 22.5 107.5t63 91t96 63t120.5 23.5q67 0 122 -25t94 -65.5t60.5 -92t21.5 -105.5q0 -51 -18.5 -98t-53.5 -85l93 -96h-135zM328 124q31 0 55 9l-94 98h137l32 -34 q23 38 23 85q0 30 -10.5 58.5t-30 50.5t-48 35t-65.5 13q-38 0 -66.5 -13.5t-48 -36t-29.5 -51t-10 -57.5q0 -30 10 -58.5t30 -50.5t48.5 -35t66.5 -13z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0394",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "#",
    u2: "4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "Y.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "V.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "T.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "four.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0431",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0424",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0259",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "(",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u044F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0434",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0414",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0410",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0408",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0394",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u018F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "two.lnum",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "three.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "one.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "U.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0455",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0447",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0437",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0436",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0434",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0431",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0430",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0424",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0414",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0410",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0408",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0394",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0259",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0129",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 247
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xF7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xF7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xF7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "+",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xF7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xD7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "=",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "+",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    g2: "seven.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "T.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "A.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "J.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0166",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "x",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0131",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012B",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Z.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "X.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "W.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "V.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "U.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "T.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "w.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "f_f_l",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "f_f_i",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "f_f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xDF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "@",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "3",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "2",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "&",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0104",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0166",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0259",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0165",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0159",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "Y.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xAE",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xA9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: " ",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0131",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u04B1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u04B0",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u044A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0447",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0442",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u042A",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0427",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0424",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0422",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0416",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0135",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEE",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u0135",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    g2: "four.lnum",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "one.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "A.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "t.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "l.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "X.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "U.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "T.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "y.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "w.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "S.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0259",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u018F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0142",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0141",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u012F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0126",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0110",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xD0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC8",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC9",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCA",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCB",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "one.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "3",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0108",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0112",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0114",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0116",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\u01FC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xC6",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011A",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "A.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "d.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "a.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0121",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xF0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "q",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "g",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "d",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u201D",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2019",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "*",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u0104",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0166",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0166",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0166",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\u01FC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xC6",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015C",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -126
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "H.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "P.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "D.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "F.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "N.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "M.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Z.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "L.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "X.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "K.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "B.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "U.sc",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "E.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "w.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "I.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "R.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_l",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_i",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1ECC",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FA",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01F4",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014E",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0108",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0104",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0102",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0100",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC5",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC3",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC2",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC1",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC0",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xA9",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "y",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "w",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "u",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "r",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "n",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "m",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "f",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "A",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "/",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FC",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0218",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03C0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\\\\\\\\",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "?",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "*",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BC",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C0",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0442",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0427",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0425",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0414",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\\\\\\\\",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "*",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u042A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0425",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0422",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0447",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0445",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0442",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0422",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0414",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0410",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0455",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0437",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0436",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0408",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0442",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u042A",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0422",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B0",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0455",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0442",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042A",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0427",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0424",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0422",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0405",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\\\\\\\\",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "*",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044A",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0445",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0442",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0425",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0414",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0410",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "?",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0436",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0434",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u042A",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0425",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0414",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0458",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044A",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0447",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0442",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0431",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0424",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0436",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0434",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u042A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0425",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0422",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0434",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0425",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0417",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0416",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0414",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0410",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0408",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "/",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0434",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0425",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0422",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0417",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0455",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044F",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044D",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044A",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0447",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0445",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0442",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0437",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0436",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0434",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0431",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0430",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042F",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0424",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0414",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0410",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0408",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "/",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0434",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0422",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0417",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0416",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0414",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0410",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0408",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\\\\\\\\",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044A",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0447",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0442",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0431",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u042D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0424",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0458",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0458",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u04B1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u044A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0442",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04B1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0442",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0437",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0436",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0434",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "?",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0442",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\\\\\\\\",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u044A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0442",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0434",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\\\\\\\\",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "?",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0434",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0431",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0430",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u0458",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0434",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "*",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\\\\\\\\",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0458",
    u2: "\u0458",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u04B1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044F",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044D",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0447",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0445",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0442",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0437",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0436",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0434",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0431",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0430",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u042F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0424",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0414",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0410",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u044F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u044D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0434",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0431",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB8",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBC",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "four.denominator",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "seven.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "seven.lnum",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "one.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0135",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "X.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "seven.lnum",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "one.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "@",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\\\\\\\\",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Z.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "U.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0159",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xAE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "?",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAE",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA9",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "seven.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "four.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "zero.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xB0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "+",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u2122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "seven.lnum",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "=",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lnum",
    g2: "seven.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0259",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xF0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "four.lnum",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    u2: "\xF7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    u2: "+",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "?",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "AE,AEacute",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "zero",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "three",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "nine",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0394",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotleft,guilsinglleft",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotright,guilsinglright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0408",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0410",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0430",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0414",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0409,uni041B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni043B,uni0459",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0409,uni041B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni043B,uni0459",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quotedbl,quotesingle",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "four",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0394",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0408",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "two",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T.sc",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one.lnum",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven.lnum",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0416",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0422",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni040E,uni0423",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0425",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0427",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni042A",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0402,uni040B",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0436",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0437",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0442",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0443,uni045E",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0445",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni044A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni04B0",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni04B1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0422",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni040E,uni0423",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0427",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni042A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0402,uni040B",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0442",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0443,uni045E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0447",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni044A",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni04B0",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni04B1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Schwa",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0404,uni041E,uni0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0424",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0409,uni041B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni043B,uni0459",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0443,uni045E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0404,uni041E,uni0421",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni03A9,Omega",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "AE,AEacute",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "AE,AEacute",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni042A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni0402,uni040B",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni04B0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0409,uni041B",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0402,uni040B",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0443,uni045E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0404,uni041E,uni0421",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "J,Jcircumflex",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0394",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0408",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0410",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0414",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0409,uni041B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni043B,uni0459",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "Schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotright,guilsinglright",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0408",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0410",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0414",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0409,uni041B",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0434",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni043B,uni0459",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0455",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "Schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0404,uni041E,uni0421",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni043B,uni0459",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0422",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni040E,uni0423",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni042A",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0402,uni040B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0442",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni044A",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni04B0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J,Jcircumflex",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0394",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0408",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0409,uni041B",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0434",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni043B,uni0459",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0416",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0422",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni040E,uni0423",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0427",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni042A",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0402,uni040B",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0436",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0437",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0442",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0443,uni045E",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0445",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044A",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni04B0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni04B1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "pi",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni042F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0404,uni041E,uni0421",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "at",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "seven",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "question",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "J.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "four",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotleft,guilsinglleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "seven",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Y.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "colon,semicolon",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "AE,AEacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "T.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "eth",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "seven",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Schwa",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 159
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "four",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "seven",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "x",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "ordfeminine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "three",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "one",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "two",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "seven",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "v",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "x",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w.alt",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y.alt",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Z.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "six",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "copyright",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "registered",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "U.sc",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "colon,semicolon",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "ampersand",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eight",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "four",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "X.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Y.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "zero",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "copyright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "registered",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "U.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteleft,quotedblleft",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "J,Jcircumflex",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "question",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bracketright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "question",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "at",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "eth",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotleft,guilsinglleft",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotright,guilsinglright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "eth",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "schwa",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "AE,AEacute",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "question",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "J,Jcircumflex",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "at",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "at",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "at",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "J,Jcircumflex",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "AE,AEacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotright,guilsinglright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quotedbl,quotesingle",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quoteright,quotedblright",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "guillemotleft,guilsinglleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "uni03A9,Omega",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A9,Omega",
    g2: "uni0394",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A9,Omega",
    g2: "backslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "pi",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "pi",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotright,guilsinglright",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotright,guilsinglright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotright,guilsinglright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotright,guilsinglright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotright,guilsinglright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J,Jcircumflex",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteleft,quotedblleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "question",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J,Jcircumflex",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni0409,uni041B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni043B,uni0459",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quotedbl,quotesingle",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni040E,uni0423",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0402,uni040B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0443,uni045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteleft,quotedblleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni040E,uni0423",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0402,uni040B",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0443,uni045E",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0404,uni041E,uni0421",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0409,uni041B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni040E,uni0423",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0443,uni045E",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0409,uni041B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni043B,uni0459",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni040E,uni0423",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0402,uni040B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0443,uni045E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "guillemotleft,guilsinglleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0455",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0442",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0443,uni045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni04B1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0404,uni041E,uni0421",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0424",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni042D",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0405",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0417",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0443,uni045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0404,uni041E,uni0421",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "slash",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "guillemotleft,guilsinglleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0442",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0443,uni045E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0447",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni044A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni04B1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0404,uni041E,uni0421",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0431",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "slash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0408",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0410",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0409,uni041B",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0434",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni043B,uni0459",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0416",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0422",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni040E,uni0423",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0425",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0402,uni040B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0436",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni04B0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0417",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0409,uni041B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni043B,uni0459",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0421",
    g2: "uni0409,uni041B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0421",
    g2: "uni0404,uni041E,uni0421",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "guillemotleft,guilsinglleft",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "guillemotright,guilsinglright",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0409,uni041B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni043B,uni0459",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0443,uni045E",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0404,uni041E,uni0421",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "colon,semicolon",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "slash",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "guillemotleft,guilsinglleft",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "guillemotright,guilsinglright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0408",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0410",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0430",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0414",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0409,uni041B",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0434",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni043B,uni0459",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni044D",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni044F",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0455",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0436",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0437",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0443,uni045E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0445",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0447",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni04B1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0404,uni041E,uni0421",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0424",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0431",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni042F",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "colon,semicolon",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni042D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0405",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0417",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "exclam",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0409,uni041B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni043B,uni0459",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni040E,uni0423",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0402,uni040B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0443,uni045E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0404,uni041E,uni0421",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quotedbl,quotesingle",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quoteright,quotedblright",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0409,uni041B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0422",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni040E,uni0423",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0425",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni042A",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0402,uni040B",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0442",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni044A",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni04B0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni04B1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quoteleft,quotedblleft",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "asterisk",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "question",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "backslash",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quotedbl,quotesingle",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteright,quotedblright",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0409,uni041B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni040E,uni0423",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0402,uni040B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0443,uni045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteleft,quotedblleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0404",
    g2: "uni0409,uni041B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0404",
    g2: "uni0404,uni041E,uni0421",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0409,uni041B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0443,uni045E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "slash",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "guillemotleft,guilsinglleft",
    k: 126
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "guillemotright,guilsinglright",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0408",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0410",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0430",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0414",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0409,uni041B",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0434",
    k: 183
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni043B,uni0459",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 189
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044D",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044F",
    k: 174
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0455",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0436",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0437",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0442",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0443,uni045E",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0445",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0447",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni04B1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0404,uni041E,uni0421",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0424",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0431",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni042F",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "colon,semicolon",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni042D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0443,uni045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0447",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni04B1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0404,uni041E,uni0421",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0456,uni0457,uni0458",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0409,uni041B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni043B,uni0459",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni040E,uni0423",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0402,uni040B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0443,uni045E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0455",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "guillemotright,guilsinglright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0409,uni041B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni043B,uni0459",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0443,uni045E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0404,uni041E,uni0421",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "colon,semicolon",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "uni043B,uni0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "uni0443,uni045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "uni043B,uni0459",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "slash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "guillemotleft,guilsinglleft",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "guillemotright,guilsinglright",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0434",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni043B,uni0459",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni044F",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0443,uni045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0447",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "question",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "backslash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0434",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni043B,uni0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0442",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni044A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni04B1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "backslash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "uni043B,uni0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "uni0443,uni045E",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0438,uni0439,uni043B,uni043C,uni043D,uni043F,uni0447,uni0448,uni044B,uni044F,uni045D,uni045F",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "guillemotleft,guilsinglleft",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0431",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "backslash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quoteright,quotedblright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0434",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni043B,uni0459",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0436",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0437",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0442",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0443,uni045E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0445",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044A",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni04B1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "question",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "backslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni0443,uni045E",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "guillemotleft,guilsinglleft",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "guillemotright,guilsinglright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni043B,uni0459",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "slash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0434",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni043B,uni0459",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni044D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni044F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0455",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0431",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quotedbl,quotesingle",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quoteright,quotedblright",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0442",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0443,uni045E",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0447",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni044A",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni04B1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quoteleft,quotedblleft",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "asterisk",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "question",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "backslash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quoteleft,quotedblleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni0443,uni045E",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "uni0443,uni045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quoteleft,quotedblleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "guillemotleft,guilsinglleft",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "uni043B,uni0459",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 19
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewayExtraBold);
export default __webpack_public_path__ + "static/media/Raleway-ExtraBold.2b6ad7724fea266fa3c996ffcfb71047.svg";
export { ForwardRef as ReactComponent };